var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWinterRoad(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.26,116.59h95.57S133.35,90.7,118.77,90.7s-19.15,17.87-19.15,17.87-9.84-9.71-17.93-9.71-15.11,12.83-15.11,12.83S55.16,104.79,47.26,116.59Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.71,68.36h44.67s-10-14.45-17.85-14.45-10.18,9.64-10.18,9.64-5.55-4.5-10.69-3.7S130.71,68.36,130.71,68.36Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.75,163.64h87s-11.91-26.6-24.65-28.26-18.84,19.77-18.84,19.77-8.22-7.58-14.69-7.58-11.45,10-11.45,10S370.18,150.71,365.75,163.64Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.92,56.93h58.77s-10.1-19.27-21.05-19.55S329.93,52,329.93,52,312.9,38.29,308.92,56.93Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.7,110.25h39.67s-6.82-13-14.21-13.2-11.28,9.84-11.28,9.84S267.38,97.67,264.7,110.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.93,224.66S186.4,165,172.24,165C162.58,165,42,224.66,42,224.66h253",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.62,176.79c.47.8,4.38-.74,7.32-.47s2.51,6.23,6.5,7c2.56.49,7.49-5.15,9.49-5.32s2.15,2,4.82,2.14,5-2.8,6.41-3,7.61,2.93,10.65,1.63,1.29-2.87,3.44-3.21,12,1.73,12.62.8S174.71,165,172.24,165C165.49,164.92,140.93,175.6,141.62,176.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.62,176.79c.24.29.66.22,1,.22s.7-.08,1-.14l2.09-.37a18.64,18.64,0,0,1,2.11-.23,3.27,3.27,0,0,1,2.06.38,4.44,4.44,0,0,1,1.29,1.68l.92,1.91a5.18,5.18,0,0,0,2.86,2.91,2.63,2.63,0,0,0,2-.16,11,11,0,0,0,1.82-1.05c1.16-.8,2.24-1.71,3.37-2.57a14.52,14.52,0,0,1,1.78-1.19,2.3,2.3,0,0,1,2.16-.11,20.57,20.57,0,0,1,1.71,1.28,3.51,3.51,0,0,0,1.91.6,6.62,6.62,0,0,0,3.75-1.51c.58-.4,1.13-.84,1.77-1.2a2.06,2.06,0,0,1,1.14-.32,6.19,6.19,0,0,1,1.09.21c1.38.38,2.71.83,4.07,1.17a12.17,12.17,0,0,0,4.08.46,4.14,4.14,0,0,0,1.83-.69,2.4,2.4,0,0,0,1.1-1.49,1.77,1.77,0,0,1,.72-1,2.89,2.89,0,0,1,1.17-.34,15.43,15.43,0,0,1,2.17.09c2.83.28,5.63.75,8.42.94a8.55,8.55,0,0,0,1,0,2.46,2.46,0,0,0,.44-.06s.09-.05.06,0a.33.33,0,0,0-.06.21.39.39,0,0,0,0,.11s0,0,0,0a11.72,11.72,0,0,0-1.77-1c-1.27-.59-2.58-1.13-3.88-1.67-2.61-1.06-5.25-2.07-7.9-3.07s-5.29-2-7.95-2.92-5.34-1.89-8.06-2.6a5,5,0,0,0-2.05,0,20.83,20.83,0,0,0-2.07.36c-1.38.3-2.74.68-4.09,1.08-2.71.82-5.38,1.76-8,2.78s-5.25,2.1-7.84,3.25c-1.29.58-2.57,1.17-3.83,1.81-.63.32-1.26.64-1.87,1a10.3,10.3,0,0,0-.9.55c-.15.1-.29.21-.43.32S141.58,176.6,141.62,176.79Zm0,0c0-.19.15-.32.26-.43s.28-.22.42-.32c.3-.2.6-.39.9-.56.61-.36,1.24-.69,1.87-1,1.26-.65,2.54-1.25,3.82-1.83q3.87-1.75,7.82-3.3c2.64-1,5.29-2,8-2.87,1.35-.43,2.71-.82,4.09-1.15.69-.16,1.39-.3,2.09-.4a5.81,5.81,0,0,1,2.16,0c2.77.67,5.45,1.59,8.14,2.47s5.35,1.83,8,2.78,5.3,2,7.93,3c1.32.53,2.63,1.07,3.93,1.66a11.43,11.43,0,0,1,1.95,1.06.92.92,0,0,1,.15.17.39.39,0,0,1,.08.23.45.45,0,0,1-.1.32.84.84,0,0,1-.4.24,2.42,2.42,0,0,1-.61.1,8.07,8.07,0,0,1-1.1,0c-2.87-.17-5.65-.7-8.44-1a16.22,16.22,0,0,0-2.06-.1,2.06,2.06,0,0,0-.86.23c-.22.12-.32.33-.44.68a3.16,3.16,0,0,1-1.38,1.81,4.86,4.86,0,0,1-2.12.78,12.37,12.37,0,0,1-4.3-.53c-1.38-.37-2.72-.85-4.06-1.24a6,6,0,0,0-1-.21,1.49,1.49,0,0,0-.87.25c-.59.31-1.16.75-1.75,1.14a7,7,0,0,1-4,1.52,4,4,0,0,1-2.08-.69,17.78,17.78,0,0,0-1.65-1.29,2,2,0,0,0-1.9.08,12.29,12.29,0,0,0-1.76,1.14c-1.14.83-2.24,1.72-3.43,2.51a10.88,10.88,0,0,1-1.86,1,2.74,2.74,0,0,1-2.1.14,5.22,5.22,0,0,1-2.9-3l-.91-1.91a4.5,4.5,0,0,0-1.26-1.66,3.23,3.23,0,0,0-2-.38,16.75,16.75,0,0,0-2.11.21l-2.09.35a9.41,9.41,0,0,1-1,.13C142.28,177,141.85,177.08,141.62,176.79Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.87,224.66s-86.46-39.92-97.56-39.88c-3,0-100.85,39.88-100.85,39.88H459.87",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.66,193.13c-.37.8-3.43-.74-5.74-.47s-2,6.24-5.1,7c-2,.5-5.88-5.15-7.45-5.32s-1.68,2-3.78,2.14-3.94-2.8-5-3-6,2.93-8.36,1.63-1-2.86-2.7-3.21-9.4,1.73-9.9.8,21.67-8.55,23.61-8.57C368.52,184.12,388.2,191.94,387.66,193.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.66,193.13c-.15.27-.51.24-.78.23a8.17,8.17,0,0,1-.84-.14l-1.67-.36a9.74,9.74,0,0,0-1.7-.2,1.92,1.92,0,0,0-1.57.45c-1.44,1.76-1.39,4.38-3.14,6a2.21,2.21,0,0,1-1.6.62,3.77,3.77,0,0,1-1.56-.75,26.39,26.39,0,0,1-2.57-2.27,12.71,12.71,0,0,0-2.58-2.15,1.2,1.2,0,0,0-.75,0,1.74,1.74,0,0,0-.65.41,11.77,11.77,0,0,1-1.22,1.23,2.73,2.73,0,0,1-1.73.51,3.71,3.71,0,0,1-1.69-.61c-1-.62-1.79-1.52-2.67-2.12a1.42,1.42,0,0,0-.33-.16.61.61,0,0,0-.3,0,4.89,4.89,0,0,0-.78.23l-1.58.64a16.66,16.66,0,0,1-3.32,1,4.84,4.84,0,0,1-1.82,0,2.85,2.85,0,0,1-.89-.35,4.73,4.73,0,0,1-.75-.54,3.17,3.17,0,0,1-.92-1.62c-.14-.6-.3-.82-.81-.93a6.3,6.3,0,0,0-1.6.07c-.56.06-1.12.15-1.68.24l-3.38.56c-.57.09-1.14.16-1.73.2a7,7,0,0,1-.91,0,1.51,1.51,0,0,1-.54-.13.62.62,0,0,1-.34-.38.46.46,0,0,1,.08-.4l.12-.14a8.29,8.29,0,0,1,1.59-.89c.53-.24,1.06-.46,1.59-.68,2.12-.86,4.26-1.65,6.42-2.42,4.32-1.48,8.64-2.94,13.08-4.09.28-.06.56-.12.86-.16a4.29,4.29,0,0,1,.88,0,16,16,0,0,1,1.71.27c1.12.23,2.23.52,3.33.84,2.19.64,4.35,1.39,6.49,2.16s4.28,1.61,6.37,2.52c1.05.45,2.09.91,3.12,1.42.51.25,1,.51,1.51.8q.38.21.72.45a2.24,2.24,0,0,1,.34.27C387.56,192.86,387.69,193,387.66,193.13Zm0,0c0-.15-.1-.26-.19-.36a2.78,2.78,0,0,0-.34-.26,6.81,6.81,0,0,0-.73-.45c-.49-.29-1-.54-1.51-.79-1-.5-2.08-1-3.13-1.4q-3.15-1.32-6.38-2.47c-2.15-.76-4.32-1.46-6.52-2.06-1.1-.3-2.2-.57-3.32-.78a16.1,16.1,0,0,0-1.68-.22,3.76,3.76,0,0,0-.82,0,8,8,0,0,0-.82.18c-4.38,1.24-8.67,2.81-13,4.37-2.14.78-4.27,1.59-6.37,2.46-.52.22-1,.45-1.55.69a7.48,7.48,0,0,0-1.39.77l0,0s0,0,0-.2-.06-.08,0-.09a.85.85,0,0,0,.29.06,5.21,5.21,0,0,0,.79,0c.55,0,1.11-.12,1.67-.19l3.38-.53c.57-.09,1.13-.18,1.71-.24a6.77,6.77,0,0,1,1.81,0,1.63,1.63,0,0,1,.94.51,2.14,2.14,0,0,1,.39.91,2.48,2.48,0,0,0,.72,1.32,3.2,3.2,0,0,0,1.33.74,4.41,4.41,0,0,0,1.58,0,17.12,17.12,0,0,0,3.22-.94l1.61-.61a5.4,5.4,0,0,1,.86-.24,1.11,1.11,0,0,1,.54,0,1.83,1.83,0,0,1,.44.23c1,.7,1.7,1.57,2.64,2.17a3.23,3.23,0,0,0,1.49.58,2.27,2.27,0,0,0,1.49-.41A10.17,10.17,0,0,0,368,194.7a1.57,1.57,0,0,1,1.73-.39,12.65,12.65,0,0,1,2.62,2.25,24.8,24.8,0,0,0,2.51,2.31,3.62,3.62,0,0,0,1.49.75,2.09,2.09,0,0,0,1.51-.58,7,7,0,0,0,1.68-2.9,9.62,9.62,0,0,1,1.49-3.07,1.51,1.51,0,0,1,.76-.42,4,4,0,0,1,.85,0,10.68,10.68,0,0,1,1.7.22l1.67.37a8.22,8.22,0,0,0,.84.15C387.15,193.37,387.51,193.4,387.66,193.13Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-44"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "36.15 224.66 89.61 224.42 143.07 224.33 250 224.16 356.93 224.33 410.39 224.42 463.85 224.66 410.39 224.91 356.93 225 250 225.16 143.07 225 89.61 224.91 36.15 224.66",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--trees-2--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.07,220.09c-.32.32-4.07.47-5.43.47s-5.11-.15-5.43-.47,4.22-25.21,5.43-25.21S325.39,219.77,325.07,220.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.15,213.75c-.93.35-4.36,1.75-5.1,2.16v-.47l2.49-1.45a29.82,29.82,0,0,0,2.67-1.59s0-.12,0-.09a22.12,22.12,0,0,0-2.61,1.44c-.85.5-1.68,1-2.51,1.52,0-1.19,0-2.39,0-3.58a29.25,29.25,0,0,0,3.91-2s0-.11,0-.09a28.48,28.48,0,0,0-3.88,1.91c0-.62,0-1.24,0-1.86,0-3.19,0-6.39-.12-9.59.81-.41,1.65-.77,2.46-1.18.05,0,0-.12,0-.1-.83.32-1.62.71-2.43,1.06,0-1.65-.11-3.29-.21-4.94a0,0,0,0,0-.08,0c-.11,3.06-.11,6.12-.07,9.18-.84-.67-1.74-1.26-2.59-1.91,0,0-.07,0,0,.05.9.68,1.74,1.44,2.64,2.12v.52c-.91-.42-1.84-.81-2.76-1.2-.07,0-.14.07-.06.1.94.46,1.87.91,2.83,1.34l.06,4.55c0,2.65.1,5.3.15,7.94q-2.58-1.31-5.21-2.54a.06.06,0,0,0-.05.1,54.07,54.07,0,0,0,5.27,2.65c0,2.2.09,4.4.12,6.6a.11.11,0,0,0,.21,0c0-2.81,0-5.61-.05-8.42a49.32,49.32,0,0,0,5.16-2.1C325.29,213.86,325.23,213.72,325.15,213.75Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.46,201.88c.54.61,1.23.13,1.49-.48s.86-1.17,1.22-1,.65,1.06,1.49.91-.08-1.59-.27-2.16.42-.52,0-1.59a13.44,13.44,0,0,0-1.26-2.34c-.33-.53-.6-.78-1.1.36s-.78,3.23-1,3.61S317,201.36,317.46,201.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.46,201.88a.76.76,0,0,0,.55.28.86.86,0,0,0,.57-.25c.33-.29.4-.75.7-1.07a1.54,1.54,0,0,1,.49-.42.48.48,0,0,1,.61.14c.28.31.55.69,1,.73.19,0,.43,0,.52-.14a.66.66,0,0,0,0-.55,8.39,8.39,0,0,0-.5-1.17.82.82,0,0,1-.08-.69,1,1,0,0,0,.12-.57A4.17,4.17,0,0,0,321,197a12,12,0,0,0-.61-1.11c-.23-.33-.43-.81-.69-1-.1-.05-.26.14-.36.3a4.25,4.25,0,0,0-.29.56,9.5,9.5,0,0,0-.39,1.21l-.31,1.24a4.22,4.22,0,0,1-.41,1.21,7.18,7.18,0,0,0-.47,1.19A1.57,1.57,0,0,0,317.46,201.88Zm0,0a1.59,1.59,0,0,1,0-1.25,8.67,8.67,0,0,1,.45-1.2,3.55,3.55,0,0,0,.37-1.21l.26-1.26a11.58,11.58,0,0,1,.36-1.24,4.53,4.53,0,0,1,.28-.59,1.31,1.31,0,0,1,.2-.28.38.38,0,0,1,.39-.12c.28.12.36.33.49.51l.34.54a9.58,9.58,0,0,1,.63,1.13,4.15,4.15,0,0,1,.44,1.24,1.23,1.23,0,0,1-.16.67c-.08.16,0,.33.08.53a9.06,9.06,0,0,1,.47,1.2.88.88,0,0,1-.05.69.69.69,0,0,1-.66.17c-.48-.07-.74-.49-1-.79a.4.4,0,0,0-.53-.15,1.54,1.54,0,0,0-.49.39c-.29.31-.37.78-.71,1.06a.9.9,0,0,1-.58.25A.81.81,0,0,1,317.46,201.88Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.61,220.09c-.32.32-4.07.47-5.43.47s-5.11-.15-5.43-.47,4.21-25.21,5.43-25.21S457.93,219.77,457.61,220.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.68,213.75c-.92.35-4.35,1.75-5.09,2.16v-.47c.82-.49,1.65-1,2.48-1.45a30,30,0,0,0,2.68-1.59s0-.12,0-.09a23.08,23.08,0,0,0-2.62,1.44c-.84.5-1.67,1-2.5,1.52,0-1.19,0-2.39,0-3.58a29.25,29.25,0,0,0,3.91-2s0-.11,0-.09a28.37,28.37,0,0,0-3.87,1.91c0-.62,0-1.24,0-1.86,0-3.19,0-6.39-.12-9.59.81-.41,1.65-.77,2.46-1.18.05,0,0-.12,0-.1-.83.32-1.62.71-2.43,1.06,0-1.65-.11-3.29-.21-4.94a0,0,0,0,0-.08,0c-.12,3.06-.11,6.12-.07,9.18-.84-.67-1.74-1.26-2.6-1.91,0,0-.06,0,0,.05.9.68,1.74,1.44,2.63,2.12,0,.17,0,.34,0,.52-.91-.42-1.84-.81-2.76-1.2-.07,0-.14.07-.06.1.94.46,1.87.91,2.82,1.34,0,1.52.05,3,.07,4.55q.06,4,.15,7.94-2.58-1.31-5.21-2.54c-.06,0-.12.06-.06.1a55.22,55.22,0,0,0,5.27,2.65c.05,2.2.1,4.4.12,6.6,0,.13.21.13.21,0,0-2.81,0-5.61,0-8.42a49.32,49.32,0,0,0,5.16-2.1C457.83,213.86,457.77,213.72,457.68,213.75Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450,201.88c.54.61,1.22.13,1.49-.48s.85-1.17,1.22-1,.65,1.06,1.49.91-.08-1.59-.28-2.16.43-.52,0-1.59a14.15,14.15,0,0,0-1.26-2.34c-.33-.53-.6-.78-1.11.36s-.77,3.23-1,3.61S449.55,201.36,450,201.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450,201.88a.76.76,0,0,0,.55.28.88.88,0,0,0,.57-.25c.33-.29.4-.75.69-1.07a1.7,1.7,0,0,1,.5-.42.47.47,0,0,1,.6.14c.29.31.56.69,1,.73.19,0,.44,0,.53-.14a.7.7,0,0,0,0-.55,11.74,11.74,0,0,0-.5-1.17.82.82,0,0,1-.09-.69,1,1,0,0,0,.13-.57,4.51,4.51,0,0,0-.42-1.16,12,12,0,0,0-.61-1.11c-.23-.33-.43-.81-.69-1s-.27.14-.37.3a5.85,5.85,0,0,0-.28.56,8.44,8.44,0,0,0-.4,1.2l-.3,1.25a4,4,0,0,1-.42,1.21,8.14,8.14,0,0,0-.46,1.19A1.57,1.57,0,0,0,450,201.88Zm0,0a1.59,1.59,0,0,1,0-1.25,7.56,7.56,0,0,1,.45-1.2,3.79,3.79,0,0,0,.37-1.21l.26-1.26a9.65,9.65,0,0,1,.36-1.24,4.53,4.53,0,0,1,.28-.59,1.31,1.31,0,0,1,.2-.28.37.37,0,0,1,.39-.12,1.11,1.11,0,0,1,.48.51l.35.54a11.27,11.27,0,0,1,.63,1.13,4.14,4.14,0,0,1,.43,1.24,1.23,1.23,0,0,1-.15.67c-.08.16,0,.33.07.53a9.1,9.1,0,0,1,.48,1.2.85.85,0,0,1-.06.69.67.67,0,0,1-.65.17c-.48-.07-.75-.49-1-.79a.41.41,0,0,0-.53-.15,1.54,1.54,0,0,0-.49.39c-.29.31-.37.78-.71,1.06a.9.9,0,0,1-.58.25A.79.79,0,0,1,450,201.88Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.51,220.72c-.28.28-3.49.4-4.66.4s-4.38-.12-4.66-.4,3.62-21.64,4.66-21.64S249.78,220.45,249.51,220.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.57,215.28c-.79.3-3.73,1.5-4.37,1.85v-.4l2.13-1.25a24,24,0,0,0,2.3-1.36s0-.1,0-.08a18.9,18.9,0,0,0-2.25,1.24c-.72.42-1.44.86-2.15,1.3,0-1,0-2.05,0-3.07a25.08,25.08,0,0,0,3.35-1.7s0-.09,0-.07a25,25,0,0,0-3.33,1.63c0-.53,0-1.06,0-1.59,0-2.74,0-5.49-.1-8.23.7-.35,1.41-.66,2.11-1,0,0,0-.1,0-.08-.71.28-1.39.6-2.09.91,0-1.42-.09-2.83-.17-4.24,0-.05-.08-.05-.08,0-.1,2.62-.09,5.25-.05,7.88-.73-.58-1.5-1.09-2.23-1.65,0,0-.06,0,0,.05.77.59,1.49,1.24,2.26,1.82v.44c-.78-.35-1.57-.69-2.37-1-.06,0-.11.07,0,.1.81.38,1.61.78,2.43,1.14,0,1.3,0,2.61,0,3.91,0,2.27.08,4.54.13,6.81q-2.22-1.11-4.47-2.18s-.1.06,0,.09a50.39,50.39,0,0,0,4.53,2.27c0,1.89.08,3.78.1,5.66a.09.09,0,1,0,.18,0c0-2.4,0-4.81,0-7.22a45.11,45.11,0,0,0,4.43-1.8A.07.07,0,0,0,249.57,215.28Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,205.09c.46.53,1.05.12,1.28-.41s.73-1,1-.83.56.91,1.28.78-.07-1.36-.23-1.85.36-.44,0-1.36a11.56,11.56,0,0,0-1.08-2c-.28-.46-.51-.66-.95.31s-.66,2.77-.85,3.09S242.59,204.65,243,205.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,205.09a.68.68,0,0,0,.47.24.7.7,0,0,0,.49-.22c.28-.24.34-.63.59-.91a1.26,1.26,0,0,1,.43-.36.4.4,0,0,1,.52.12c.25.27.48.58.83.62.16,0,.37,0,.44-.12a.59.59,0,0,0,0-.47,8.47,8.47,0,0,0-.43-1,.71.71,0,0,1-.07-.61.79.79,0,0,0,.1-.48,3.72,3.72,0,0,0-.36-1,9.81,9.81,0,0,0-.52-.95c-.19-.28-.38-.7-.59-.83-.06,0-.21.11-.29.25a3.58,3.58,0,0,0-.24.48,7.35,7.35,0,0,0-.35,1l-.26,1.07a3.77,3.77,0,0,1-.36,1,6.35,6.35,0,0,0-.4,1A1.3,1.3,0,0,0,243,205.09Zm0,0a1.37,1.37,0,0,1,0-1.07,6.41,6.41,0,0,1,.39-1,3.3,3.3,0,0,0,.31-1l.22-1.08a6.86,6.86,0,0,1,.31-1.07,3.82,3.82,0,0,1,.23-.51,1.88,1.88,0,0,1,.18-.24.35.35,0,0,1,.35-.11,1,1,0,0,1,.42.44l.3.47a8.3,8.3,0,0,1,.54,1,3.31,3.31,0,0,1,.37,1.07,1,1,0,0,1-.13.58.55.55,0,0,0,.06.44,8,8,0,0,1,.41,1,.71.71,0,0,1,0,.6.62.62,0,0,1-.57.15c-.42-.06-.65-.43-.87-.69s-.67,0-.87.21-.32.66-.61.91a.78.78,0,0,1-.5.21A.67.67,0,0,1,243,205.09Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.79,221.32a22.77,22.77,0,0,0,7.84,0c.24-.23-3-18.22-3.92-18.22S345.56,221.09,345.79,221.32Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.73,216.74c.67.25,3.15,1.26,3.68,1.55,0-.11,0-.22,0-.33l-1.8-1.05c-.64-.38-1.33-.71-1.93-1.15,0,0,0-.08,0-.07a16.56,16.56,0,0,1,1.89,1.05c.61.36,1.22.72,1.82,1.1,0-.87,0-1.73,0-2.59a20.9,20.9,0,0,1-2.83-1.44s0-.07,0-.06a21.38,21.38,0,0,1,2.8,1.38c0-.45,0-.89,0-1.34,0-2.31,0-4.62.09-6.93-.59-.3-1.2-.56-1.78-.85a0,0,0,0,1,0-.08c.59.24,1.17.51,1.75.77q0-1.78.15-3.57a0,0,0,0,1,.06,0c.08,2.21.08,4.42.05,6.64.61-.49,1.26-.92,1.88-1.39,0,0,0,0,0,0-.65.49-1.25,1-1.9,1.53,0,.13,0,.25,0,.38.66-.31,1.33-.59,2-.87.05,0,.1,0,0,.08-.68.32-1.35.65-2,1,0,1.1,0,2.19,0,3.29,0,1.91-.07,3.83-.11,5.74,1.25-.63,2.5-1.24,3.77-1.84,0,0,.09.05,0,.07a38.79,38.79,0,0,1-3.81,1.92c0,1.59-.07,3.18-.09,4.77a.08.08,0,0,1-.15,0c0-2,0-4.06,0-6.09a37.59,37.59,0,0,1-3.72-1.51C345.63,216.82,345.67,216.71,345.73,216.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.71,205.86c.51.39.92-.08,1.2.08s.33,1.43,1.12,1.09c.51-.22-.42-1.58-.46-2.41,0-.51-.26-1.71-.86-1.68s-.57,1.3-.73,1.6S348.29,205.55,348.71,205.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.71,205.86a.74.74,0,0,0,.64.13c.2,0,.48-.21.65,0a5.86,5.86,0,0,1,.3.62c.1.19.25.39.45.39.56,0,.3-.57.15-1a6.69,6.69,0,0,1-.44-1.33,3.46,3.46,0,0,0-.27-1.29c-.09-.19-.22-.38-.4-.41s-.36.1-.45.3c-.2.39-.17.88-.39,1.3a3.51,3.51,0,0,0-.33.6A.51.51,0,0,0,348.71,205.86Zm0,0a.51.51,0,0,1-.1-.63,3.83,3.83,0,0,1,.3-.61c.2-.4.13-.89.32-1.33a.56.56,0,0,1,.59-.42.82.82,0,0,1,.56.48,3.71,3.71,0,0,1,.33,1.36,6.54,6.54,0,0,0,.39,1.29,2.5,2.5,0,0,1,.16.68.41.41,0,0,1-.14.38.73.73,0,0,1-.38.09.72.72,0,0,1-.51-.49A5.9,5.9,0,0,0,350,206c-.14-.21-.42-.06-.62,0A.76.76,0,0,1,348.71,205.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.37,220.43c-.3.3-3.76.43-5,.43s-4.72-.13-5-.43,3.89-23.26,5-23.26S296.66,220.14,296.37,220.43Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.44,214.58c-.86.33-4,1.61-4.7,2,0-.14,0-.29,0-.43l2.3-1.34a26.78,26.78,0,0,0,2.47-1.47s0-.1,0-.08a20.18,20.18,0,0,0-2.41,1.33c-.78.46-1.55.93-2.32,1.4,0-1.1,0-2.2,0-3.3a25.36,25.36,0,0,0,3.6-1.83s0-.1,0-.08a26.87,26.87,0,0,0-3.57,1.76c0-.57,0-1.14,0-1.71,0-2.95,0-5.9-.12-8.85.75-.38,1.53-.71,2.27-1.09.05,0,0-.11,0-.09-.76.29-1.5.65-2.24,1,0-1.52-.1-3-.19-4.56,0,0-.08,0-.08,0-.11,2.83-.1,5.65-.06,8.48-.78-.62-1.61-1.17-2.4-1.77,0,0-.06,0,0,.05.83.63,1.6,1.33,2.43,1.95,0,.16,0,.32,0,.48-.85-.38-1.7-.74-2.55-1.1-.07,0-.13.06-.06.09.87.42,1.73.84,2.61,1.24l.06,4.2c0,2.44.09,4.88.14,7.33-1.59-.81-3.2-1.59-4.81-2.35-.06,0-.11.06-.05.09a51.38,51.38,0,0,0,4.86,2.45q.07,3,.11,6.09c0,.12.2.12.19,0q0-3.88,0-7.77a49.23,49.23,0,0,0,4.75-1.94C296.57,214.68,296.52,214.55,296.44,214.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.64,200.7c-.66.49-1.18-.11-1.54.09s-.42,1.83-1.43,1.39c-.65-.28.54-2,.58-3.08,0-.64.34-2.17,1.11-2.13s.73,1.65.93,2S293.17,200.3,292.64,200.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.64,200.7a1,1,0,0,1-.83.18c-.26,0-.62-.24-.8,0a6.38,6.38,0,0,0-.33.8.88.88,0,0,1-.64.61.86.86,0,0,1-.47-.11.52.52,0,0,1-.17-.46,3.54,3.54,0,0,1,.21-.88,7.94,7.94,0,0,0,.51-1.64,4.65,4.65,0,0,1,.41-1.73,1,1,0,0,1,.7-.61.7.7,0,0,1,.72.52c.25.56.16,1.18.42,1.7a4.37,4.37,0,0,1,.39.78A.66.66,0,0,1,292.64,200.7Zm0,0a.68.68,0,0,0,.11-.8,5.14,5.14,0,0,0-.41-.77c-.29-.53-.24-1.16-.5-1.67a.55.55,0,0,0-.59-.4.89.89,0,0,0-.53.54,4.41,4.41,0,0,0-.36,1.66,7.78,7.78,0,0,1-.55,1.69,3.56,3.56,0,0,0-.24.81.34.34,0,0,0,.09.33.73.73,0,0,0,.37.1c.27,0,.46-.26.58-.51s.21-.54.37-.8a.38.38,0,0,1,.41-.13c.14,0,.28.08.42.11A1,1,0,0,0,292.64,200.7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.47,220.43c-.3.3-3.75.43-5,.43s-4.71-.13-5-.43,3.89-23.26,5-23.26S390.77,220.14,390.47,220.43Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.54,214.58c-.86.33-4,1.61-4.7,2v-.43l2.29-1.34a26.78,26.78,0,0,0,2.47-1.47,0,0,0,0,0,0-.08,21,21,0,0,0-2.41,1.33c-.78.46-1.55.93-2.31,1.4,0-1.1,0-2.2,0-3.3a25.47,25.47,0,0,0,3.61-1.83s0-.1,0-.08a26.87,26.87,0,0,0-3.57,1.76c0-.57,0-1.14,0-1.71,0-2.95,0-5.9-.11-8.85.75-.38,1.52-.71,2.27-1.09,0,0,0-.11,0-.09-.76.29-1.49.65-2.24,1,0-1.52-.1-3-.19-4.56a0,0,0,0,0-.08,0c-.1,2.83-.1,5.65-.06,8.48-.78-.62-1.61-1.17-2.4-1.77,0,0-.06,0,0,.05.83.63,1.6,1.33,2.43,1.95,0,.16,0,.32,0,.48-.84-.38-1.7-.74-2.55-1.1-.07,0-.13.06-.06.09.87.42,1.73.84,2.61,1.24,0,1.4.05,2.8.06,4.2q.06,3.66.14,7.33-2.38-1.22-4.8-2.35c-.07,0-.12.06-.06.09a50.37,50.37,0,0,0,4.87,2.45q.06,3,.11,6.09a.1.1,0,0,0,.19,0c0-2.59,0-5.18,0-7.77a48.39,48.39,0,0,0,4.76-1.94A.08.08,0,0,0,390.54,214.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.74,200.7c-.66.49-1.18-.11-1.54.09s-.41,1.83-1.43,1.39c-.64-.28.55-2,.59-3.08,0-.64.33-2.17,1.1-2.13s.73,1.65.93,2S387.27,200.3,386.74,200.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.74,200.7a1,1,0,0,1-.83.18c-.26,0-.61-.24-.79,0a8.36,8.36,0,0,0-.34.8.86.86,0,0,1-.64.61.85.85,0,0,1-.46-.11.5.5,0,0,1-.18-.46,3.55,3.55,0,0,1,.22-.88,8.56,8.56,0,0,0,.5-1.64,4.65,4.65,0,0,1,.41-1.73,1,1,0,0,1,.7-.61.71.71,0,0,1,.73.52c.24.56.16,1.18.41,1.7a4.41,4.41,0,0,1,.4.78A.68.68,0,0,1,386.74,200.7Zm0,0a.65.65,0,0,0,.11-.8,4.37,4.37,0,0,0-.41-.77c-.28-.53-.24-1.16-.5-1.67a.54.54,0,0,0-.58-.4.84.84,0,0,0-.53.54,4.41,4.41,0,0,0-.36,1.66,9,9,0,0,1-.55,1.69,3.59,3.59,0,0,0-.25.81.4.4,0,0,0,.09.33.76.76,0,0,0,.37.1c.27,0,.46-.26.58-.51s.22-.54.38-.8a.36.36,0,0,1,.4-.13c.15,0,.28.08.43.11A1,1,0,0,0,386.74,200.7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.23,221.66a20.57,20.57,0,0,0,7,0c.21-.2-2.72-16.26-3.5-16.26S280,221.46,280.23,221.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.18,217.57c.6.23,2.81,1.13,3.28,1.39,0-.1,0-.2,0-.3l-1.61-.93c-.57-.34-1.19-.64-1.72-1,0,0,0-.07,0-.06a14,14,0,0,1,1.69.94c.54.31,1.08.64,1.62,1,0-.77,0-1.53,0-2.3A18.62,18.62,0,0,1,281,215s0-.07,0-.06a20,20,0,0,1,2.5,1.23v-1.2c0-2.06,0-4.12.08-6.18L282,208s0-.08,0-.07c.53.21,1.05.46,1.57.69,0-1.07.07-2.13.13-3.19,0,0,.05,0,.06,0,.07,2,.06,3.95,0,5.92.54-.43,1.12-.81,1.67-1.23,0,0,0,0,0,0-.57.44-1.11.93-1.69,1.37,0,.11,0,.22,0,.33.59-.27,1.19-.52,1.78-.77.05,0,.09,0,0,.07l-1.82.86c0,1,0,2,0,2.93,0,1.71-.06,3.42-.1,5.13,1.11-.57,2.23-1.11,3.36-1.64,0,0,.08,0,0,.06a36,36,0,0,1-3.4,1.71c0,1.42-.06,2.84-.08,4.26a.07.07,0,0,1-.13,0c0-1.81,0-3.62,0-5.43a34.48,34.48,0,0,1-3.32-1.36C280.08,217.65,280.12,217.55,280.18,217.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.55,209c.39.16.77-.36.87-.91s.17-.87.38-1,.28.35.7.24.13-.46-.12-1-.29-1.2-.7-1.2-.55,1.39-.75,1.94S282,208.83,282.55,209Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.55,209a.49.49,0,0,0,.55-.21,1.46,1.46,0,0,0,.27-.56c0-.21.06-.43.11-.63s.08-.46.36-.57.23.13.31.17a.34.34,0,0,0,.25.08c.21,0,.26-.11.17-.31a7.81,7.81,0,0,1-.52-1.17,1.11,1.11,0,0,0-.24-.5c-.13-.1-.23,0-.33.17a7.19,7.19,0,0,0-.37,1.19,5.45,5.45,0,0,1-.5,1.19,4.14,4.14,0,0,0-.21.59C282.35,208.68,282.33,209,282.55,209Zm0,0c-.22-.09-.21-.36-.17-.56a3.35,3.35,0,0,1,.2-.61,5.16,5.16,0,0,0,.41-1.2,6.76,6.76,0,0,1,.3-1.26.69.69,0,0,1,.23-.3.39.39,0,0,1,.42,0,1.28,1.28,0,0,1,.35.61,8.28,8.28,0,0,0,.47,1.18.41.41,0,0,1,0,.39.44.44,0,0,1-.36.16c-.28,0-.44-.3-.54-.3s-.25.27-.31.47-.09.41-.15.61a1.34,1.34,0,0,1-.29.57A.47.47,0,0,1,282.55,209Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,221.66a20.57,20.57,0,0,0,7,0c.21-.2-2.72-16.26-3.5-16.26S370.8,221.46,371,221.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,217.57c.6.23,2.81,1.13,3.28,1.39,0-.1,0-.2,0-.3l-1.61-.93c-.57-.34-1.19-.64-1.72-1,0,0,0-.07,0-.06a14,14,0,0,1,1.69.94c.54.31,1.08.64,1.62,1,0-.77,0-1.53,0-2.3a18.62,18.62,0,0,1-2.52-1.28s0-.07,0-.06a20,20,0,0,1,2.5,1.23v-1.2c0-2.06,0-4.12.08-6.18l-1.58-.76s0-.08,0-.07c.53.21,1.05.46,1.57.69,0-1.07.07-2.13.13-3.19,0,0,0,0,.06,0,.07,2,.06,3.95,0,5.92.54-.43,1.12-.81,1.67-1.23,0,0,.05,0,0,0-.57.44-1.11.93-1.69,1.37,0,.11,0,.22,0,.33.59-.27,1.19-.52,1.78-.77,0,0,.09,0,0,.07l-1.82.86c0,1,0,2,0,2.93,0,1.71-.06,3.42-.1,5.13,1.11-.57,2.23-1.11,3.36-1.64,0,0,.08,0,0,.06a36,36,0,0,1-3.4,1.71c0,1.42-.06,2.84-.08,4.26,0,.08-.14.08-.13,0,0-1.81,0-3.62,0-5.43a34.48,34.48,0,0,1-3.32-1.36C370.86,217.65,370.9,217.55,371,217.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.33,209c.39.16.77-.36.87-.91s.17-.87.38-1,.28.35.7.24.13-.46-.12-1-.29-1.2-.7-1.2-.55,1.39-.75,1.94S372.81,208.83,373.33,209Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.33,209a.49.49,0,0,0,.55-.21,1.46,1.46,0,0,0,.27-.56c0-.21.06-.43.11-.63s.08-.46.36-.57.23.13.31.17a.34.34,0,0,0,.25.08c.21,0,.26-.11.16-.31a9,9,0,0,1-.51-1.17,1.11,1.11,0,0,0-.24-.5c-.13-.1-.23,0-.33.17a7.19,7.19,0,0,0-.37,1.19,5.45,5.45,0,0,1-.5,1.19,4.14,4.14,0,0,0-.21.59C373.13,208.68,373.11,209,373.33,209Zm0,0c-.22-.09-.21-.36-.17-.56a3.35,3.35,0,0,1,.2-.61,5.16,5.16,0,0,0,.41-1.2,6.76,6.76,0,0,1,.3-1.26.69.69,0,0,1,.23-.3.39.39,0,0,1,.42,0,1.28,1.28,0,0,1,.35.61,8.28,8.28,0,0,0,.47,1.18.41.41,0,0,1,0,.39.44.44,0,0,1-.36.16c-.28,0-.44-.3-.54-.3s-.25.27-.31.47-.09.41-.15.61a1.47,1.47,0,0,1-.29.57A.47.47,0,0,1,373.33,209Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Road--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.05,269.9l-15.71-14.21s32.89,1.69,62.9,14.21c22.23,9.27,39.64,22.48,48.07,34.34C393.8,331.64,396,396.32,373.7,500H0S281.08,395.58,305.52,305.73C310.83,286.24,279.05,269.9,279.05,269.9Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.08,307.79c0,26.13-11.7,54.55-35.76,86.9C278.81,426.28,244.13,460.83,196.59,500H195c48-39.43,82.89-74.17,106.5-105.91,23.94-32.17,35.57-60.4,35.57-86.3,0-13.69-22.31-28.87-36.37-35.23-7.43-3.35-18.85-6-27.22-7.69L272,263.56c8.5,1.64,21.08,4.47,29.08,8.09a108.34,108.34,0,0,1,23,14.39C333.24,293.67,338.08,301.19,338.08,307.79Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.05,307.79c0,53.92-41.55,113.58-134.26,192.21h-1.55c93.1-78.8,134.81-138.43,134.81-192.21,0-6.75-4.43-13.93-13.16-21.33a109.26,109.26,0,0,0-23.24-14.57c-9-4.2-21.17-7-30.87-8.57l-1.34-1.21c10,1.49,23,4.41,32.63,8.87C306.85,272.74,340.05,288.71,340.05,307.79Z",
    style: {
      fill: "#1F2937"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Houses--inject-44"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "320.99 229.14 332.33 229.14 332.84 220.91 320.99 220.91 320.99 229.14",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.99 220.91 316.91 216.86 313.66 220.91 314.17 229.14 320.99 229.14 320.99 220.91",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.91,221.32h.7c.19,0,3.21-3.74,3.35-3.74a26,26,0,0,1,2.79,3.37c.59.93,1.23,1,2.33,1h11.3c.62,0,.89-.72.79-1.16l0-.11c-.17-.42-3.27-2.58-4.09-3.59s-1.23-1.41-1.63-1.41h-11a1,1,0,0,0-.85.42c-1,1.35-3.35,4-3.64,4.52S312.74,221.32,312.91,221.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.91,221.32h.4c.13,0,.29.05.39-.07a7.81,7.81,0,0,0,.56-.59l1.06-1.24,1.06-1.24a6.21,6.21,0,0,1,.56-.59,2.16,2.16,0,0,1,.58.55,31.17,31.17,0,0,1,2.05,2.54,2.22,2.22,0,0,0,1.16,1.08,5.09,5.09,0,0,0,1.61.13h10.6a1.68,1.68,0,0,0,.78-.09.93.93,0,0,0,.41-.64.67.67,0,0,0-.2-.71c-1.61-1.44-3.49-2.64-4.8-4.39a1.17,1.17,0,0,0-.68-.38h-10.6a3.13,3.13,0,0,0-.81.05,1.26,1.26,0,0,0-.61.51c-.66.86-1.36,1.69-2.05,2.53l-1,1.26a8,8,0,0,0-.48.66,1,1,0,0,0-.15.37A.23.23,0,0,0,312.91,221.32Zm0,0a.23.23,0,0,1-.2-.3,1,1,0,0,1,.15-.37,4.45,4.45,0,0,1,.48-.66l1-1.26c.69-.84,1.38-1.68,2.05-2.54a1.22,1.22,0,0,1,.62-.52,3.13,3.13,0,0,1,.81,0h10.6a1.17,1.17,0,0,1,.71.39c1.33,1.75,3.19,2.93,4.81,4.38a.7.7,0,0,1,.23.35,1,1,0,0,1,0,.42,1,1,0,0,1-.45.68,1.62,1.62,0,0,1-.81.1h-10.6a5.5,5.5,0,0,1-1.62-.14,2.28,2.28,0,0,1-1.17-1.1c-.63-.88-1.32-1.72-2-2.54a3,3,0,0,0-.57-.55,6.19,6.19,0,0,0-.55.59l-1.06,1.24-1.07,1.23c-.18.2-.36.41-.56.6s-.26,0-.39.06Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.91,221.32h.7c.19,0,3.21-3.74,3.35-3.74a26,26,0,0,1,2.79,3.37c.59.93,1.23,1,2.33,1h11.3c.62,0,.89-.72.79-1.16a1.54,1.54,0,0,1-.34.28,6.89,6.89,0,0,1-2.86.18c-1.07-.12-2.12-.28-3.19-.32a23.42,23.42,0,0,0-3.45.13c-1.05.12-2.29.43-3.06-.38s-3.07-3.12-3.33-3.52a3.1,3.1,0,0,0-.72-.89,1,1,0,0,0-.68-.17c-1,1.35-3.35,4-3.64,4.52S312.74,221.32,312.91,221.32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.92,
    y: 225.55,
    width: 1.98,
    height: 3.6,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.9,229.14h-2l0-3.59v0h2v0Zm0,0,0-3.59,0,0h-2l0,0,0,3.59h2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.7,
    y: 225.79,
    width: 0.43,
    height: 0.54,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.13,225.79v0a.53.53,0,0,0-.37.51h-.06v-.54Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.26,
    y: 225.79,
    width: 0.43,
    height: 0.54,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.69,225.79v0a.53.53,0,0,0-.37.51h-.06v-.54Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.46,
    y: 227.91,
    width: 0.9,
    height: 0.13,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.14,
    y: 225.79,
    width: 0.43,
    height: 0.54,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.57,225.79v0a.53.53,0,0,0-.37.51h-.06v-.54Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.25,216.78h2.61a13.32,13.32,0,0,1,1.16,1.45c.05.08,0,.22-.35.22h-2.42Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.23 218.16 326.23 220.19 327.68 220.19 327.68 218.16 326.95 217.26 326.23 218.16",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.23 218.16 325.08 218.16 326.23 220.19 326.23 218.16",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.58,
    y: 218.2,
    width: 0.82,
    height: 1.39,
    transform: "translate(653.98 437.78) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.58,219.59l.82,0v0l0-1.39,0,0h-.82l0,0Zm0,0,0-1.39v0h.88v0l0,1.39h-.83Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.03,
    y: 218.29,
    width: 0.27,
    height: 0.45,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,218.29v0c.25,0,.26.34.26.42h0v-.45Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.68,
    y: 218.29,
    width: 0.27,
    height: 0.45,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.68,218.29v0c.25,0,.25.34.25.42h0v-.45Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.03,
    y: 218.82,
    width: 0.27,
    height: 0.66,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,218.82v0c.28.1.22.38.24.62h0v-.66Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.68,
    y: 218.82,
    width: 0.27,
    height: 0.66,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.68,218.82v0c.27.1.22.38.24.62h0v-.66Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.14,
    y: 215.33,
    width: 1.45,
    height: 1.91,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.14 215.33 318 215.33 318 215.63 319.14 217.24 319.14 215.33",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.14,
    y: 214.68,
    width: 1.61,
    height: 0.65,
    transform: "translate(639.89 430.01) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.75,214.68l-1.61,0,0,0v.65l0,0,1.61,0h0Zm0,0v.65h0l-1.61,0h0v-.71h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.88,
    y: 214.68,
    width: 1.26,
    height: 0.65,
    transform: "translate(637.02 430.01) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.3,225l0,2.58h-2V225a1,1,0,0,1,1-.89,1,1,0,0,1,1,.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.3,225v2.6h-2v-1.41a12.73,12.73,0,0,1,0-1.38,1,1,0,0,1,.39-.56,1,1,0,0,1,1.56.75h0Zm0,0h0a1,1,0,0,0-.9-.89,1.09,1.09,0,0,0-.64.16.94.94,0,0,0-.37.55,10.45,10.45,0,0,0,0,1.37v1.38l0,0,2,0h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.19,
    y: 226.49,
    width: 1.07,
    height: 0.64,
    transform: "translate(102.35 556.45) rotate(-89.73)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.41,226.27v.07c.6,0,.61.81.61,1h0v-1.07Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.34,
    y: 226.48,
    width: 1.07,
    height: 0.64,
    transform: "translate(101.51 555.6) rotate(-89.73)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.56,226.26v.07c.6.06.61.82.6,1h0v-1.07Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.56,225h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.19,224.39v1.69h-.63V225a.67.67,0,0,1,.15-.39A.66.66,0,0,1,330.19,224.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.19,224.39v1.69h-.1c0-.39.09-1.54-.38-1.47A.66.66,0,0,1,330.19,224.39Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.05,226.07h-.64v-1.69a.62.62,0,0,1,.63.61v1.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.05,226.07h-.14c0-.42.1-1.42-.5-1.42v-.26a.62.62,0,0,1,.63.61v1.07Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.44,225v2.58h-2l0-2.58a1,1,0,0,1,1-.89,1,1,0,0,1,1,.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.44,225v2.6h-2v-1.41a12.73,12.73,0,0,1,.05-1.38,1,1,0,0,1,.39-.56,1,1,0,0,1,.67-.15,1,1,0,0,1,.89.9h0Zm0,0h0a1,1,0,0,0-.89-.89,1.11,1.11,0,0,0-.65.16,1,1,0,0,0-.37.55,12.53,12.53,0,0,0,0,1.37v1.38l0,0,2,0h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.33,
    y: 226.49,
    width: 1.07,
    height: 0.64,
    transform: "translate(95.53 549.6) rotate(-89.73)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.56,226.27v.07c.6,0,.61.81.61,1h0v-1.07Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.48,
    y: 226.48,
    width: 1.07,
    height: 0.64,
    transform: "translate(94.68 548.74) rotate(-89.73)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.7,226.26v.07c.6.06.61.82.61,1h0v-1.07Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.7,225h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.33,224.39v1.69h-.63V225a.67.67,0,0,1,.15-.39A.66.66,0,0,1,323.33,224.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.33,224.39v1.69h-.09c0-.39.09-1.54-.39-1.47A.66.66,0,0,1,323.33,224.39Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.19,226.07h-.63v-1.69a.63.63,0,0,1,.64.61v1.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.19,226.07h-.14c0-.42.1-1.42-.5-1.42v-.26a.63.63,0,0,1,.64.61v1.07Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.08,225v2.58h2V225a1,1,0,0,0-1-.89,1,1,0,0,0-1,.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.08,225l0,2.58h0l2,0,0,0v-1.38c0-.45,0-.92,0-1.37a1,1,0,0,0-.37-.55,1.14,1.14,0,0,0-.65-.16,1,1,0,0,0-.9.89Zm0,0h0a1,1,0,0,1,.9-.9.94.94,0,0,1,1,.71,10.61,10.61,0,0,1,.05,1.38v1.41h-2V225Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.33,
    y: 226.27,
    width: 0.64,
    height: 1.07,
    transform: "translate(-1.07 1.51) rotate(-0.27)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317,226.27v.07c-.6,0-.61.81-.6,1h0v-1.07Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.18,
    y: 226.27,
    width: 0.64,
    height: 1.07,
    transform: "translate(-1.07 1.51) rotate(-0.27)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.81,226.26v.07c-.6.06-.6.82-.6,1h0v-1.07Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.81,225h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.18,224.39v1.69h.64V225a.61.61,0,0,0-.15-.39A.64.64,0,0,0,317.18,224.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.18,224.39v1.69h.1c0-.39-.09-1.54.38-1.47A.64.64,0,0,0,317.18,224.39Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.32,226.07H317v-1.69a.63.63,0,0,0-.63.61v1.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.32,226.07h.14c0-.42-.09-1.42.5-1.42v-.26a.63.63,0,0,0-.63.61v1.07Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.08,220.18v2.58h2v-2.58a1,1,0,0,0-1-.89,1,1,0,0,0-1,.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.08,220.18l0,2.58,0,0,2,0,0,0v-1.38c0-.45,0-.92,0-1.37a1,1,0,0,0-.37-.55,1.07,1.07,0,0,0-.65-.16,1,1,0,0,0-.9.89Zm0,0h0a1,1,0,0,1,1.56-.75,1,1,0,0,1,.39.56,10.61,10.61,0,0,1,.05,1.38v1.41h-2v-2.6Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.33,
    y: 221.45,
    width: 0.64,
    height: 1.07,
    transform: "translate(-1.05 1.51) rotate(-0.27)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317,221.45v.07c-.6,0-.61.81-.6,1h0v-1.07Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.18,
    y: 221.44,
    width: 0.64,
    height: 1.07,
    transform: "translate(-1.05 1.51) rotate(-0.27)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.81,221.44v.07c-.6.06-.6.82-.6,1h0v-1.07Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.81,220.15h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.18,219.57v1.69h.64v-1.07a.63.63,0,0,0-.63-.61Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.18,219.57v1.69h.1c0-.39-.09-1.55.38-1.47A.61.61,0,0,0,317.18,219.57Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.32,221.25H317v-1.69a.63.63,0,0,0-.63.61v1.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.32,221.25h.14c0-.42-.09-1.42.5-1.42v-.26a.63.63,0,0,0-.63.61v1.07Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.08,229.5a22.83,22.83,0,0,0-4.95.23c-1.44.19-2.89.41-4.34.52a15.5,15.5,0,0,1-4.25-.12,55.81,55.81,0,0,0-8.64-.8,7.58,7.58,0,0,1-2.37-.23s0,0,0,0a16.47,16.47,0,0,0,5.42-.25c3.2-.4,6.35.42,9.56.28,1.63-.07,3.23-.37,4.87-.31a39.58,39.58,0,0,1,4.73.54C335.2,229.34,335.18,229.5,335.08,229.5Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.73,231.12a11.76,11.76,0,0,1-2.36-.32c-.58-.06-1.15-.12-1.73-.14a23.45,23.45,0,0,0-4.32.56,3.83,3.83,0,0,1-1.71-.16,6.19,6.19,0,0,0-2.05-.37,10.24,10.24,0,0,1-1.74-.23,4.46,4.46,0,0,0-.82-.06c-.51.08-1,.16-1.54.19h0a4.69,4.69,0,0,1-1.35-.11s0,0,0,0a5.94,5.94,0,0,0,1.46.06,7,7,0,0,1,1.71-.23c.5-.08,1-.16,1.5-.2a11.59,11.59,0,0,1,2.28,0,13.42,13.42,0,0,0,2.1.28,31,31,0,0,1,4.2-.18c.95.14,1.88.39,2.82.58l1.56.21A0,0,0,0,1,347.73,231.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.31,232.75c-.31.06-.63.12-.95.15l-.64.15a8.28,8.28,0,0,1-2.32.27c-1.7,0-3.35-.5-5-.63a15.43,15.43,0,0,1-2.36-.09c-.4-.09-.77-.25-1.18-.31a8.54,8.54,0,0,0-1.34,0c-.05,0-.05-.07,0-.07a6.3,6.3,0,0,1,1.73.11l.44.12c1.76.11,3.52-.38,5.27-.16.86.12,1.68.42,2.54.53a13.18,13.18,0,0,0,2.51.09l.28,0a6,6,0,0,1,1.05-.15A0,0,0,0,1,331.31,232.75Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.42 229.14 398.07 229.14 397.56 223.64 409.42 223.64 409.42 229.14",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.41 223.63 413.49 218.53 416.74 223.63 416.23 229.13 409.41 229.13 409.41 223.63",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.41 223.63 413.49 218.53 416.74 223.63 416.23 229.13 409.41 229.13 409.41 223.63",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.5,224.05h-.7c-.2,0-3.21-5.18-3.36-5.18s-2.19,3.89-2.78,4.81-1.24,1-2.34,1H397c-.63,0-.89-.72-.79-1.16a.17.17,0,0,1,0-.1c.16-.43,3.26-4,4.08-5.05s1.24-1.4,1.63-1.4h11a1,1,0,0,1,.85.41c1,1.35,3.34,5.5,3.63,6S417.67,224.05,417.5,224.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.5,224.05h-.67c-.08,0-.11-.08-.16-.13-.18-.24-.34-.49-.5-.73l-.94-1.51-.93-1.51-.47-.75-.25-.37a1.09,1.09,0,0,0-.13-.17c-.05,0-.09.1-.13.16-.62,1-1.17,2.05-1.75,3.08-.29.52-.57,1-.88,1.54a2.33,2.33,0,0,1-.59.66,1.93,1.93,0,0,1-.84.3c-2.36.08-4.72,0-7.09,0h-3.55c-.59,0-1.17,0-1.77,0a.87.87,0,0,1-.61-.63.9.9,0,0,1,.12-.87c1.44-1.88,3-3.65,4.51-5.48a4.16,4.16,0,0,1,.65-.61.94.94,0,0,1,.42-.16H413a1,1,0,0,1,.79.35c.18.23.35.48.51.73.65,1,1.25,2,1.85,3l.89,1.54.44.77a1.2,1.2,0,0,1,.18.4C417.73,223.86,417.67,224.06,417.5,224.05Zm0,0c.17,0,.23-.19.19-.33a1.44,1.44,0,0,0-.18-.4l-.45-.77-.89-1.53c-.6-1-1.2-2-1.85-3-.17-.25-.33-.5-.52-.73a1,1,0,0,0-.77-.34H402.39a1.21,1.21,0,0,0-.84.16,3.62,3.62,0,0,0-.64.6c-1.49,1.83-3.06,3.6-4.49,5.48a.84.84,0,0,0-.12.81.82.82,0,0,0,.56.59c.57,0,1.18,0,1.76,0h3.55c2.36,0,4.73,0,7.09,0a1.85,1.85,0,0,0,.82-.3,2.12,2.12,0,0,0,.58-.65c.31-.5.6-1,.89-1.53.58-1,1.13-2.08,1.76-3.08,0-.06.07-.14.15-.16a1.15,1.15,0,0,1,.14.17l.24.37.47.76.93,1.51.93,1.5c.16.25.32.5.5.74.05.05.08.14.16.13h.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.5,224.05h-.7c-.2,0-3.21-5.18-3.36-5.18s-2.19,3.89-2.78,4.81-1.24,1-2.34,1H397c-.63,0-.89-.72-.79-1.16a1.29,1.29,0,0,0,.33.28,6.77,6.77,0,0,0,2.87.18c1.06-.12,2.11-.28,3.18-.32a23.42,23.42,0,0,1,3.45.13,5.63,5.63,0,0,0,3.23-.13c1.44-.74,1.79-2.63,2.45-4a11.83,11.83,0,0,1,.71-1.25,2.93,2.93,0,0,1,.72-.88,1,1,0,0,1,.69-.18c1,1.35,3.34,5.5,3.63,6S417.67,224.05,417.5,224.05Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.29,
    y: 225.68,
    width: 1.8,
    height: 2.57,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.09,228.25l-1.8,0h0v-2.62h1.85v0Zm0,0,0-2.57,0,0h-1.8l0,0v2.57l0,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.52,
    y: 225.89,
    width: 0.58,
    height: 0.98,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.09,225.89V226c-.54,0-.55.73-.55.91h0v-1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.29,
    y: 225.89,
    width: 0.58,
    height: 0.98,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.87,225.89V226c-.55,0-.56.73-.56.91h0v-1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.52,
    y: 227.05,
    width: 0.58,
    height: 0.98,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.09,227.05v.07c-.54,0-.55.74-.55.91h0v-1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.29,
    y: 227.05,
    width: 0.58,
    height: 0.98,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.87,227.05v.07c-.55,0-.56.74-.56.91h0v-1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.89,
    y: 225.68,
    width: 1.8,
    height: 2.57,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.68,228.25l-1.79,0h0v-2.62h1.86v0Zm0,0,0-2.57,0,0h-1.79l0,0v2.57l0,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.11,
    y: 225.89,
    width: 0.58,
    height: 0.98,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.69,225.89V226c-.55,0-.56.73-.56.91h0v-1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.89,
    y: 225.89,
    width: 0.58,
    height: 0.98,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.46,225.89V226c-.54,0-.55.73-.55.91h0v-1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.11,
    y: 227.05,
    width: 0.58,
    height: 0.98,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.69,227.05v.07c-.55,0-.56.74-.56.91h0v-1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.89,
    y: 227.05,
    width: 0.58,
    height: 0.98,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.46,227.05v.07c-.54,0-.55.74-.55.91h0v-1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.42,
    y: 225.54,
    width: 1.98,
    height: 3.6,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.4,229.14h-2l0-3.6v0h2v0Zm0,0,0-3.6,0,0h-2l0,0,0,3.6h2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.2,
    y: 225.79,
    width: 0.43,
    height: 0.54,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.62,225.79v0a.54.54,0,0,0-.36.51h-.06v-.54Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.75,
    y: 225.79,
    width: 0.43,
    height: 0.54,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.18,225.79v0a.54.54,0,0,0-.36.51h-.07v-.54Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.96,
    y: 228.15,
    width: 0.9,
    height: 0.13,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.64,
    y: 225.79,
    width: 0.43,
    height: 0.54,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.06,225.79v0a.54.54,0,0,0-.36.51h-.06v-.54Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.2,
    y: 226.47,
    width: 0.43,
    height: 0.54,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.62,226.47v0a.54.54,0,0,0-.36.51h-.06v-.54Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.75,
    y: 226.47,
    width: 0.43,
    height: 0.54,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.18,226.47v0a.54.54,0,0,0-.36.51h-.07v-.54Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.64,
    y: 226.47,
    width: 0.43,
    height: 0.54,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.06,226.47v0a.54.54,0,0,0-.36.51h-.06v-.54Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.2,
    y: 227.15,
    width: 0.43,
    height: 0.54,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.62,227.15v0a.54.54,0,0,0-.36.51h-.06v-.54Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.75,
    y: 227.15,
    width: 0.43,
    height: 0.54,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.18,227.15v0a.54.54,0,0,0-.36.51h-.07v-.54Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.64,
    y: 227.15,
    width: 0.43,
    height: 0.54,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.06,227.15v0a.54.54,0,0,0-.36.51h-.06v-.54Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.61,
    y: 216.61,
    width: 1.45,
    height: 1.91,
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.06 216.61 405.2 216.61 405.2 216.91 404.06 218.51 404.06 216.61",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.06 216.61 405.2 216.61 405.2 216.91 404.06 218.51 404.06 216.61",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.45,
    y: 215.96,
    width: 1.61,
    height: 0.65,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.45,216l1.61,0h0v.71h0l-1.61,0h0Zm0,0v.65h0l1.61,0,0,0V216l0,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.06,
    y: 215.96,
    width: 1.26,
    height: 0.65,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "413.9 229.14 417.59 229.14 417.94 225.35 413.9 225.35 413.9 229.14",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "413.9 229.14 417.59 229.14 417.94 225.35 413.9 225.35 413.9 229.14",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "413.9 225.35 412.09 224.63 412.13 229.14 413.9 229.14 413.9 225.35",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.18,
    y: 226.33,
    width: 1.55,
    height: 2.81,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.72,229.14l-1.54,0h0v0l0-2.81v0h1.61v0Zm0,0,0-2.81,0,0h-1.54l0,0,0,2.81v0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.78,
    y: 226.52,
    width: 0.33,
    height: 0.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.12,226.52v0a.41.41,0,0,0-.29.39h-.05v-.42Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.22,
    y: 226.52,
    width: 0.33,
    height: 0.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.55,226.52v0a.42.42,0,0,0-.28.39h0v-.42Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.6,
    y: 228.18,
    width: 0.7,
    height: 0.1,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.35,
    y: 226.52,
    width: 0.33,
    height: 0.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.68,226.52v0a.41.41,0,0,0-.29.39h0v-.42Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.36,225.65h-4.18c-.13,0-.35.08-1.07-.33a8.46,8.46,0,0,1-1.23-.71.17.17,0,0,1,.1-.24.69.69,0,0,1,.22,0H417c.28,0,.88.51,1.22.82l.23.21A.16.16,0,0,1,418.36,225.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.36,225.65h-4.45a2.51,2.51,0,0,1-.83-.34l-.78-.42a2.22,2.22,0,0,1-.39-.23.17.17,0,0,1-.06-.23.21.21,0,0,1,.2-.12c1.2,0,2.38,0,3.57,0h.89a1.36,1.36,0,0,1,.86.15,4.51,4.51,0,0,1,.7.54l.33.3c.05.05.12.11.1.19A.15.15,0,0,1,418.36,225.65Zm0,0a.15.15,0,0,0,.14-.14.24.24,0,0,0-.1-.19l-.33-.29a5.12,5.12,0,0,0-.71-.54,1.38,1.38,0,0,0-.85-.14h-.89c-1.18,0-2.38,0-3.55,0-.15,0-.24.16-.12.25a3.44,3.44,0,0,0,.38.22l.78.43a2.42,2.42,0,0,0,.8.33h.89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.36,225.65h-4.18c-.13,0-.35.08-1.07-.33a8.46,8.46,0,0,1-1.23-.71.17.17,0,0,1,.1-.24c.16.22.67.31.88.38a4.44,4.44,0,0,1,.49.24,3.45,3.45,0,0,0,1.78.16,17.15,17.15,0,0,1,1.76.13l.89.05a1,1,0,0,0,.34,0c.11-.06.12-.11.1-.16l.23.21A.16.16,0,0,1,418.36,225.65Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.91,224.75Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.6,222.42a.92.92,0,1,0,.92-.92A.92.92,0,0,0,412.6,222.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.6,222.42a.92.92,0,0,0,.92.9.9.9,0,0,0,.88-.9.89.89,0,0,0-.88-.9A.91.91,0,0,0,412.6,222.42Zm0,0a.93.93,0,0,1,.92-.94.94.94,0,1,1,0,1.87A.93.93,0,0,1,412.6,222.42Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.8,222.42a.71.71,0,0,0,.72.71.47.47,0,0,0,.17,0,.71.71,0,0,0,.31-.16.71.71,0,0,0-.48-1.24l-.18,0a.6.6,0,0,0-.23.1A.7.7,0,0,0,412.8,222.42Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414,222.94a.71.71,0,0,0-.48-1.24l-.18,0C413.88,221.84,414.31,222.47,414,222.94Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 413.42,
    y: 221.56,
    width: 0.2,
    height: 1.69,
    transform: "translate(827.03 444.82) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.42,223.25h.19l0-1.69,0,0h-.2l0,0Zm0,0,0-1.69v0h.26v0l0,1.69h-.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 413.42,
    y: 221.56,
    width: 0.2,
    height: 1.69,
    transform: "translate(635.92 -191.11) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.36,222.51v-.2h0l-1.69,0,0,0v.2l0,0Zm0,0-1.69,0h0v-.27h0l1.69,0h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.75,229.42a14,14,0,0,1-2.82-.22c-1.16,0-2.31,0-3.47,0-.92,0-1.84.1-2.75.2s-1.78.26-2.68.31a10.22,10.22,0,0,1-2.52-.25,9.47,9.47,0,0,0-2.71-.17,25.31,25.31,0,0,1-2.61.24,11.07,11.07,0,0,1-2.35-.44c-1.5-.34-3.15.54-4.56-.22a0,0,0,1,1,0-.08,4.67,4.67,0,0,0,2.77.17,14.15,14.15,0,0,1,1.84-.18,8.54,8.54,0,0,1,1.34.08,7.26,7.26,0,0,0,1.54.16,8.58,8.58,0,0,0,1.41-.36,3.3,3.3,0,0,1,1,0,24.51,24.51,0,0,0,2.43.35,12.25,12.25,0,0,1,2.25-.22,8.29,8.29,0,0,1,1.08.31,2.38,2.38,0,0,0,1.37-.11,9.78,9.78,0,0,1,4.47-.22c.79.11,1.58.26,2.37.38s1.72.11,2.57.2A.06.06,0,0,1,420.75,229.42Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.58,230.91a9.88,9.88,0,0,1-2.82.17l-.12,0h0c-.78,0-1.55-.21-2.32-.18-.39,0-.76.1-1.14.12a10.09,10.09,0,0,1-1.1,0c-.78,0-1.55-.09-2.34-.06s-1.49-.16-2.24-.15a0,0,0,1,1,0-.09,14.33,14.33,0,0,1,1.47.13c.24,0,.48,0,.72,0,.49-.13,1-.37,1.45-.46.74-.14,1.45.21,2.2.13a4.71,4.71,0,0,1,1.12-.06,6.49,6.49,0,0,1,.89.25,8.42,8.42,0,0,0,1.23.27,27.64,27.64,0,0,0,3-.12S400.61,230.9,400.58,230.91Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416,232.24c-.74-.05-1.47-.13-2.21-.15a13.77,13.77,0,0,1-2.13,0,13.56,13.56,0,0,0-2.7-.1,5.15,5.15,0,0,1-1.18,0l-.82,0c-.05,0-.05-.1,0-.09a16.74,16.74,0,0,0,2.24,0c.26-.05.51-.11.76-.18a3.94,3.94,0,0,1,1-.16,4.86,4.86,0,0,1,.84.19,3.54,3.54,0,0,0,1.17,0,3,3,0,0,1,1,.12,4.32,4.32,0,0,0,1.07.21,4.41,4.41,0,0,1,1,.1S416,232.24,416,232.24Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.7,
    y: 222.42,
    width: 1.66,
    height: 2.18,
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.4,
    y: 222.42,
    width: 1.3,
    height: 2.18,
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.4,
    y: 222.42,
    width: 1.3,
    height: 2.18,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.7,
    y: 221.68,
    width: 1.84,
    height: 0.74,
    transform: "translate(715.24 444.11) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.54,221.68l-1.84,0,0,0v.74l0,0,1.84,0h0Zm0,0v.74h0l-1.84,0h0v-.8h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.26,
    y: 221.68,
    width: 1.44,
    height: 0.74,
    transform: "translate(711.96 444.11) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.6 236.74 363.56 236.74 364.13 231.11 350.6 231.11 350.6 236.74",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.6 231.08 345.94 225.25 342.24 231.08 342.81 236.71 350.6 236.71 350.6 231.08",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.6 231.08 345.94 225.25 342.24 231.08 342.81 236.71 350.6 236.71 350.6 231.08",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.4,231.58h.8c.22,0,3.66-5.92,3.82-5.92s2.51,4.44,3.19,5.5,1.41,1.09,2.67,1.09h12.89c.72,0,1-.82.91-1.32a.34.34,0,0,0,0-.12c-.19-.49-3.73-4.6-4.66-5.76s-1.42-1.61-1.87-1.61h-12.6a1.17,1.17,0,0,0-1,.48c-1.16,1.54-3.82,6.27-4.15,6.81S341.2,231.58,341.4,231.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.4,231.58h.76c.09,0,.13-.1.18-.15.2-.27.38-.56.57-.84l1.07-1.72,1.06-1.73.53-.86.28-.42a1,1,0,0,1,.16-.2c.09,0,.12.12.17.18.71,1.15,1.34,2.35,2,3.52.33.59.65,1.18,1,1.75a2.4,2.4,0,0,0,.67.75,2,2,0,0,0,.93.33c.67.07,1.35,0,2,0H363c.67,0,1.36,0,2,0a1,1,0,0,0,.65-.68,1,1,0,0,0-.14-.93c-1.63-2.14-3.43-4.17-5.13-6.26a4.74,4.74,0,0,0-.73-.69,1,1,0,0,0-.46-.17H346.5a1.16,1.16,0,0,0-.89.4,9.34,9.34,0,0,0-.58.82c-.74,1.13-1.43,2.29-2.12,3.46l-1,1.75-.51.87a1.89,1.89,0,0,0-.2.46C341.13,231.36,341.2,231.58,341.4,231.58Zm0,0c-.2,0-.27-.22-.22-.38a1.57,1.57,0,0,1,.2-.46l.51-.88,1-1.75c.69-1.16,1.37-2.33,2.11-3.46.19-.28.38-.56.59-.82a1.16,1.16,0,0,1,.9-.41h12.66a1.08,1.08,0,0,1,.48.18,4.91,4.91,0,0,1,.74.7c1.71,2.09,3.51,4.1,5.15,6.25a1.06,1.06,0,0,1,.14,1,1,1,0,0,1-.69.72c-.69.05-1.36,0-2,0H352.82a19.46,19.46,0,0,1-2,0,2,2,0,0,1-.95-.34,2.45,2.45,0,0,1-.68-.75c-.35-.58-.68-1.17-1-1.76-.66-1.17-1.29-2.37-2-3.52-.05-.06-.1-.16-.15-.18a1.56,1.56,0,0,0-.16.2l-.27.42-.54.86L344,228.86l-1.07,1.72c-.18.28-.36.57-.57.84,0,.05-.09.16-.18.15h-.76Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.05,226h3a14,14,0,0,1,1.33,1.64c.06.09,0,.26-.39.26h-2.78Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.3 227.58 360.3 229.9 361.96 229.9 361.96 227.58 361.13 226.55 360.3 227.58",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.3 227.58 359 227.58 360.3 229.9 360.3 227.58",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.3 227.58 359 227.58 360.3 229.9 360.3 227.58",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.7,
    y: 227.62,
    width: 0.94,
    height: 1.59,
    transform: "translate(722.35 456.82) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.7,229.21l.94,0v0l0-1.59,0,0h-.94l0,0Zm0,0,0-1.59v0h0l.94,0h0v0l0,1.59h-1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.23,
    y: 227.73,
    width: 0.3,
    height: 0.51,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.23,227.73v0c.28,0,.29.39.29.48h0v-.51Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.82,
    y: 227.73,
    width: 0.3,
    height: 0.51,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.82,227.73v0c.29,0,.29.39.29.48h0v-.51Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.23,
    y: 228.33,
    width: 0.3,
    height: 0.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.23,228.33v0c.31.11.25.43.27.71h0v-.76Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.82,
    y: 228.33,
    width: 0.3,
    height: 0.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.82,228.33v0c.31.11.25.43.27.71h0v-.76Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.75,226h3a15.08,15.08,0,0,1,1.32,1.64c.06.09,0,.26-.39.26h-2.77Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.98 227.56 352.98 229.87 354.63 229.87 354.63 227.56 353.81 226.52 352.98 227.56",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.98 227.56 351.68 227.56 352.98 229.87 352.98 227.56",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.98 227.56 351.68 227.56 352.98 229.87 352.98 227.56",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.41,
    y: 227.62,
    width: 0.94,
    height: 1.59,
    transform: "translate(707.75 456.82) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.41,229.21l.94,0,0,0,0-1.59,0,0h-.94l0,0Zm0,0,0-1.59v0h0l.94,0h0v0l0,1.59h-.95Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.93,
    y: 227.73,
    width: 0.3,
    height: 0.51,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.93,227.73v0c.28,0,.29.39.29.48h0v-.51Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.52,
    y: 227.73,
    width: 0.3,
    height: 0.51,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.52,227.73v0c.29,0,.29.39.29.48h0v-.51Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.93,
    y: 228.33,
    width: 0.3,
    height: 0.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.93,228.33v0c.31.11.25.43.27.71h0v-.76Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.52,
    y: 228.33,
    width: 0.3,
    height: 0.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.52,228.33v0c.31.11.25.43.27.71h0v-.76Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.4,231.58h.8c.22,0,3.66-5.92,3.82-5.92s2.51,4.44,3.19,5.5,1.41,1.09,2.67,1.09h12.89c.72,0,1-.82.91-1.32a2,2,0,0,1-.39.32,7.83,7.83,0,0,1-3.27.2c-1.21-.13-2.41-.31-3.63-.36a27.22,27.22,0,0,0-3.94.14c-1.21.14-2.56.43-3.69-.15-1.65-.85-2-3-2.8-4.52a13.45,13.45,0,0,0-.81-1.43,3.37,3.37,0,0,0-.82-1,1.1,1.1,0,0,0-.79-.2c-1.16,1.54-3.82,6.27-4.15,6.81S341.2,231.58,341.4,231.58Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.98,
    y: 232.79,
    width: 2.05,
    height: 3.46,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347,236.25H345l0-3.46v0h2.11v0Zm0,0,0-3.46,0,0h-2l0,0,0,3.46h2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.23,
    y: 233.03,
    width: 0.66,
    height: 1.11,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.89,233v.07c-.62.06-.63.84-.63,1h0V233Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.11,
    y: 233.03,
    width: 0.66,
    height: 1.11,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.77,233v.07c-.62.06-.63.84-.63,1h0V233Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.23,
    y: 234.35,
    width: 0.66,
    height: 1.65,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.89,234.35v.11c-.68.23-.55.93-.6,1.54h-.06v-1.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.11,
    y: 234.35,
    width: 0.66,
    height: 1.65,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.77,234.35v.11c-.68.23-.55.93-.59,1.54h-.07v-1.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.9,
    y: 232.79,
    width: 2.05,
    height: 3.46,
    transform: "translate(707.85 469.04) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.9,236.25h2l0-3.46,0,0H352.9l0,0Zm0,0,0-3.46v0H355v0l0,3.46H352.9Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.04,
    y: 233.03,
    width: 0.66,
    height: 1.11,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354,233v.07c.62.06.63.84.63,1h0V233Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.15,
    y: 233.03,
    width: 0.66,
    height: 1.11,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.15,233v.07c.63.06.64.84.64,1h0V233Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.04,
    y: 234.35,
    width: 0.66,
    height: 1.65,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354,234.35v.11c.68.23.55.93.6,1.54h.06v-1.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.15,
    y: 234.35,
    width: 0.66,
    height: 1.65,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.15,234.35v.11c.69.23.56.93.6,1.54h.06v-1.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.15,
    y: 232.79,
    width: 2.05,
    height: 3.46,
    transform: "translate(722.35 469.04) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.15,236.25h2l0-3.46,0,0h-2.05l0,0Zm0,0,0-3.46v0h2.1v0l0,3.46h-2.06Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.29,
    y: 233.03,
    width: 0.66,
    height: 1.11,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.29,233v.07c.62.06.63.84.63,1h0V233Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.4,
    y: 233.03,
    width: 0.66,
    height: 1.11,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.4,233v.07c.62.06.64.84.63,1h0V233Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.29,
    y: 234.35,
    width: 0.66,
    height: 1.65,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.29,234.35v.11c.68.23.55.93.59,1.54H362v-1.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.4,
    y: 234.35,
    width: 0.66,
    height: 1.65,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.4,234.35v.11c.68.23.55.93.6,1.54h.06v-1.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.5,
    y: 232.78,
    width: 2.26,
    height: 4.11,
    transform: "translate(715.27 469.67) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.5,236.89l2.27,0,0,0,0-4.11,0,0H356.5l0,0Zm0,0,0-4.11v0h2.32v0l0,4.11H356.5Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.39,
    y: 233.06,
    width: 0.49,
    height: 0.61,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.39,233.06v0a.61.61,0,0,1,.42.58h.07v-.62Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.75,
    y: 233.06,
    width: 0.49,
    height: 0.61,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.75,233.06v0a.61.61,0,0,1,.42.58h.07v-.62Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.12,
    y: 235.48,
    width: 1.03,
    height: 0.15,
    transform: "translate(715.27 471.11) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.03,
    y: 233.06,
    width: 0.49,
    height: 0.61,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,233.06v0a.61.61,0,0,1,.42.58h.07v-.62Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346.03,
    cy: 229.9,
    r: 1.05,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.08,229.9A1.06,1.06,0,0,1,346,231a1.07,1.07,0,1,1,1.05-1.06Zm0,0a1.05,1.05,0,0,0-1.05-1,1,1,0,0,0,0,2.06A1.05,1.05,0,0,0,347.08,229.9Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.84,229.9a.81.81,0,0,1-.81.81l-.21,0a.75.75,0,0,1-.34-.18.81.81,0,0,1,.55-1.42.64.64,0,0,1,.2,0,.77.77,0,0,1,.26.12A.82.82,0,0,1,346.84,229.9Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.48,230.5a.81.81,0,0,1,.55-1.42.64.64,0,0,1,.2,0C345.61,229.24,345.12,230,345.48,230.5Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.92,
    y: 228.92,
    width: 0.23,
    height: 1.93,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.14,230.85h-.23l0-1.93v0h.29v0Zm0,0,0-1.93,0,0h-.22l0,0,0,1.93h.22Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.91,
    y: 228.92,
    width: 0.23,
    height: 1.93,
    transform: "translate(575.92 -116.14) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.06,230v-.22h0l1.93,0h0V230h0Zm0,0,1.93,0,0,0v-.23l0,0-1.93,0h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.53,237a8.86,8.86,0,0,1-3.8-.12,13.24,13.24,0,0,0-3.14.2,24.56,24.56,0,0,1-2.68.57,15.35,15.35,0,0,1-3-.14,16.22,16.22,0,0,0-2.95-.16,22.84,22.84,0,0,1-3,.3,14.86,14.86,0,0,1-2.63-.65,9.92,9.92,0,0,0-3-.18,25,25,0,0,1-5.53.19c-.1,0-.06-.17,0-.16a11.12,11.12,0,0,0,2.7.06,22.39,22.39,0,0,1,5.84-.54,16.14,16.14,0,0,1,2.78,0,14.23,14.23,0,0,0,2.83.29c.9-.05,1.79-.22,2.69-.25a10.33,10.33,0,0,1,2.54.38,7.3,7.3,0,0,0,2.74-.33,8,8,0,0,1,2.24,0c.71.1,1.43.25,2.14.36a22.33,22.33,0,0,0,3.06.06A.07.07,0,0,1,367.53,237Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.35,239.05l-.17,0s-.06,0-.18,0h0a1.66,1.66,0,0,1-.32,0c-.73.09-1.46.18-2.2.23a19.35,19.35,0,0,1-2.85-.07c-1.87-.17-3.77-.05-5.64-.05-.07,0-.07-.1,0-.11,1,0,2-.05,3-.06a3.29,3.29,0,0,1,1.23-.28,4.1,4.1,0,0,0,1.35.12c.35-.06.68-.2,1-.23a10,10,0,0,1,2.24.26,13.7,13.7,0,0,0,2.48,0A0,0,0,0,1,365.35,239.05Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.24,
    y: 230.15,
    width: 1.66,
    height: 2.18,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.94,
    y: 230.15,
    width: 1.3,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.24,
    y: 229.41,
    width: 1.84,
    height: 0.74,
    transform: "translate(786.33 459.56) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.09,229.41l-1.85,0,0,0v.74l0,0,1.85,0h0Zm0,0v.74h0l-1.85,0h0v-.8h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.8,
    y: 229.41,
    width: 1.44,
    height: 0.74,
    transform: "translate(783.05 459.56) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.43 245.4 399.39 245.4 399.97 239.12 386.43 239.12 386.43 245.4",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.43 239.11 381.78 233.28 378.07 239.11 378.65 245.39 386.43 245.39 386.43 239.11",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.2,239.58h.8c.23,0,3.67-5.92,3.83-5.92s2.51,4.44,3.18,5.5,1.42,1.09,2.67,1.09h12.9c.71,0,1-.82.9-1.33l0-.12c-.2-.48-3.73-4.59-4.67-5.75s-1.41-1.61-1.86-1.61h-12.6a1.17,1.17,0,0,0-1,.48c-1.16,1.53-3.82,6.27-4.15,6.81S377,239.58,377.2,239.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.2,239.58H378c.09,0,.13-.09.19-.15.2-.27.38-.55.56-.84l1.07-1.72,1.06-1.72.54-.86.28-.42a1,1,0,0,1,.16-.2c.08,0,.12.12.17.18.71,1.15,1.34,2.34,2,3.52.33.59.66,1.18,1,1.75a2.51,2.51,0,0,0,.67.74,2,2,0,0,0,.94.34c.67.07,1.34,0,2,0h10.12c.67,0,1.36,0,2,0a.92.92,0,0,0,.64-.67.94.94,0,0,0-.14-.93c-1.62-2.15-3.42-4.17-5.12-6.26a4.39,4.39,0,0,0-.74-.69.83.83,0,0,0-.45-.17H382.31a1.16,1.16,0,0,0-.89.4c-.21.26-.4.54-.59.82-.74,1.13-1.43,2.29-2.11,3.45l-1,1.75-.51.88a1.26,1.26,0,0,0-.2.46C376.94,239.36,377,239.59,377.2,239.58Zm0,0c-.19,0-.26-.22-.22-.37a1.48,1.48,0,0,1,.21-.46l.51-.88,1-1.75c.68-1.17,1.37-2.33,2.11-3.46.19-.28.37-.56.58-.83a1.2,1.2,0,0,1,.91-.4H395a1,1,0,0,1,.48.18,4,4,0,0,1,.74.69c1.72,2.09,3.51,4.11,5.15,6.26a1,1,0,0,1,.15,1,1,1,0,0,1-.7.72c-.68.05-1.35,0-2,0H388.63a19.65,19.65,0,0,1-2-.05,2.06,2.06,0,0,1-1-.34,2.4,2.4,0,0,1-.67-.75c-.36-.58-.68-1.17-1-1.76-.66-1.18-1.29-2.37-2-3.52,0-.06-.09-.16-.15-.18a1.73,1.73,0,0,0-.15.2l-.28.42-.54.86-1.06,1.72-1.07,1.72c-.19.28-.37.56-.57.84-.06,0-.1.15-.19.15h-.76Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.2,239.58h.8c.23,0,3.67-5.92,3.83-5.92s2.51,4.44,3.18,5.5,1.42,1.09,2.67,1.09h12.9c.71,0,1-.82.9-1.33a1.66,1.66,0,0,1-.38.32,7.68,7.68,0,0,1-3.27.21c-1.22-.13-2.42-.32-3.64-.36a26,26,0,0,0-3.94.14c-1.2.14-2.55.43-3.69-.15-1.65-.85-2-3-2.79-4.53a15.55,15.55,0,0,0-.82-1.43,3.64,3.64,0,0,0-.82-1,1.13,1.13,0,0,0-.78-.19c-1.16,1.53-3.82,6.27-4.15,6.81S377,239.58,377.2,239.58Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.93,
    y: 237.07,
    width: 2.05,
    height: 2.93,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,240l-2.05,0h0v-3H383v0Zm0,0,0-2.93,0,0h-2.05l0,0,0,2.93,0,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.19,
    y: 237.31,
    width: 0.66,
    height: 1.11,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.85,237.31v.07c-.63.05-.64.84-.64,1h0v-1.11Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.07,
    y: 237.31,
    width: 0.66,
    height: 1.11,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.73,237.31v.07c-.62.05-.63.84-.63,1h0v-1.11Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.19,
    y: 238.64,
    width: 0.66,
    height: 1.11,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.85,238.64v.07c-.63,0-.64.84-.64,1h0v-1.11Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.07,
    y: 238.64,
    width: 0.66,
    height: 1.11,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.73,238.64v.07c-.62,0-.63.84-.63,1h0v-1.11Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.94,
    y: 241.45,
    width: 2.05,
    height: 2.93,
    transform: "translate(793.93 485.83) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.94,244.38l2.05,0,0,0,0-2.93,0,0h-2.05l0,0Zm0,0,0-2.93v0H398v3h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.08,
    y: 241.69,
    width: 0.66,
    height: 1.11,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.08,241.69v.07c.62.05.63.84.63,1h0v-1.11Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.19,
    y: 241.69,
    width: 0.66,
    height: 1.11,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.19,241.69v.07c.62.05.64.84.63,1h0v-1.11Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.08,
    y: 243.02,
    width: 0.66,
    height: 1.11,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.08,243v.07c.62,0,.63.84.63,1h0V243Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.19,
    y: 243.02,
    width: 0.66,
    height: 1.11,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.19,243v.07c.62,0,.64.84.63,1h0V243Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.41,
    y: 241.45,
    width: 2.05,
    height: 2.93,
    transform: "translate(778.86 485.83) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.41,244.38l2,0,0,0,0-2.93,0,0h-2l0,0Zm0,0,0-2.93v0h2.11v3h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.55,
    y: 241.69,
    width: 0.66,
    height: 1.11,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.55,241.69v.07c.62.05.63.84.63,1h0v-1.11Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.66,
    y: 241.69,
    width: 0.66,
    height: 1.11,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.66,241.69v.07c.62.05.63.84.63,1h0v-1.11Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.55,
    y: 243.02,
    width: 0.66,
    height: 1.11,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.55,243v.07c.62,0,.63.84.63,1h0V243Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.66,
    y: 243.02,
    width: 0.66,
    height: 1.11,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.66,243v.07c.62,0,.63.84.63,1h0V243Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.16,233.55h3a14.14,14.14,0,0,1,1.33,1.65c.06.09,0,.25-.4.25H391.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.42 235.12 392.42 237.44 394.07 237.44 394.07 235.12 393.25 234.09 392.42 235.12",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.42 235.12 391.12 235.12 392.42 237.44 392.42 235.12",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.82,
    y: 235.16,
    width: 0.94,
    height: 1.59,
    transform: "translate(786.58 471.91) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.82,236.75h.93l0-1.59,0,0h-.94l0,0Zm0,0,0-1.59v0h1v0l0,1.59h-.95Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.34,
    y: 235.27,
    width: 0.3,
    height: 0.51,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.34,235.27v0c.29,0,.29.39.29.48h0v-.51Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.94,
    y: 235.27,
    width: 0.3,
    height: 0.51,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.94,235.27v0c.28,0,.29.39.29.48h0v-.51Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.34,
    y: 235.87,
    width: 0.3,
    height: 0.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.34,235.87v0c.31.11.25.43.27.71h0v-.76Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.94,
    y: 235.87,
    width: 0.3,
    height: 0.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.94,235.87v0c.31.11.25.43.27.71h0v-.76Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.21,
    y: 241.3,
    width: 2.26,
    height: 4.11,
    transform: "translate(786.68 486.71) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.21,245.41l2.26,0v0l0-4.11,0,0-2.26,0,0,0Zm0,0,0-4.11v0h2.32v0l0,4.11h-2.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.1,
    y: 241.58,
    width: 0.49,
    height: 0.61,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.1,241.58v0a.61.61,0,0,1,.41.58h.07v-.62Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.46,
    y: 241.58,
    width: 0.49,
    height: 0.61,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.46,241.58v0a.61.61,0,0,1,.42.58H393v-.62Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.83,
    y: 244.28,
    width: 1.03,
    height: 0.15,
    transform: "translate(786.68 488.71) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.74,
    y: 241.58,
    width: 0.49,
    height: 0.61,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.74,241.58v0a.61.61,0,0,1,.41.58h.07v-.62Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.1,
    y: 242.36,
    width: 0.49,
    height: 0.61,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.1,242.36v0a.61.61,0,0,1,.41.58h.07v-.62Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.46,
    y: 242.36,
    width: 0.49,
    height: 0.61,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.46,242.36v0a.61.61,0,0,1,.42.58H393v-.62Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.74,
    y: 242.36,
    width: 0.49,
    height: 0.61,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.74,242.36v0a.61.61,0,0,1,.41.58h.07v-.62Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.1,
    y: 243.14,
    width: 0.49,
    height: 0.61,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.1,243.14v0a.61.61,0,0,1,.41.58h.07v-.61Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.46,
    y: 243.14,
    width: 0.49,
    height: 0.61,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.46,243.14v0a.61.61,0,0,1,.42.58H393v-.61Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.74,
    y: 243.14,
    width: 0.49,
    height: 0.61,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.74,243.14v0a.61.61,0,0,1,.41.58h.07v-.61Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.83 245.4 383.68 245.4 384.08 242.18 377.83 242.18 377.83 245.4",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.83 242.18 374.62 239.18 372.06 242.18 372.46 245.4 377.83 245.4 377.83 242.18",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.56,242.23h.55c.15,0,2.53-3,2.64-3s1.73,2.28,2.19,2.83,1,.56,1.84.56h5.33a.58.58,0,0,0,.62-.68s0,0,0-.06c-.13-.25-2.57-2.37-3.21-3s-1-.83-1.29-.83h-5.12a.91.91,0,0,0-.67.25c-.8.79-2.63,3.22-2.86,3.5S371.42,242.23,371.56,242.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.56,242.23h.52c.16-.06.26-.23.38-.35l.67-.8,1.34-1.61.17-.2.1-.09a.33.33,0,0,1,.11.09l.33.41.63.83c.43.55.82,1.14,1.29,1.65s1.31.38,2,.4h4.18a7.1,7.1,0,0,0,1,0c.32-.07.55-.53.29-.76-1-1-2.06-1.89-3.09-2.83a6.31,6.31,0,0,0-.8-.67,1,1,0,0,0-.47-.19h-4.71a1.74,1.74,0,0,0-1,.16,8.51,8.51,0,0,0-.71.76c-.46.53-.89,1.08-1.32,1.63l-.65.82-.32.41a.72.72,0,0,0-.12.23A.15.15,0,0,0,371.56,242.23Zm0,0c-.09,0-.19-.07-.16-.17a.47.47,0,0,1,.12-.23l.32-.41.64-.83c.43-.55.86-1.1,1.31-1.63a7.46,7.46,0,0,1,.72-.77,1.7,1.7,0,0,1,1-.16h4.71a1.09,1.09,0,0,1,.5.19,7.46,7.46,0,0,1,.8.67c1,.94,2.11,1.83,3.11,2.82.3.29,0,.79-.32.87a7.51,7.51,0,0,1-1.06,0h-4.18c-.35,0-.7,0-1,0a1.54,1.54,0,0,1-1-.4c-.48-.52-.86-1.1-1.29-1.65l-.63-.84c-.11-.14-.21-.28-.33-.41s-.06-.07-.09-.08l-.09.09-.17.19-1.34,1.61-.68.8c-.12.12-.22.28-.38.34Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.56,242.23h.55c.15,0,2.41-2.93,2.52-2.93s1.85,2.17,2.31,2.72,1,.56,1.84.56h5.33a.58.58,0,0,0,.62-.68,1.2,1.2,0,0,1-.27.16,7,7,0,0,1-2.25.11c-.84-.07,1.9-.16,1.06-.19a22.47,22.47,0,0,0-2.72.08A5.87,5.87,0,0,1,378,242c-1.14-.44-1.41-1.54-1.93-2.33a6.43,6.43,0,0,0-.56-.73,1.86,1.86,0,0,0-.56-.52,1,1,0,0,0-.55-.1c-.8.79-2.63,3.22-2.86,3.5S371.42,242.23,371.56,242.23Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.74,245.25a41.43,41.43,0,0,1-7.12.55c-1.11,0-2.22.08-3.32.21a20.1,20.1,0,0,1-3.18-.23c-1.06,0-2.28.22-3.32.11a19.08,19.08,0,0,0-3.38,0c-2.23.17-3.38-.65-6.53-.2a45,45,0,0,1-6.77,0,.09.09,0,0,1,0-.17l1.95-.08c2.29-.18,4.57-.33,6.86-.46a22.2,22.2,0,0,1,3.16-.08c1,.08,2.07.36,3.13.36,2,0,3.88-.94,5.89-.59a11.44,11.44,0,0,0,3.19.4,21.73,21.73,0,0,1,3.12-.23c2.11.07,4.19.51,6.31.28C402.8,245.12,402.81,245.24,402.74,245.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.57,247.36a44.87,44.87,0,0,1-6.66.16l-7-.08h.58c1.11,0,1.65-.09,2.76-.08h.06c.57-.06,1.1-.24,1.66-.34a2.37,2.37,0,0,1,1.09.05,4.28,4.28,0,0,0,1.71.06,19.3,19.3,0,0,1,2.72.28c1,0,2.07-.09,3.1-.11C407.6,247.29,407.61,247.36,407.57,247.36Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,247.19l-.44,0c-.26,0-.56,0-.82,0h-6.59a0,0,0,1,1,0-.06l1.79,0a3.3,3.3,0,0,0,.52-.13,3.26,3.26,0,0,1,.71-.22,2.69,2.69,0,0,1,.49,0,4.13,4.13,0,0,0,1.11,0,3.79,3.79,0,0,1,1.37.19,8,8,0,0,0,1.09.16c.14,0,.28,0,.41,0H387A0,0,0,1,1,387,247.19Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.89,246.82l-.19,0c-.12.11-1.07,0-1.2,0-.37,0-.72.11-1.08.1s-.72-.13-1.09-.13-.76,0-1.14.06a0,0,0,0,1,0-.08l1-.06a5.85,5.85,0,0,1,.71-.12c.37,0,.7.11,1.07.06a2.48,2.48,0,0,1,.72,0c.2,0,.4.09.59.12a2.38,2.38,0,0,1,.36,0h.22S395.93,246.81,395.89,246.82Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mountains--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.44,264.05H500V205.33s-13.52-10.42-25.94-5.64-18.58,12.43-27,15.48-38.15,7.05-45.24,13.25-16.85,20.1-23.94,21.58S336.44,264.05,336.44,264.05Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482,197.61c-1.4.11-11.3,1.43-12.55,2.08s-8.78,6.15-9.59,6.73-6.56,4.64-7.3,5.27-8.8,3.79-9.3,4-10.25,3-11.17,3.16.64,1.83.79,1.75a86.35,86.35,0,0,1,8.64-1.17c1.08.08,5.47,5.27,5.47,5.27a10,10,0,0,0,4.09,1.55c2.58.41,3.82,5.48,4.65,5.73s7.07-2.24,8.11-3.4,4.61-11.31,5-11.81,1.25-.5,2.16-.83,2,3.41,3,3.66,1.42,2,2.75,2.08,6.57-4.33,7.4-5.08,2.82-.74,3.65-.66,2.66,1.41,3.08,1.16,2.41-2.41,2.66-2.66.08-4.24.33-5.23.34-.84,2.25-.5,2.63.33,3.24-.17-.92-4.26-1.8-4.78-6-3.53-6.76-4.2S483.18,197.52,482,197.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.87,232.33a.71.71,0,0,1-.23,0c-.43-.13-.73-.69-1.31-1.84-.77-1.54-1.82-3.64-3.3-3.88a10.22,10.22,0,0,1-4.25-1.62c-2.12-2.49-4.7-5.14-5.28-5.2-1-.07-8,1-8.48,1.15-.19.11-.43-.06-.51-.12s-1.22-1.1-1.06-1.82a.7.7,0,0,1,.57-.53c.94-.2,10.69-3,11.14-3.15.69-.23,8.53-3.34,9.17-3.88s4-2.91,6-4.35l1.32-.94.27-.2c5.36-3.88,8.59-6.15,9.37-6.56,1.37-.72,11.59-2,12.7-2.12s8.24,1.25,9.09,2c.63.57,4.85,3.06,6.24,3.88l.46.27c.85.51,2,3.18,2.12,4.48a1,1,0,0,1-.27.92c-.74.6-1.57.59-3.55.25l-.64-.12a3.43,3.43,0,0,0-1-.12,1.55,1.55,0,0,0-.15.46,19.51,19.51,0,0,0-.16,2.76c0,2.1-.07,2.45-.28,2.65l-.36.38a21.46,21.46,0,0,1-2.37,2.33c-.38.24-.91,0-1.88-.51a5.6,5.6,0,0,0-1.42-.6c-1-.09-2.71,0-3.37.57-.06.06-6,5.25-7.68,5.17a2.76,2.76,0,0,1-1.9-1.28,2.1,2.1,0,0,0-.91-.81c-.62-.16-1.11-1-1.67-2.06-.3-.55-.86-1.57-1.11-1.61a7.75,7.75,0,0,1-.92.27,2.06,2.06,0,0,0-1.07.45c-.15.21-.82,1.95-1.48,3.64-1.63,4.19-2.92,7.46-3.56,8.18C463.11,229.92,457.4,232.33,455.87,232.33Zm-8.58-7.91a10.28,10.28,0,0,0,3.86,1.42c1.85.3,3,2.6,3.85,4.29a6.38,6.38,0,0,0,.87,1.46c.69.14,6.69-2.17,7.7-3.3.6-.67,2.3-5.06,3.42-8a30.41,30.41,0,0,1,1.6-3.84,2.57,2.57,0,0,1,1.47-.7,7,7,0,0,0,.85-.24c.78-.28,1.36.75,2,1.95.35.64.89,1.62,1.19,1.69a2.64,2.64,0,0,1,1.32,1.07c.4.49.78,1,1.36,1h0c1,0,5.43-3.47,7.1-5,1.14-1,3.83-.78,3.94-.76a5.55,5.55,0,0,1,1.69.67,7.26,7.26,0,0,0,1.22.52c.22-.15,1.62-1.63,2.15-2.19l.33-.35a18.13,18.13,0,0,0,.1-2.18,18.89,18.89,0,0,1,.18-2.93c.3-1.21.74-1.13,2-.89l.63.12c1.86.32,2.46.3,2.94-.09.23-.45-1-3.72-1.75-4.17l-.46-.27c-2.64-1.56-5.75-3.43-6.36-4s-7.41-1.91-8.54-1.82l0-.37,0,.37c-1.65.13-11.27,1.45-12.4,2.05-.43.22-2.19,1.36-9.28,6.5l-.27.2-1.33.94c-1.89,1.34-5.4,3.84-5.94,4.31-.83.71-9.08,3.91-9.43,4s-10.27,3-11.21,3.16c0,.17.49.8.75,1a86.22,86.22,0,0,1,8.63-1.15c1.14.09,4.67,4.15,5.73,5.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.6,243.5S298.74,227.15,288.05,222s-43.84-8.6-54.93-14.76-45.57-28.79-52.46-33.86c-3.82-2.81-21.63-9-34.59-15.87-10.43-5.5-15.67-12-23.54-12.76-17.67-1.67-49.75,15.4-52.54,18.81a184.13,184.13,0,0,1-14.41,15.49c-2.92,2.8-33.94,19.56-40.45,32C3.66,233.1,0,243.5,0,243.5Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.54,157a28.09,28.09,0,0,0-10.35,7.62c-1.57,1.85-.77,4.54,1.72,4.37s7.73-2.84,10.39-2.85,5.92,7.71,9.16,8a31.2,31.2,0,0,0,8.14-.67c1.83-.25,6.74-.26,6.74-.26l5.33,6s6.41,2.57,8,2.48,8.65,3.48,8.65,3.48l4.41,3.65s11.13-3.35,11.72-3.76,1-2.33,1.57-3.16,11.73,4.46,11.73,4.46,6.83,8.8,8.41,9.13a73.71,73.71,0,0,0,8.82.74c.91-.09,1.74-3.58,1.74-3.58s-1.19-12,0-13,7.71-3.59,7.76-4.46-8.53-7.76-10.52-8.67S148.4,157,146.07,155.54s-16.93-14.63-20.21-15.46S102,141.54,101,142.87s-8,6.58-9.38,7.16S79.54,157,79.54,157Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.68,196.66a79.25,79.25,0,0,1-8.6-.75c-1.61-.33-7.31-7.56-8.58-9.2-4.88-2.31-10.32-4.58-11.23-4.48a8.9,8.9,0,0,0-.61,1.36,4.13,4.13,0,0,1-1,1.82c-.6.43-10,3.26-11.82,3.82l-.19.06-4.57-3.78c-2.74-1.37-7.3-3.46-8.39-3.39-1.6.09-7.49-2.24-8.15-2.51l-.14-.1-5.22-5.85c-.87,0-4.92,0-6.51.26l-1.27.2a25.24,25.24,0,0,1-7,.48c-1.82-.19-3.53-2.36-5.18-4.46-1.39-1.76-2.83-3.58-3.94-3.58h0A20.58,20.58,0,0,0,75.77,168a21.74,21.74,0,0,1-4.83,1.36A2.6,2.6,0,0,1,68.3,168a3.32,3.32,0,0,1,.6-3.61,28.68,28.68,0,0,1,10.47-7.72c.74-.44,10.75-6.43,12.15-7s8.36-5.78,9.21-7c1.12-1.64,22.32-3.67,25.22-2.94,2.23.56,9,6.25,14.5,10.82,2.7,2.26,5,4.21,5.81,4.68,1.54.93,12.41,5.26,19.61,8.13,3.65,1.45,6.54,2.6,7.2,2.91,1.38.63,10.81,7.73,10.75,9,0,.63-1.12,1.25-4.58,2.94a24.29,24.29,0,0,0-3.31,1.78c-.63.57-.41,7,.15,12.65v.06l0,.06c-.27,1.13-1,3.77-2.07,3.87Zm-28.44-15.14c.94,0,3.61.73,11.66,4.55l.14.11c2.61,3.36,7.14,8.78,8.19,9a73.1,73.1,0,0,0,8.7.72c.3,0,1-1.44,1.4-3.23-.29-2.92-1.1-12.19.11-13.23a23.18,23.18,0,0,1,3.47-1.88,22.55,22.55,0,0,0,4.14-2.31c-.58-1.14-8.33-7.42-10.29-8.31-.65-.3-3.53-1.44-7.17-2.89-7.65-3.05-18.13-7.22-19.72-8.19-.83-.5-3.07-2.37-5.9-4.74-5.13-4.29-12.14-10.16-14.21-10.68-3.67-.92-23.44,1.61-24.41,2.65-.95,1.38-8,6.65-9.54,7.29-1.37.57-12,6.92-12.08,7l-.06,0c-5.39,2.06-9.44,6.62-10.2,7.51a2.64,2.64,0,0,0-.5,2.79,1.87,1.87,0,0,0,1.92,1,21.4,21.4,0,0,0,4.63-1.32,20.88,20.88,0,0,1,5.78-1.52h0c1.48,0,3,1.88,4.52,3.87s3.17,4,4.68,4.17a25.13,25.13,0,0,0,6.76-.46q.72-.13,1.29-.21c1.84-.26,6.59-.27,6.79-.27h.17l5.38,6c1.82.73,6.54,2.51,7.74,2.42,1.67-.07,8.11,3.15,8.85,3.51l4.32,3.57c4.24-1.27,10.93-3.34,11.42-3.65a4.62,4.62,0,0,0,.74-1.49,8.33,8.33,0,0,1,.74-1.58C144.76,181.65,144.85,181.52,145.24,181.52Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500,243v56H375A56,56,0,0,0,395.55,276c3.06-6.32,25.77-16.65,27.85-18.65,4.64-4.46,9.25-12.78,11.24-15.21a5.17,5.17,0,0,1,.95-.82.1.1,0,0,1,.06-.05c5-3.64,25-13.62,36.42-12.54,5.61.53,9.35,5.18,16.77,9.09C492.31,239.6,496.27,241.37,500,243Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500,241v21.61c-1.69-1.88-3.55-4.28-3.55-4.28s-7.94-3.78-8.36-3.19-.71,2-1.12,2.25-8.35,2.69-8.35,2.69l-3.14-2.61s-5-2.53-6.16-2.47-5.69-1.77-5.69-1.77l-3.8-4.26s-3.5,0-4.8.19a22.24,22.24,0,0,1-5.8.48c-2.31-.24-4.63-5.73-6.53-5.73s-5.62,1.91-7.4,2-2.35-1.8-1.23-3.11a20.38,20.38,0,0,1,1.52-1.58.1.1,0,0,1,.06-.05,18.37,18.37,0,0,1,5.79-3.8s7.64-4.58,8.64-5a37,37,0,0,0,6.69-5.11c.65-.95,15.33-2.57,17.68-2s12.73,10,14.39,11C489.76,236.91,495.16,239.09,500,241Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.38,263.6l-.66-.72c-1.52-1.69-3.19-3.82-3.51-4.23-3.34-1.59-7.09-3.16-7.87-3.18a5,5,0,0,0-.39.89,3.17,3.17,0,0,1-.76,1.35c-.42.3-6.06,2-8.46,2.75l-.19.05-3.3-2.74c-1.84-.91-5.18-2.39-5.9-2.38h-.07c-1.26,0-5.31-1.61-5.78-1.8l-.14-.09-3.69-4.14c-.71,0-3.48,0-4.58.19-.26,0-.56.09-.9.14a18.15,18.15,0,0,1-5,.34c-1.34-.14-2.57-1.7-3.77-3.21-1-1.24-2-2.52-2.72-2.52a14.59,14.59,0,0,0-3.9,1,15.77,15.77,0,0,1-3.47,1,2,2,0,0,1-2-1,2.46,2.46,0,0,1,.45-2.69,20.61,20.61,0,0,1,1.49-1.56l0-.08.11-.05a18.48,18.48,0,0,1,5.88-3.84c.25-.16,7.61-4.57,8.63-5a37.25,37.25,0,0,0,6.52-5c.82-1.19,15.8-2.7,18.08-2.14,1.49.38,5.57,3.72,10.34,7.72,1.93,1.62,3.6,3,4.15,3.34.91.55,6.41,2.77,11.11,4.65l.24.09Zm-12.13-8.86c.74,0,2.69.57,8.36,3.27l.14.11s1.42,1.83,2.87,3.51V241.27c-4.94-2-10.05-4-11-4.6-.6-.37-2.2-1.71-4.24-3.42-3.42-2.86-8.6-7.2-10-7.56-2.51-.62-16.43,1.09-17.3,1.86a36.18,36.18,0,0,1-6.84,5.22c-.77.32-6,3.39-8.59,5a17.94,17.94,0,0,0-5.72,3.75l-.08.06a18.26,18.26,0,0,0-1.47,1.54A1.72,1.72,0,0,0,434,245a1.19,1.19,0,0,0,1.26.63,15.3,15.3,0,0,0,3.28-.94,15.24,15.24,0,0,1,4.15-1.09c1.11,0,2.18,1.36,3.31,2.8s2.23,2.83,3.26,2.93a17.29,17.29,0,0,0,4.79-.33l.92-.15c1.31-.18,4.71-.19,4.85-.19H460l3.85,4.32a26.89,26.89,0,0,0,5.4,1.71h.1c1.23,0,5.45,2.09,6.3,2.51l3.05,2.53c3-.9,7.66-2.35,8.06-2.58a4.3,4.3,0,0,0,.49-1,6.17,6.17,0,0,1,.53-1.15C487.84,254.86,487.92,254.74,488.25,254.74Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.35,266.61c-1,.5-4.32,4.16-6,6s-11,.65-12.42,0-11.36-2.51-14.35-2.17c-2.68.3-10.53.67-13.7,1.76,7.25-6,22.8-13.26,24.5-14.9a33.53,33.53,0,0,0,3.13-3.54,25.3,25.3,0,0,1,3.69,1.94c1.66,1.23,8.65.44,11.31,2.6S446.35,266.11,445.35,266.61Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.42,264.05c-2.63-2.36-28.33-20.53-37.78-27.18s-42-14-47.21-23.68-33.05-52.95-43.92-58.36S62.45,142.51,54.58,143,30.45,157.67,25.2,162.92.2,175.53.2,175.53v88.52H232.42",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.76,166.43c1-.7,17.4-1.74,19.56-3.4s11-1,11.47-.5S57.94,176,57.94,176s5.82,1.73,7,2.52,8,4.13,8,4.13,7.15,12.64,9.14,13.64,8.48-11.65,8.48-11.65,4.16-8.31,5.16-9.64,4.65-1.29,4.65-1.29,1.77,4.68,2.88,4.81,4.09,2.46,5.09,2.13,3.66-4,4-4.65a50,50,0,0,0,1.16-4.89s4.49,4.57,5.32,4.89,2,2.29,3.16,2-4.65-9.29-5.49-11.45-6.48-9.15-9.31-11.64-16.28-6.49-18.44-8-30.76-9-32.42-8.48-12.93,6.16-13.62,8-9.82,9.81-11.65,11S20.76,166.43,20.76,166.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.24,196.7a.76.76,0,0,1-.36-.08c-2-1-8.28-12-9.24-13.69-.9-.44-6.82-3.34-7.93-4.1a48.24,48.24,0,0,0-6.88-2.47l-.17-.05-.07-.16c-2.13-4.89-5.66-12.86-6.08-13.37-.69-.39-9-1-11,.55-1.3,1-6.53,1.68-13.23,2.47a49.61,49.61,0,0,0-6.34.94l-3.05,1.84,2.58-2.42c.34-.32,8.46-7.93,10.3-9.1,2-1.29,10.89-9.14,11.5-10.79.79-2.1,12.54-7.81,13.86-8.21,1.74-.5,30.5,7,32.75,8.53a50.42,50.42,0,0,0,6.74,2.77c4.69,1.74,10,3.72,11.73,5.24,2.74,2.41,8.54,9.51,9.42,11.78.28.73,1.2,2.36,2.17,4.08,2.67,4.71,3.74,6.8,3.43,7.54a.53.53,0,0,1-.38.33c-.94.26-1.8-.57-2.48-1.24a3.9,3.9,0,0,0-.9-.74c-.74-.29-3.66-3.17-5-4.48a35.94,35.94,0,0,1-1.06,4.3c-.3.62-3,4.44-4.2,4.84-.69.22-1.74-.32-3.26-1.17a8.08,8.08,0,0,0-2-.94c-1.16-.14-2.56-3.46-3.09-4.82-1.11,0-3.43.25-4.09,1.14-1,1.29-5.08,9.51-5.12,9.59C89.38,187.7,84.57,196.7,82.24,196.7Zm-24-21c1,.3,5.83,1.77,6.93,2.52s7.86,4.06,7.93,4.1l.11.05,0,.1c2.85,5,7.6,12.8,9,13.49,1,.5,4.93-5.54,8-11.48.17-.34,4.18-8.36,5.19-9.7s4.55-1.44,5-1.44h.25l.09.24c.92,2.43,2.09,4.53,2.57,4.58a8,8,0,0,1,2.27,1c.9.5,2.25,1.26,2.66,1.11.82-.27,3.45-3.79,3.77-4.45a42.14,42.14,0,0,0,1.13-4.81l.14-.7.5.51a45.7,45.7,0,0,0,5.19,4.81,4.23,4.23,0,0,1,1.15.91c.54.52,1.16,1.1,1.65,1.07,0-.87-2.12-4.56-3.39-6.8-1-1.82-1.92-3.39-2.23-4.18-.78-2.05-6.29-8.92-9.2-11.49-1.62-1.43-7.1-3.46-11.5-5.09a50.55,50.55,0,0,1-6.91-2.86c-2.12-1.47-30.31-8.86-32.1-8.43-2.06.62-12.79,6.2-13.38,7.76-.75,2-10.1,10.07-11.8,11.16-1.4.88-6.82,5.88-9.13,8,1-.17,2.68-.37,5.15-.66,4.91-.58,11.63-1.38,12.86-2.33,2.21-1.69,11.17-1.26,12-.47C52.56,162.76,56.8,172.46,58.21,175.69Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.44,279.68s-11.36-18.69-15.69-24c-1.58-1.93-13.52-7.73-18.12-10.86-5.87-4-11.38-11.9-13.75-15.7-3.75-6-22.7-16.49-28-17s-24.61,11.07-25.94,17.39-12,28.26-20.29,34.91A91.48,91.48,0,0,0,156,279.68Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.05,258.78c-2.7.62-8.69-.07-10.17-.54-1.77-.55-6-4.43-8.09-5.54s-18.18-6.76-20.38-7.87-22.07-6-23.19-9.53-1.1-10.31,0-12.3l.64-10.73c6.36,1.52,23.48,11.21,27,16.86,2.37,3.8,7.88,11.71,13.75,15.7,4.6,3.13,16.54,8.93,18.12,10.86C277.39,256.47,278.17,257.53,279.05,258.78Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.63,231.2c.11-.89.44-5.77,1-7.32s10.77-8.87,12.25-9.75,6.15-1,7-1.33,5.88-2,6.77-2.11,14.74,6.32,17.18,7.65,6.07,5.87,6.62,6.32S235.3,224,233,223s-6.76-3.88-10.64-3.32-5.88,4.32-6.21,5.32,0,5.43-.44,6.65a50.44,50.44,0,0,1-4.77,7.2c-.89,1-.55,3.55-3.1,5.1s-2.55-5.1-3.55-8.31-2.55-7.09-2.55-7.09-3.66,4.1-4.77,5.21-.55,5-.77,6.2-4,7.54-5.32,8.43-1.22-3.33-.78-5.77-2-5.36-2-5.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.51,248.87a.74.74,0,0,1-.41-.12c-1.11-.73-.65-4.83-.4-6.2.41-2.24-1.87-5-1.9-5.06l-.12-.15,1.58-6.21c0-.2.05-.55.1-1a38.35,38.35,0,0,1,.91-6.38c.63-1.75,11.19-9.22,12.42-9.95,1-.6,3.26-.85,5.06-1.06a13.28,13.28,0,0,0,2-.3c.77-.28,5.89-2,6.85-2.12,1.14-.14,15.69,6.75,17.41,7.69,1.87,1,4.41,3.86,5.78,5.39.42.47.78.88.9,1l.25.21-.13.34c-.45.74-6.78-1-8-1.58-.49-.21-1.07-.5-1.72-.83-2.43-1.22-5.76-2.89-8.72-2.47-3.67.52-5.59,4.13-5.9,5.07a14.62,14.62,0,0,0-.16,2.82,16.08,16.08,0,0,1-.29,3.84,50.68,50.68,0,0,1-4.84,7.32,3.9,3.9,0,0,0-.57,1.35,6,6,0,0,1-2.62,3.82,1.47,1.47,0,0,1-1.41.18c-1.18-.54-1.58-2.91-2-5.42a26.11,26.11,0,0,0-.68-3.28c-.76-2.44-1.85-5.31-2.32-6.5-1,1.1-3.48,3.88-4.37,4.77-.65.65-.63,2.69-.61,4.17a12.19,12.19,0,0,1-.06,1.84c-.24,1.31-4,7.7-5.48,8.67A1,1,0,0,1,190.51,248.87Zm-2-11.71c.51.65,2.36,3.24,1.94,5.52-.49,2.71-.3,5.27.08,5.44a.27.27,0,0,0,.12-.05c1.27-.85,5-7.13,5.16-8.18a11.81,11.81,0,0,0,0-1.7c0-1.71,0-3.84.83-4.71,1.09-1.09,4.71-5.15,4.75-5.19l.4-.46.23.57s1.57,3.93,2.56,7.12a28.15,28.15,0,0,1,.7,3.38c.34,2,.77,4.48,1.58,4.86.07,0,.28.12.71-.14a5.19,5.19,0,0,0,2.29-3.39,4.24,4.24,0,0,1,.73-1.63,49.33,49.33,0,0,0,4.69-7.09,15.75,15.75,0,0,0,.25-3.58,14.18,14.18,0,0,1,.19-3.06c.43-1.27,2.53-5,6.51-5.57,3.19-.46,6.65,1.27,9.17,2.54.63.32,1.2.6,1.68.81a34.39,34.39,0,0,0,6.52,1.67l-.38-.42c-1.34-1.49-3.82-4.27-5.58-5.23-2.88-1.57-16-7.56-17-7.61-.78.1-5.63,1.7-6.66,2.09a12.06,12.06,0,0,1-2.21.34c-1.63.18-3.88.43-4.76,1-1.9,1.13-11.63,8.25-12.09,9.56a38.2,38.2,0,0,0-.88,6.18c0,.49-.08.86-.1,1.05v0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.52,305.73C281.08,395.58,0,500,0,500L.2,182.45S35.33,167,56,171s45.22,17.23,53.87,26.57,33.51,32.13,47.68,34c9.29,1.24,22.92,7.27,28.8,11.1,4.4,2.87,5.4,8.08,8.55,11.64,1.83,2.07,40.11,5.77,52,12.75,7.72,4.52,27.73,6.85,42.4,9.32C298,283,308.78,293.76,305.52,305.73Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.2,182.45s14.29-7.6,16.29-8.74,14.18-2.91,18.17-3.36,12-5.66,16.19-5.38,28.6,10.2,31.92,11.34,11.09,7.78,12.2,8.44,14.36,7.49,16.15,10.07,2.81,12.32,5.19,15.87,11.69,12.86,13,15.07,14.23,11.09,11.33,14.19-21.41-6.2-24.35-7.53-11.4,1.81-15.82,3.23S91.86,246.18,89,248.5a49.24,49.24,0,0,1-14.41,7.19c-4.84,1.33-10.76,12.13-12.37,14s-13.35-8.66-17.12-12.58-1.22-24.23-6.76-23.85-7.87-11.95-9.2-14.17-11.3,9.76-15.52,11.75S10.72,239.07,8.73,242,0,251.7,0,251.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.63,270.3c-3.31,0-14.18-10.16-16.82-12.91-1.74-1.81-2.17-6.63-2.63-11.73-.54-6-1.11-12.19-3.83-12-4.48.32-6.85-6.7-8.41-11.34a20.9,20.9,0,0,0-1.14-3,.15.15,0,0,0-.13-.09c-1.09-.15-4.54,3.12-7.34,5.75s-5.71,5.35-7.57,6.23c-2.42,1.15-2.88,3.85-3.34,6.45A11.19,11.19,0,0,1,9,242.16C7,245,.54,251.68.27,252l-.65.65.21-70.4.19-.1c.15-.08,14.31-7.61,16.28-8.74,2.15-1.23,15.05-3,18.32-3.4,1.7-.19,4.18-1.29,6.8-2.45,3.44-1.52,7-3.11,9.45-2.94,3.19.21,17.5,5.76,26,9.08,2.87,1.11,5.14,2,6,2.28,2.49.84,7.29,4.62,10.15,6.87,1,.81,1.84,1.44,2.12,1.61s.72.4,1.48.81c6.17,3.33,13.42,7.4,14.79,9.36.88,1.26,1.57,4.09,2.29,7.08.78,3.27,1.67,7,2.9,8.8a103.8,103.8,0,0,0,7.32,8.49,71.45,71.45,0,0,1,5.71,6.6,26.32,26.32,0,0,0,3.53,3.39c3.63,3.18,8.14,7.13,8.27,9.77a1.92,1.92,0,0,1-.52,1.48c-2.47,2.63-13.76-2.24-23.33-6.77-.63-.31-1.13-.54-1.45-.68-2.43-1.1-9.2,1.15-13.67,2.63l-1.87.62c-2.63.84-5.24,4.61-7.54,7.93a25.38,25.38,0,0,1-3.86,4.85,49.14,49.14,0,0,1-14.54,7.26c-3.58,1-7.85,7.47-10.41,11.34-.77,1.17-1.39,2.1-1.77,2.56a1.09,1.09,0,0,1-.82.35ZM38.49,232.9c3.3,0,3.85,6.17,4.44,12.69.42,4.75.86,9.66,2.42,11.28,4.21,4.38,13.78,12.68,16.27,12.68h0a.33.33,0,0,0,.27-.09c.35-.42,1-1.33,1.72-2.49,2.61-4,7-10.58,10.83-11.64a49.3,49.3,0,0,0,14.27-7.12,26.42,26.42,0,0,0,3.72-4.69c2.37-3.43,5.05-7.31,7.92-8.23.56-.18,1.19-.38,1.86-.61,4.86-1.61,11.52-3.83,14.22-2.61l1.46.69c13.31,6.31,20.87,8.64,22.46,6.94a1.18,1.18,0,0,0,.32-.93c-.11-2.32-4.68-6.32-8-9.25A24.27,24.27,0,0,1,129,226a73.66,73.66,0,0,0-5.62-6.48A103.45,103.45,0,0,1,116,210.9c-1.31-2-2.17-5.55-3-9-.71-2.92-1.37-5.68-2.17-6.83-1.44-2.06-11-7.2-14.54-9.13-.78-.42-1.32-.71-1.51-.83s-1.1-.81-2.19-1.66c-2.83-2.22-7.57-5.95-9.93-6.75-.86-.29-3.13-1.17-6-2.29-8.5-3.3-22.74-8.83-25.82-9-2.27-.14-5.74,1.39-9.09,2.87-2.68,1.19-5.21,2.31-7,2.51-4.22.48-16.15,2.22-18,3.31S2.31,181.75.57,182.68l-.19,68.1a111.89,111.89,0,0,0,8-9.05,11,11,0,0,0,1.27-4.2c.46-2.67,1-5.69,3.75-7,1.76-.83,4.61-3.51,7.38-6.1,4.06-3.82,6.64-6.11,8-5.94a.9.9,0,0,1,.67.44,19.8,19.8,0,0,1,1.22,3.16c1.39,4.15,3.75,11.1,7.64,10.83Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.7,364.37c-14.55,12-31.59,23.83-49.86,35.18-7.15-4.45-73.62-53.32-74.67-55.44s-9.46-53.06-9.26-56.71,6.19-20.31,6.19-20.31,5,22,6.65,25.15S157,316,160,318s28.73,14.4,34.83,14.35C199.64,332.3,242,354.82,259.7,364.37Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.67,268.84c-1,1.39-7.28,5.36-10.15,5.36s-13.65-2.1-14-1.88-17.51,7-20.28,7.87-15.52-.22-16-1.55,4.55-20.62,4.56-24.28c1.83,2.07,40.11,5.77,52,12.75A23.76,23.76,0,0,0,250.67,268.84Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.84,399.55c-5.57,3.47-11.27,6.89-17,10.26-11.12,1-19.13-1-23.91-1.42s-23.82-2.28-25.82,3.38-11,9.64-14,11.63-9,5.33-12.8,10c-2.14,2.61-5.59,12.42-8.91,20.89C48.74,481.89,0,500,0,500V288.06l.13,0c1.58.25,17.28,2.79,24.23,5.66a159.89,159.89,0,0,1,20.91,10.95c2.29,1.66,21,15.29,29.3,17.29s21,0,28.27,2.66,28.26,15.3,32.33,19.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.38,500.54v-213l.48.13c1.84.29,17.4,2.8,24.4,5.69a160.61,160.61,0,0,1,21,11l.14.1c6.29,4.56,21.72,15.37,29,17.13,3.79.9,8.58,1,13.22,1.05,5.45.08,11.08.16,15.09,1.62,7.37,2.68,28.3,15.29,32.47,19.56l75.07,55.73-.47.29c-5.27,3.28-11,6.74-17,10.26l-.16.05a78.7,78.7,0,0,1-19.69-.87c-1.64-.24-3.07-.45-4.28-.55l-.84-.07c-15.12-1.25-23.4-.18-24.6,3.2-1.63,4.65-7.7,8.11-11.71,10.4-1,.55-1.8,1-2.39,1.42s-1.13.73-1.8,1.16c-3.11,2-7.8,4.95-10.92,8.75-1.65,2-4.13,8.5-6.76,15.36-.69,1.81-1.39,3.65-2.09,5.43l-.06.13-.13.07C49.56,481.92.62,500.17.13,500.35Zm.76-212v211c5.34-2,52-19.69,106.72-45.47.68-1.73,1.37-3.51,2-5.28,2.65-6.92,5.15-13.46,6.88-15.57,3.2-3.89,8-6.91,11.1-8.9.66-.43,1.27-.81,1.78-1.15s1.46-.89,2.44-1.45c3.92-2.23,9.83-5.61,11.38-10,1.78-5.05,15.33-4.53,25.36-3.69l.84.07c1.24.09,2.67.3,4.33.54a77.59,77.59,0,0,0,19.43.88c5.83-3.4,11.38-6.74,16.49-9.92L135,344.41c-4.06-4.15-25.12-16.83-32.24-19.42-3.88-1.41-9.45-1.49-14.84-1.57-4.68-.08-9.52-.15-13.39-1.08-7.43-1.78-23-12.66-29.29-17.25l-.14-.1a160.42,160.42,0,0,0-20.83-10.9C17.61,291.36,2.76,288.89.38,288.5Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-44"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 453.18,
    cy: 474.86,
    rx: 41.71,
    ry: 7.63,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.8,
    cy: 461.68,
    rx: 34.47,
    ry: 7.63,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 154.39,
    cy: 374.93,
    rx: 21.21,
    ry: 4.69,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.64,
    cy: 320.81,
    rx: 26.28,
    ry: 5.81,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.11,
    cy: 411.8,
    rx: 41.71,
    ry: 7.63,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 449.44,
    cy: 367.34,
    rx: 50.09,
    ry: 7.59,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 437.47,
    cy: 328.4,
    rx: 50.09,
    ry: 7.59,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--trees-1--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M372.19,275.29c.64.64,8.06.92,10.76.92s10.11-.28,10.75-.92-8.35-49.94-10.75-49.94S371.56,274.65,372.19,275.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.05,262.73c1.83.7,8.62,3.46,10.08,4.27,0-.31,0-.62,0-.93q-2.46-1.44-4.93-2.87a58.52,58.52,0,0,1-5.29-3.15c-.09-.06,0-.23.07-.18a43.58,43.58,0,0,1,5.18,2.86c1.67,1,3.32,2,5,3,0-2.37,0-4.73,0-7.09a56.81,56.81,0,0,1-7.74-3.93c-.08-.05,0-.21.07-.17a56.84,56.84,0,0,1,7.67,3.78c0-1.23,0-2.46,0-3.68.07-6.33.08-12.66.24-19-1.61-.81-3.27-1.53-4.88-2.35-.1-.05,0-.23.08-.19,1.64.64,3.21,1.39,4.81,2.1.09-3.27.21-6.53.41-9.79a.09.09,0,0,1,.17,0c.23,6.06.21,12.13.13,18.19,1.67-1.33,3.45-2.51,5.14-3.8.07,0,.13.06.07.11-1.78,1.35-3.44,2.85-5.21,4.2,0,.34,0,.68,0,1,1.81-.82,3.64-1.59,5.47-2.38.15-.06.27.15.13.22-1.86.89-3.72,1.8-5.6,2.64-.05,3-.1,6-.14,9-.07,5.24-.18,10.49-.29,15.73q5.12-2.6,10.31-5c.13-.06.25.13.12.2a110.71,110.71,0,0,1-10.44,5.25c-.09,4.35-.18,8.71-.24,13.07a.21.21,0,0,1-.41,0c.06-5.56.07-11.12.08-16.68A100,100,0,0,1,371.92,263C371.75,263,371.87,262.66,372.05,262.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.32,236.53c1.22.49,2.38-1.12,2.67-2.8s.54-2.69,1.18-3,.87,1.07,2.15.75.41-1.42-.36-3.1-.9-3.7-2.18-3.7-1.68,4.29-2.29,6S377.72,235.87,379.32,236.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.32,236.53a1.51,1.51,0,0,0,1.7-.64,4.54,4.54,0,0,0,.84-1.74c.15-.63.22-1.29.38-1.93a5.43,5.43,0,0,1,.33-.93,1.24,1.24,0,0,1,.73-.69c.41,0,.6.34.86.51a1.12,1.12,0,0,0,.84.31,1,1,0,0,0,.8-.34,1,1,0,0,0-.07-.87c-.24-.59-.57-1.16-.85-1.76a18.65,18.65,0,0,1-.69-1.84,3.57,3.57,0,0,0-.86-1.66.76.76,0,0,0-.8-.1,1.56,1.56,0,0,0-.55.72,22.3,22.3,0,0,0-1.07,3.74A17.65,17.65,0,0,1,379.5,233a10.9,10.9,0,0,0-.66,1.84,2.64,2.64,0,0,0-.06,1A.92.92,0,0,0,379.32,236.53Zm0,0a1,1,0,0,1-.56-.75,2.69,2.69,0,0,1,.05-1,11.32,11.32,0,0,1,.63-1.86,17.24,17.24,0,0,0,1.35-3.65,22,22,0,0,1,1-3.8,1.77,1.77,0,0,1,.62-.82,1,1,0,0,1,1,.11,3.67,3.67,0,0,1,1,1.75,18.89,18.89,0,0,0,.65,1.83c.27.6.59,1.16.83,1.79a.91.91,0,0,1-.9,1.43,1.35,1.35,0,0,1-.94-.36c-.26-.2-.47-.52-.75-.5-.59.2-.82.94-1,1.53s-.25,1.27-.41,1.91a4.5,4.5,0,0,1-.87,1.75A1.53,1.53,0,0,1,379.32,236.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.25,316c-.87.87-11,1.25-14.64,1.25S384.84,316.84,384,316s11.37-68,14.64-68S414.11,315.1,413.25,316Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.45,298.87c-2.49.95-11.74,4.71-13.73,5.81,0-.42,0-.84,0-1.26l6.7-3.91a79.31,79.31,0,0,0,7.22-4.29c.11-.08.05-.3-.1-.24a59.92,59.92,0,0,0-7.06,3.9c-2.27,1.33-4.52,2.7-6.76,4.09q0-4.83,0-9.65A77.18,77.18,0,0,0,410.2,288c.12-.06,0-.28-.09-.22a76,76,0,0,0-10.44,5.15c0-1.68,0-3.35,0-5-.09-8.61-.11-17.23-.33-25.85,2.19-1.1,4.45-2.08,6.64-3.19.14-.07,0-.32-.11-.26-2.22.86-4.36,1.89-6.55,2.85-.11-4.44-.28-8.88-.55-13.32a.12.12,0,0,0-.23,0c-.31,8.25-.28,16.51-.18,24.76-2.27-1.81-4.69-3.41-7-5.17-.09-.07-.18.09-.09.15,2.42,1.84,4.68,3.88,7.1,5.71,0,.47,0,.93,0,1.4-2.47-1.13-5-2.17-7.45-3.24-.2-.08-.37.2-.17.29,2.53,1.22,5.06,2.45,7.62,3.6q.09,6.13.19,12.27c.09,7.14.25,14.28.4,21.42q-7-3.53-14-6.86c-.18-.08-.34.17-.16.27A147.37,147.37,0,0,0,399,309.84c.13,5.93.25,11.86.32,17.8a.28.28,0,0,0,.56,0c-.08-7.57-.09-15.14-.11-22.7,2.45-.61,11.7-4.57,13.9-5.66C413.85,299.17,413.69,298.78,413.45,298.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.35,258.3c-1.92,1.45-3.43-.3-4.49.29s-1.22,5.35-4.17,4.06c-1.89-.83,1.58-5.89,1.7-9,.07-1.88,1-6.36,3.22-6.24s2.13,4.82,2.72,5.94S403.91,257.14,402.35,258.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.35,258.3a2.8,2.8,0,0,1-2.42.52c-.42-.09-.82-.23-1.24-.3a1.44,1.44,0,0,0-.62,0,.93.93,0,0,0-.48.37c-.44.72-.64,1.57-1,2.34s-.89,1.6-1.83,1.68a2.14,2.14,0,0,1-1.25-.33,1.29,1.29,0,0,1-.43-1.21,10.45,10.45,0,0,1,.67-2.48,24.34,24.34,0,0,0,1.49-4.84,13.44,13.44,0,0,1,1.17-5,2.84,2.84,0,0,1,1.87-1.72,1.53,1.53,0,0,1,1.25.34,2.62,2.62,0,0,1,.74,1.06,10.78,10.78,0,0,1,.64,2.48l.22,1.26a3.13,3.13,0,0,0,.44,1.18,13.87,13.87,0,0,1,1.16,2.27,3.43,3.43,0,0,1,.23,1.26A1.43,1.43,0,0,1,402.35,258.3Zm0,0a1.4,1.4,0,0,0,.57-1.09,3.08,3.08,0,0,0-.24-1.24,13.87,13.87,0,0,0-1.18-2.26,3.19,3.19,0,0,1-.46-1.2l-.24-1.25a10.7,10.7,0,0,0-.67-2.45,1.78,1.78,0,0,0-1.85-1.3,2.71,2.71,0,0,0-1.72,1.65,13.35,13.35,0,0,0-1.09,4.92A24.26,24.26,0,0,1,393.9,259a9.88,9.88,0,0,0-.68,2.43,1.16,1.16,0,0,0,.35,1.08,2.06,2.06,0,0,0,1.17.31c.85-.05,1.4-.85,1.75-1.59a25.55,25.55,0,0,1,1.05-2.33.89.89,0,0,1,.52-.39,1.53,1.53,0,0,1,.64,0c.42.08.82.23,1.24.32A2.78,2.78,0,0,0,402.35,258.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.42,345.81c1.17,1.17,14.78,1.69,19.74,1.69s18.57-.52,19.73-1.69-15.32-91.67-19.73-91.67S456.25,344.64,457.42,345.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.14,322.75c3.37,1.28,15.83,6.36,18.52,7.84,0-.57,0-1.14,0-1.7-3-1.77-6-3.52-9-5.28a105.42,105.42,0,0,1-9.72-5.78c-.15-.11-.07-.41.13-.33a81,81,0,0,1,9.52,5.26c3.06,1.8,6.09,3.65,9.11,5.52,0-4.34,0-8.68.06-13A103.61,103.61,0,0,1,461.52,308c-.15-.09,0-.37.13-.3a103.89,103.89,0,0,1,14.08,6.94c0-2.25,0-4.51,0-6.76.12-11.62.15-23.24.44-34.86-3-1.49-6-2.81-9-4.3-.19-.1-.06-.44.15-.36,3,1.17,5.89,2.56,8.83,3.85.16-6,.39-12,.75-18a.16.16,0,0,1,.31,0c.41,11.12.38,22.26.24,33.39,3.06-2.44,6.32-4.6,9.44-7,.12-.1.24.11.12.2-3.26,2.48-6.31,5.22-9.57,7.69l0,1.89c3.32-1.52,6.69-2.93,10.05-4.37.26-.11.49.27.23.4-3.42,1.64-6.83,3.31-10.29,4.85-.08,5.52-.17,11-.24,16.55-.13,9.62-.34,19.25-.55,28.88q9.41-4.76,18.94-9.25c.24-.11.45.23.21.37a195.92,195.92,0,0,1-19.16,9.62c-.17,8-.34,16-.44,24a.38.38,0,0,1-.75,0c.11-10.2.12-20.4.15-30.61-3.3-.81-15.78-6.16-18.75-7.62C456.61,323.16,456.82,322.63,457.14,322.75Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.5,274.66c2.23.91,4.36-2.06,4.89-5.14s1-4.93,2.18-5.55,1.59,2,3.93,1.38.76-2.61-.65-5.69-1.65-6.78-4-6.78-3.09,7.86-4.22,10.93S467.55,273.46,470.5,274.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.5,274.66a2.22,2.22,0,0,0,1.75-.05,4.17,4.17,0,0,0,1.39-1.11,8.48,8.48,0,0,0,1.55-3.21c.27-1.16.4-2.36.71-3.52a8.11,8.11,0,0,1,.61-1.71,2.19,2.19,0,0,1,1.3-1.23,1.1,1.1,0,0,1,.86.34l.67.6a2.26,2.26,0,0,0,1.6.58,2,2,0,0,0,1.52-.66,2,2,0,0,0-.11-1.65c-.45-1.1-1.05-2.15-1.55-3.24a30.06,30.06,0,0,1-1.26-3.39,6.73,6.73,0,0,0-1.62-3.08,2,2,0,0,0-.78-.32,1.11,1.11,0,0,0-.8.12,3.26,3.26,0,0,0-1,1.37,41.48,41.48,0,0,0-1.93,6.9c-.43,2.39-1.63,4.52-2.57,6.71a20.35,20.35,0,0,0-1.19,3.39,4.86,4.86,0,0,0-.12,1.78A1.75,1.75,0,0,0,470.5,274.66Zm0,0a1.73,1.73,0,0,1-1-1.38,4.92,4.92,0,0,1,.1-1.79,20.34,20.34,0,0,1,1.16-3.4c.93-2.21,2.1-4.34,2.51-6.72a41,41,0,0,1,1.88-7,3.38,3.38,0,0,1,1.11-1.46,1.32,1.32,0,0,1,.93-.16,2.06,2.06,0,0,1,.88.36,6.83,6.83,0,0,1,1.73,3.17A31.31,31.31,0,0,0,481,259.7c.49,1.1,1.08,2.14,1.53,3.27a2.09,2.09,0,0,1,.08,1.81,1.45,1.45,0,0,1-.76.55,2.76,2.76,0,0,1-.9.17,2.34,2.34,0,0,1-1.69-.63l-.67-.6a1,1,0,0,0-.75-.32,2.15,2.15,0,0,0-1.23,1.16,8.22,8.22,0,0,0-.61,1.68c-.31,1.16-.46,2.35-.74,3.52a8.41,8.41,0,0,1-1.59,3.21,4.05,4.05,0,0,1-1.4,1.1A2.2,2.2,0,0,1,470.5,274.66Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.16,267.52c-.49.49-6.19.71-8.26.71s-7.77-.22-8.26-.71,6.41-38.36,8.26-38.36S365.65,267,365.16,267.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.28,257.87c-1.41.54-6.63,2.66-7.75,3.28,0-.23,0-.47,0-.71l3.79-2.21a44,44,0,0,0,4.07-2.42c.06,0,0-.17-.06-.13a33.52,33.52,0,0,0-4,2.2c-1.29.75-2.55,1.52-3.82,2.31,0-1.82,0-3.63,0-5.45a43.61,43.61,0,0,0,5.94-3c.07,0,0-.16-.05-.13a43.53,43.53,0,0,0-5.89,2.91c0-.95,0-1.89,0-2.84-.06-4.86-.06-9.72-.19-14.58,1.24-.63,2.51-1.18,3.75-1.8.08,0,0-.19-.06-.15-1.26.49-2.47,1.07-3.7,1.61q-.09-3.77-.31-7.52c0-.08-.13-.08-.13,0-.18,4.66-.16,9.32-.1,14-1.28-1-2.65-1.93-3.95-2.92-.05,0-.1,0-.05.08,1.36,1,2.63,2.19,4,3.22,0,.27,0,.53,0,.79-1.39-.63-2.8-1.22-4.2-1.82-.11-.05-.21.11-.1.16,1.43.69,2.86,1.38,4.31,2,0,2.31.07,4.62.1,6.92.05,4,.14,8.06.23,12.09-2.63-1.32-5.27-2.62-7.93-3.87-.1,0-.19.1-.09.16a83.38,83.38,0,0,0,8,4c.07,3.35.14,6.7.19,10.05a.16.16,0,0,0,.31,0c0-4.27,0-8.54-.06-12.81a78.91,78.91,0,0,0,7.84-3.19C365.5,258,365.41,257.82,365.28,257.87Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.68,237.75c-.93.38-1.82-.86-2-2.15s-.42-2.07-.91-2.33-.67.83-1.65.58-.31-1.09.27-2.38.69-2.84,1.68-2.84,1.29,3.29,1.76,4.58S360.92,237.24,359.68,237.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.68,237.75a1.19,1.19,0,0,1-1.32-.48,3.76,3.76,0,0,1-.67-1.34c-.12-.49-.18-1-.32-1.47s-.32-1-.76-1.16c-.2,0-.36.23-.56.39a1,1,0,0,1-.73.28,1,1,0,0,1-.75-.32.94.94,0,0,1,0-.82c.19-.48.44-.91.64-1.37a12.94,12.94,0,0,0,.51-1.4,2.82,2.82,0,0,1,.75-1.37.78.78,0,0,1,.83-.08,1.44,1.44,0,0,1,.49.64,16.84,16.84,0,0,1,.76,2.93,13.23,13.23,0,0,0,1,2.82,8.82,8.82,0,0,1,.49,1.42C360.18,236.88,360.2,237.53,359.68,237.75Zm0,0c.52-.23.49-.87.38-1.32a8.86,8.86,0,0,0-.5-1.42,13.28,13.28,0,0,1-1.11-2.8,17,17,0,0,0-.84-2.87,1.2,1.2,0,0,0-.41-.54.57.57,0,0,0-.58.08,2.75,2.75,0,0,0-.65,1.26,13.63,13.63,0,0,1-.53,1.42c-.21.46-.46.9-.65,1.35-.08.22-.16.47-.06.63a.78.78,0,0,0,.59.26.88.88,0,0,0,.64-.23c.19-.12.34-.41.67-.39.56.21.68.8.81,1.26s.18,1,.29,1.48a3.41,3.41,0,0,0,.65,1.34A1.15,1.15,0,0,0,359.68,237.75Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.85,343.19c1.57,1.57,19.9,2.27,26.57,2.27s25-.7,26.56-2.27-20.62-123.41-26.56-123.41S400.28,341.61,401.85,343.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.48,312.14c4.53,1.73,21.3,8.56,24.93,10.55,0-.76,0-1.53,0-2.29q-6.07-3.57-12.17-7.1c-4.35-2.53-9-4.79-13.09-7.78-.2-.15-.09-.55.18-.44,4.48,1.87,8.64,4.63,12.81,7.08s8.2,4.91,12.27,7.42q0-8.76.07-17.52a139.4,139.4,0,0,1-19.11-9.71c-.21-.13-.07-.51.17-.41a140,140,0,0,1,18.95,9.34c0-3,0-6.07.07-9.11.16-15.63.19-31.28.59-46.91-4-2-8.07-3.78-12.05-5.8-.26-.13-.08-.58.2-.48,4,1.58,7.92,3.45,11.88,5.19.22-8.07.53-16.13,1-24.18a.21.21,0,0,1,.41,0c.56,15,.51,30,.33,44.95,4.12-3.29,8.51-6.2,12.7-9.39.17-.13.32.15.16.27-4.38,3.34-8.48,7-12.88,10.36l0,2.54c4.47-2,9-3.94,13.51-5.88.36-.15.67.36.31.53-4.6,2.21-9.18,4.45-13.84,6.54-.1,7.42-.23,14.84-.33,22.26-.17,13-.45,25.92-.73,38.88q12.66-6.39,25.49-12.44a.28.28,0,0,1,.29.49,266.78,266.78,0,0,1-25.8,12.95c-.23,10.77-.45,21.54-.59,32.31a.51.51,0,0,1-1,0c.15-13.73.17-27.47.21-41.21-4.45-1.09-21.25-8.29-25.25-10.26C400.75,312.69,401,312,401.48,312.14Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.46,247.41c3,1.22,5.87-2.77,6.58-6.92s1.35-6.64,2.93-7.47,2.14,2.64,5.3,1.86,1-3.51-.88-7.66-2.22-9.13-5.37-9.13-4.16,10.58-5.68,14.72S415.49,245.79,419.46,247.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.46,247.41a3,3,0,0,0,2.35-.07,5.33,5.33,0,0,0,1.87-1.49,11.09,11.09,0,0,0,2.1-4.32c.37-1.56.55-3.18,1-4.74a10.4,10.4,0,0,1,.81-2.29,3,3,0,0,1,1.74-1.65,1.46,1.46,0,0,1,1.14.46c.31.26.59.55.9.8a3.76,3.76,0,0,0,1,.62,2.85,2.85,0,0,0,1.16.17,3.79,3.79,0,0,0,1.15-.23,1.8,1.8,0,0,0,.92-.67,2.67,2.67,0,0,0-.15-2.25c-.6-1.49-1.41-2.89-2.08-4.37a43.6,43.6,0,0,1-1.69-4.55,22.7,22.7,0,0,0-.84-2.26,5,5,0,0,0-1.36-1.9,2.46,2.46,0,0,0-1.06-.43,1.5,1.5,0,0,0-1.1.17,4.43,4.43,0,0,0-1.41,1.85c-1.29,3-1.82,6.18-2.59,9.31a22.7,22.7,0,0,1-1.47,4.61l-2,4.42a27.37,27.37,0,0,0-1.59,4.56,6.48,6.48,0,0,0-.16,2.4A2.24,2.24,0,0,0,419.46,247.41Zm0,0a2.28,2.28,0,0,1-1.39-1.85,6.7,6.7,0,0,1,.15-2.4,26.34,26.34,0,0,1,1.57-4.58l2-4.43a23.23,23.23,0,0,0,1.43-4.61c.75-3.14,1.25-6.36,2.54-9.36a4.54,4.54,0,0,1,1.47-2,1.74,1.74,0,0,1,1.24-.2,2.6,2.6,0,0,1,1.16.46,5.15,5.15,0,0,1,1.44,2,21.62,21.62,0,0,1,.87,2.27,41.61,41.61,0,0,0,1.65,4.54c.65,1.47,1.45,2.88,2.05,4.39a5.38,5.38,0,0,1,.33,1.19,1.75,1.75,0,0,1-.21,1.22,1.88,1.88,0,0,1-1,.73,4.13,4.13,0,0,1-1.21.24,3,3,0,0,1-1.21-.19,4.19,4.19,0,0,1-1.05-.65c-.31-.26-.6-.55-.9-.81a1.38,1.38,0,0,0-1-.44,2.91,2.91,0,0,0-1.67,1.58,11.28,11.28,0,0,0-.81,2.26c-.43,1.56-.62,3.17-1,4.74a11.43,11.43,0,0,1-2.13,4.32,5.58,5.58,0,0,1-1.89,1.49A3,3,0,0,1,419.46,247.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.37,353.79c1.42,1.42,18,2,24,2s22.57-.63,24-2-18.62-111.39-24-111.39S130,352.37,131.37,353.79Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,325.76c4.09,1.56,19.23,7.73,22.5,9.53,0-.69,0-1.38,0-2.07-3.65-2.15-7.32-4.28-11-6.41-3.93-2.29-8.16-4.33-11.82-7-.18-.13-.08-.5.16-.4,4.05,1.68,7.8,4.18,11.57,6.39s7.4,4.43,11.07,6.7c0-5.27,0-10.54.07-15.81a126.58,126.58,0,0,1-17.26-8.77c-.19-.12-.06-.46.16-.37a127.34,127.34,0,0,1,17.1,8.43c0-2.74,0-5.48.06-8.22.15-14.11.18-28.24.54-42.35-3.59-1.81-7.29-3.41-10.88-5.23-.23-.12-.07-.53.19-.43,3.64,1.42,7.14,3.1,10.72,4.68.19-7.29.47-14.56.91-21.83a.19.19,0,0,1,.38,0c.5,13.51.46,27,.29,40.57,3.72-3,7.69-5.59,11.47-8.47.15-.11.29.13.15.24-4,3-7.66,6.35-11.63,9.36l0,2.29c4-1.85,8.12-3.56,12.2-5.31.32-.13.6.32.28.48-4.15,2-8.29,4-12.5,5.9-.09,6.7-.21,13.4-.29,20.1-.16,11.7-.41,23.4-.66,35.1q11.42-5.77,23-11.24c.29-.14.55.28.25.44a238.85,238.85,0,0,1-23.28,11.7c-.21,9.72-.41,19.44-.53,29.16a.46.46,0,0,1-.92,0c.13-12.4.15-24.79.19-37.19-4-1-19.18-7.49-22.79-9.27C130.38,326.26,130.64,325.61,131,325.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.22,259.29c3.16,2.38,5.63-.49,7.36.47s2,8.77,6.84,6.65c3.09-1.35-2.59-9.64-2.79-14.75-.12-3.08-1.59-10.41-5.28-10.21s-3.49,7.9-4.45,9.73S146.68,257.38,149.22,259.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.22,259.29a4.55,4.55,0,0,0,4,.81c.68-.15,1.34-.39,2-.52a2.66,2.66,0,0,1,1,0,1.49,1.49,0,0,1,.83.63,40.81,40.81,0,0,1,1.71,3.82,6.9,6.9,0,0,0,1.12,1.74,2.65,2.65,0,0,0,1.78.9,3.91,3.91,0,0,0,2-.49,2,2,0,0,0,.59-1.84,17.28,17.28,0,0,0-1.12-4c-1-2.61-2.15-5.17-2.56-8a27.07,27.07,0,0,0-.51-4.14,16.92,16.92,0,0,0-1.29-4,7.35,7.35,0,0,0-1.14-1.72,3.26,3.26,0,0,0-1.73-1,2.37,2.37,0,0,0-1.9.5,4.11,4.11,0,0,0-1.18,1.66,17.81,17.81,0,0,0-1.08,4c-.13.69-.24,1.38-.39,2.06a5.14,5.14,0,0,1-.74,2,22.88,22.88,0,0,0-1.94,3.7,5.1,5.1,0,0,0-.38,2A2.34,2.34,0,0,0,149.22,259.29Zm0,0a2.35,2.35,0,0,1-.95-1.79,5.32,5.32,0,0,1,.37-2.05,24.17,24.17,0,0,1,1.91-3.72,5,5,0,0,0,.72-1.94c.14-.69.25-1.38.37-2.06a18.41,18.41,0,0,1,1.07-4.06,4.23,4.23,0,0,1,1.2-1.72,2.53,2.53,0,0,1,2-.54,3.45,3.45,0,0,1,1.83,1,7.39,7.39,0,0,1,1.17,1.76,16.37,16.37,0,0,1,1.34,4,26.63,26.63,0,0,1,.55,4.16c.37,2.75,1.54,5.33,2.48,8a16.64,16.64,0,0,1,1.1,4.05,2.09,2.09,0,0,1-.66,2,4,4,0,0,1-2.05.51,2.78,2.78,0,0,1-1.85-1,7,7,0,0,1-1.12-1.77,39.76,39.76,0,0,0-1.68-3.82,1.41,1.41,0,0,0-.8-.62,2.5,2.5,0,0,0-1,0c-.69.12-1.35.36-2,.5a4.5,4.5,0,0,1-4-.84Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.2,249.62c.44.44,5.59.64,7.46.64s7-.2,7.46-.64S312.33,215,310.66,215,302.76,249.18,303.2,249.62Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.1,240.9c1.27.49,6,2.41,7,3,0-.22,0-.43,0-.65l-3.42-2a42.2,42.2,0,0,1-3.67-2.18c-.06-.05,0-.16.05-.13a31.46,31.46,0,0,1,3.59,2c1.16.68,2.31,1.38,3.45,2.08,0-1.64,0-3.28,0-4.92a38.09,38.09,0,0,1-5.37-2.72c-.06,0,0-.15.05-.12a39.76,39.76,0,0,1,5.32,2.62c0-.85,0-1.7,0-2.55.05-4.39.05-8.78.17-13.17-1.12-.57-2.27-1.06-3.39-1.63-.07,0,0-.17.06-.14,1.13.45,2.22,1,3.33,1.46.06-2.26.15-4.53.29-6.79,0-.07.11-.07.12,0,.15,4.2.14,8.41.09,12.62,1.15-.92,2.39-1.74,3.56-2.63.05,0,.09,0,.05.07-1.23.94-2.38,2-3.62,2.91,0,.24,0,.48,0,.71,1.26-.57,2.53-1.1,3.8-1.65.1,0,.19.1.09.15-1.3.62-2.58,1.25-3.89,1.84,0,2.08-.07,4.16-.09,6.25-.05,3.64-.13,7.28-.21,10.91,2.37-1.19,4.76-2.36,7.16-3.49.09,0,.17.09.08.14a75.27,75.27,0,0,1-7.24,3.63c-.07,3-.13,6-.17,9.08a.15.15,0,0,1-.29,0c.05-3.86.05-7.72.06-11.57a69.52,69.52,0,0,1-7.08-2.89C302.89,241.06,303,240.86,303.1,240.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.75,220.23c1,.74,1.75-.15,2.29.15s.62,2.72,2.13,2.06c1-.42-.81-3-.87-4.58,0-1-.5-3.24-1.64-3.18s-1.09,2.46-1.39,3S308,219.64,308.75,220.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.75,220.23a1.43,1.43,0,0,0,1.23.25c.21,0,.42-.13.63-.17a.54.54,0,0,1,.59.21,11.41,11.41,0,0,1,.55,1.18c.18.37.47.77.89.79a1,1,0,0,0,.57-.16.58.58,0,0,0,.15-.52,5,5,0,0,0-.36-1.22,12.36,12.36,0,0,1-.8-2.5,6.74,6.74,0,0,0-.55-2.49c-.18-.37-.44-.75-.83-.82a.85.85,0,0,0-.91.63,5.11,5.11,0,0,0-.35,1.23,3.61,3.61,0,0,1-.37,1.25,7,7,0,0,0-.61,1.15A1,1,0,0,0,308.75,220.23Zm0,0a1,1,0,0,1-.18-1.2,6.66,6.66,0,0,1,.59-1.16,3.44,3.44,0,0,0,.32-1.24,5.83,5.83,0,0,1,.31-1.28,1,1,0,0,1,1.06-.74,1.47,1.47,0,0,1,1,.89,6.57,6.57,0,0,1,.6,2.56,12.37,12.37,0,0,0,.76,2.45,5.55,5.55,0,0,1,.33,1.29.69.69,0,0,1-.24.65,1.12,1.12,0,0,1-.66.16c-.5,0-.78-.5-.95-.88a9.68,9.68,0,0,0-.51-1.19.49.49,0,0,0-.55-.2c-.22,0-.42.11-.64.15A1.43,1.43,0,0,1,308.75,220.23Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.87,447.71c-2.25,2.25-28.48,3.25-38,3.25s-35.76-1-38-3.25,29.51-176.57,38-176.57S490.12,445.46,487.87,447.71Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.39,403.29c-6.48,2.47-30.48,12.25-35.66,15.1,0-1.1,0-2.19,0-3.28,5.79-3.41,11.6-6.78,17.41-10.16,6.23-3.62,12.92-6.86,18.74-11.13.28-.21.12-.79-.27-.63-6.41,2.67-12.35,6.62-18.33,10.12s-11.73,7-17.55,10.62c0-8.35,0-16.7-.11-25.06A199.12,199.12,0,0,0,480,375c.3-.18.1-.73-.25-.59a201.26,201.26,0,0,0-27.12,13.37c0-4.34,0-8.69-.09-13-.24-22.37-.28-44.76-.85-67.13,5.69-2.87,11.55-5.4,17.24-8.29.37-.19.11-.84-.29-.69-5.77,2.26-11.33,4.93-17,7.42-.3-11.54-.75-23.08-1.45-34.6a.3.3,0,0,0-.59,0c-.8,21.42-.73,42.87-.47,64.32-5.89-4.71-12.18-8.87-18.18-13.44-.23-.17-.46.22-.23.4,6.28,4.77,12.15,10.06,18.44,14.82,0,1.21,0,2.42,0,3.63-6.39-2.92-12.88-5.64-19.34-8.41-.5-.22-1,.51-.44.76,6.58,3.15,13.14,6.37,19.81,9.35.15,10.62.33,21.24.47,31.86.24,18.55.65,37.09,1,55.63q-18.1-9.15-36.47-17.81c-.46-.22-.87.44-.41.7a381,381,0,0,0,36.91,18.54c.33,15.41.65,30.82.85,46.23a.73.73,0,0,0,1.45,0c-.21-19.65-.25-39.31-.3-59,6.36-1.57,30.4-11.87,36.12-14.69C489.43,404.07,489,403.05,488.39,403.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.57,297.93c-5,3.76-8.92-.79-11.67.74s-3.16,13.89-10.84,10.54c-4.9-2.14,4.12-15.28,4.43-23.38.18-4.88,2.52-16.5,8.36-16.19s5.54,12.53,7.07,15.43S463.6,294.9,459.57,297.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.57,297.93a7.69,7.69,0,0,1-3,1.39,7.81,7.81,0,0,1-3.3-.08c-1.09-.22-2.13-.61-3.22-.79a3.94,3.94,0,0,0-1.64,0,2.92,2.92,0,0,0-.73.36,2.63,2.63,0,0,0-.54.61,16.08,16.08,0,0,0-1.4,3c-.4,1-.79,2.07-1.26,3.07a11,11,0,0,1-1.78,2.81,4.34,4.34,0,0,1-2.91,1.5,5.88,5.88,0,0,1-3.22-.81,2.32,2.32,0,0,1-.92-1.39,4.76,4.76,0,0,1-.11-1.68,26.8,26.8,0,0,1,1.74-6.41c.77-2.08,1.58-4.13,2.31-6.22a32.48,32.48,0,0,0,1.66-6.39c.12-1.09.13-2.21.28-3.31s.33-2.2.56-3.28a27.55,27.55,0,0,1,2.11-6.31,11.5,11.5,0,0,1,1.86-2.77,5,5,0,0,1,2.87-1.64,3.93,3.93,0,0,1,3.17.83,7.06,7.06,0,0,1,1.9,2.72,29.79,29.79,0,0,1,1.69,6.42c.19,1.09.36,2.19.58,3.27a12.51,12.51,0,0,0,.41,1.6,8.18,8.18,0,0,0,.74,1.48,36.88,36.88,0,0,1,3,5.89,8.44,8.44,0,0,1,.6,3.25A3.77,3.77,0,0,1,459.57,297.93Zm0,0a3.75,3.75,0,0,0,1.49-2.85,8.14,8.14,0,0,0-.61-3.23,36.47,36.47,0,0,0-3.06-5.88,8.27,8.27,0,0,1-.76-1.48,15.24,15.24,0,0,1-.42-1.61c-.22-1.09-.4-2.18-.6-3.27a29.25,29.25,0,0,0-1.7-6.39,7.09,7.09,0,0,0-1.88-2.66,3.77,3.77,0,0,0-3-.79,5,5,0,0,0-2.78,1.61,11.37,11.37,0,0,0-1.81,2.73,27.11,27.11,0,0,0-2.06,6.27q-.34,1.62-.54,3.27c-.15,1.09-.15,2.19-.28,3.31a31.72,31.72,0,0,1-1.69,6.43c-.74,2.09-1.57,4.14-2.34,6.22a26.74,26.74,0,0,0-1.77,6.36,3.14,3.14,0,0,0,1,2.94,5.71,5.71,0,0,0,3.13.79,4.19,4.19,0,0,0,2.84-1.45,10.71,10.71,0,0,0,1.77-2.77c.48-1,.87-2,1.28-3.06a16.47,16.47,0,0,1,1.42-3,2.76,2.76,0,0,1,.56-.62,2.62,2.62,0,0,1,.75-.37,4,4,0,0,1,1.66,0c1.09.19,2.13.58,3.22.81a7.17,7.17,0,0,0,6.27-1.28Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.69,300.53c1.17,1.17,14.78,1.69,19.74,1.69s18.57-.52,19.73-1.69-15.32-91.68-19.73-91.68S17.52,299.36,18.69,300.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.42,277.47c3.36,1.28,15.82,6.35,18.51,7.83,0-.56,0-1.13,0-1.7q-4.5-2.66-9-5.27a105.42,105.42,0,0,1-9.72-5.78c-.15-.11-.07-.41.13-.33a81,81,0,0,1,9.52,5.26c3.06,1.79,6.09,3.65,9.11,5.51,0-4.34,0-8.67.06-13a102.92,102.92,0,0,1-14.2-7.22c-.16-.09-.06-.38.12-.3A102.73,102.73,0,0,1,37,269.4c0-2.26,0-4.51,0-6.77.13-11.61.15-23.24.44-34.85-3-1.49-6-2.81-9-4.31-.19-.1-.06-.43.15-.35,3,1.17,5.89,2.55,8.83,3.85.16-6,.39-12,.75-18a.16.16,0,0,1,.31,0c.41,11.13.38,22.26.24,33.4,3.06-2.45,6.33-4.61,9.44-7,.12-.09.24.11.12.2-3.26,2.48-6.3,5.23-9.57,7.7l0,1.89c3.32-1.52,6.69-2.93,10-4.37.26-.11.49.26.23.39-3.42,1.64-6.83,3.31-10.29,4.86-.08,5.51-.17,11-.24,16.54-.13,9.63-.34,19.26-.54,28.89q9.39-4.75,18.93-9.25c.24-.11.45.23.21.36A197.12,197.12,0,0,1,38,292.26c-.17,8-.34,16-.44,24a.38.38,0,0,1-.75,0c.11-10.2.12-20.41.15-30.61-3.3-.82-15.78-6.16-18.75-7.63C17.88,277.87,18.09,277.34,18.42,277.47Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.78,229.37c2.22.91,4.35-2.05,4.88-5.13s1-4.94,2.18-5.55,1.59,2,3.93,1.38.76-2.61-.65-5.7-1.64-6.78-4-6.78-3.09,7.87-4.22,10.94S28.82,228.17,31.78,229.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.78,229.37a2.15,2.15,0,0,0,1.74-.05,3.93,3.93,0,0,0,1.39-1.11,8.29,8.29,0,0,0,1.55-3.2c.27-1.16.4-2.37.71-3.53a8.62,8.62,0,0,1,.61-1.7,2.21,2.21,0,0,1,1.3-1.24,1.13,1.13,0,0,1,.86.34l.67.6a2.27,2.27,0,0,0,1.6.59,2,2,0,0,0,1.52-.67,2,2,0,0,0-.11-1.65c-.45-1.1-1-2.14-1.55-3.24a29.91,29.91,0,0,1-1.26-3.38,6.68,6.68,0,0,0-1.62-3.08,1.73,1.73,0,0,0-.78-.32,1.11,1.11,0,0,0-.8.12,3.31,3.31,0,0,0-1,1.36,42.58,42.58,0,0,0-1.93,6.91c-.43,2.38-1.63,4.52-2.57,6.71a20.35,20.35,0,0,0-1.19,3.39,5.07,5.07,0,0,0-.12,1.78A1.73,1.73,0,0,0,31.78,229.37Zm0,0a1.74,1.74,0,0,1-1-1.37,4.91,4.91,0,0,1,.1-1.79A20.45,20.45,0,0,1,32,222.8c.93-2.21,2.1-4.33,2.51-6.71a41.4,41.4,0,0,1,1.88-7,3.41,3.41,0,0,1,1.11-1.45,1.32,1.32,0,0,1,.93-.16,2.17,2.17,0,0,1,.88.35,6.86,6.86,0,0,1,1.73,3.18,32.11,32.11,0,0,0,1.21,3.37c.49,1.09,1.08,2.14,1.53,3.27a2.07,2.07,0,0,1,.08,1.8,1.41,1.41,0,0,1-.75.55,3.2,3.2,0,0,1-.91.18,2.4,2.4,0,0,1-1.69-.63l-.67-.6a1,1,0,0,0-.75-.32,2.12,2.12,0,0,0-1.23,1.16,7.47,7.47,0,0,0-.6,1.68c-.32,1.15-.46,2.34-.75,3.51a8.34,8.34,0,0,1-1.59,3.21,4,4,0,0,1-1.4,1.11A2.18,2.18,0,0,1,31.78,229.37Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.14,381.25c-2.28,2.29-28.89,3.3-38.57,3.3s-36.29-1-38.58-3.3S77.94,202.08,86.57,202.08,127.43,379,125.14,381.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.68,336.18c-6.58,2.51-30.93,12.42-36.19,15.32,0-1.11,0-2.22,0-3.33,5.88-3.46,11.77-6.88,17.67-10.31,6.32-3.68,13.11-7,19-11.3.29-.21.13-.8-.27-.64-6.5,2.71-12.54,6.73-18.6,10.28S95.37,343.33,89.47,347c0-8.48,0-17-.11-25.43a203.29,203.29,0,0,0,27.76-14.11c.3-.18.1-.74-.25-.6a204.84,204.84,0,0,0-27.52,13.57c0-4.41,0-8.82-.09-13.23-.25-22.69-.29-45.42-.87-68.12,5.78-2.91,11.73-5.48,17.5-8.41.38-.19.11-.85-.3-.7-5.85,2.29-11.5,5-17.24,7.53-.32-11.71-.76-23.42-1.48-35.11a.3.3,0,0,0-.6,0c-.81,21.74-.74,43.5-.47,65.27-6-4.78-12.36-9-18.45-13.64-.24-.18-.47.22-.23.4,6.36,4.84,12.32,10.21,18.7,15,0,1.23,0,2.46.05,3.69-6.49-3-13.07-5.73-19.63-8.53-.51-.22-1,.51-.45.76,6.68,3.21,13.34,6.47,20.1,9.49.16,10.78.34,21.56.48,32.33.25,18.82.66,37.64,1.06,56.46q-18.36-9.3-37-18.08c-.47-.22-.88.45-.41.72a389.89,389.89,0,0,0,37.45,18.81c.33,15.63.66,31.27.86,46.91a.74.74,0,0,0,1.47,0c-.21-19.94-.25-39.89-.3-59.83,6.46-1.6,30.85-12.05,36.65-14.91C126.73,337,126.31,335.93,125.68,336.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.08,251.8c3.83,4.38,8.7,1,10.6-3.39s6.06-8.29,8.63-6.84,4.62,7.54,10.6,6.46-.56-11.28-1.94-15.31,3-3.68,0-11.31-6.61-12.78-9-16.59-4.26-5.55-7.85,2.55S76.64,230.3,75.07,233,67.87,248.14,71.08,251.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.08,251.8a5.45,5.45,0,0,0,3.92,2,6.22,6.22,0,0,0,4.08-1.76c2.37-2,2.9-5.29,5-7.57a10.48,10.48,0,0,1,3.49-2.89,3.4,3.4,0,0,1,2.24-.29,4.3,4.3,0,0,1,1.85,1.32c1,1.11,1.93,2.35,3.05,3.37a7.23,7.23,0,0,0,3.95,2,7.07,7.07,0,0,0,1.13.06c.37,0,.75-.08,1.12-.11a2.92,2.92,0,0,0,1.9-1.06,3.53,3.53,0,0,0,.54-2.12,10.51,10.51,0,0,0-.37-2.22,63.75,63.75,0,0,0-3.49-8.39,12.25,12.25,0,0,1-.78-2.15,3.9,3.9,0,0,1,.22-2.29,18.34,18.34,0,0,0,.82-2.11,6.15,6.15,0,0,0,.16-2.22,16.1,16.1,0,0,0-1.2-4.34c-.57-1.41-1.19-2.79-1.85-4.15a83.14,83.14,0,0,0-4.38-8L90,205.1a22,22,0,0,0-1.26-1.88,4,4,0,0,0-1.67-1.41,1.9,1.9,0,0,0-1.95.66,9.16,9.16,0,0,0-1.34,1.8,29.46,29.46,0,0,0-2,4.07,67.09,67.09,0,0,0-2.7,8.68c-.74,2.94-1.38,5.91-2,8.87-.33,1.49-.66,3-1,4.44a18.18,18.18,0,0,1-.71,2.16c-.31.71-.72,1.34-1,2A53.48,53.48,0,0,0,71,243a23.41,23.41,0,0,0-.85,4.46A6.11,6.11,0,0,0,71.08,251.8Zm0,0a6.16,6.16,0,0,1-.94-4.34A23.34,23.34,0,0,1,71,243a53,53,0,0,1,3.26-8.5c.3-.69.73-1.33,1-2a18.09,18.09,0,0,0,.69-2.16c.38-1.47.71-2.95,1-4.44.65-3,1.28-5.93,2-8.88a68.36,68.36,0,0,1,2.67-8.71,29.81,29.81,0,0,1,2-4.1A9.78,9.78,0,0,1,85,202.34l.44-.38c.16-.11.34-.19.52-.29a2.72,2.72,0,0,1,.58-.13,1.66,1.66,0,0,1,.59.09,4.07,4.07,0,0,1,1.76,1.47A19.6,19.6,0,0,1,90.2,205l2.43,3.85a83.74,83.74,0,0,1,4.43,8c.65,1.37,1.27,2.76,1.83,4.17a16.4,16.4,0,0,1,1.21,4.41,6.11,6.11,0,0,1-.18,2.29,18.1,18.1,0,0,1-.83,2.13,3.79,3.79,0,0,0-.22,2.18,12.78,12.78,0,0,0,.76,2.12,61.84,61.84,0,0,1,3.47,8.42,10.15,10.15,0,0,1,.36,2.26,3.6,3.6,0,0,1-.57,2.21,3.07,3.07,0,0,1-2,1.1c-.38,0-.76.09-1.14.11a7.2,7.2,0,0,1-1.14-.07,7.32,7.32,0,0,1-4-2.06c-1.13-1-2-2.28-3-3.39a4.14,4.14,0,0,0-1.8-1.3,3.39,3.39,0,0,0-2.19.28,10.52,10.52,0,0,0-3.47,2.86c-2.07,2.26-2.62,5.53-5,7.55a6.24,6.24,0,0,1-4.1,1.76A5.43,5.43,0,0,1,71.08,251.8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.19,434.92c-1.94,1.94-24.58,2.8-32.81,2.8s-30.87-.86-32.81-2.8S40,282.51,47.38,282.51,82.14,433,80.19,434.92Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.65,396.58c-5.59,2.13-26.31,10.57-30.79,13,0-.95,0-1.89,0-2.83,5-2.94,10-5.85,15-8.77,5.38-3.13,11.15-5.92,16.17-9.61.24-.18.11-.68-.23-.54-5.53,2.3-10.66,5.71-15.82,8.74s-10.13,6.06-15.15,9.16q0-10.81-.09-21.63a172.21,172.21,0,0,0,23.61-12c.26-.15.08-.63-.21-.51a174.09,174.09,0,0,0-23.41,11.54c0-3.75,0-7.5-.08-11.25-.21-19.3-.25-38.63-.74-57.94,4.92-2.48,10-4.66,14.88-7.16.33-.16.1-.72-.24-.59-5,1.95-9.79,4.25-14.68,6.4-.26-10-.64-19.92-1.25-29.86a.26.26,0,0,0-.51,0c-.69,18.49-.63,37-.4,55.51-5.09-4.06-10.52-7.65-15.7-11.59-.2-.15-.39.19-.19.34,5.41,4.12,10.48,8.68,15.91,12.79,0,1.05,0,2.09,0,3.14-5.52-2.53-11.12-4.87-16.7-7.26-.43-.19-.82.44-.38.65,5.68,2.72,11.34,5.5,17.1,8.07.13,9.17.28,18.34.4,27.5.21,16,.56,32,.91,48Q32.49,412,16.64,404.56c-.41-.19-.76.38-.36.61a329.2,329.2,0,0,0,31.86,16c.28,13.3.56,26.6.73,39.9a.63.63,0,0,0,1.25,0c-.18-17-.21-33.93-.26-50.89,5.5-1.36,26.25-10.25,31.18-12.68C81.55,397.25,81.19,396.37,80.65,396.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.77,305.63c-4.32,3.25-7.7-.68-10.07.64s-2.73,12-9.36,9.1c-4.23-1.85,3.55-13.19,3.82-20.18.16-4.22,2.18-14.24,7.22-14s4.78,10.81,6.1,13.32S59.25,303,55.77,305.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.77,305.63a6.22,6.22,0,0,1-5.42,1.13c-.94-.19-1.84-.52-2.78-.68a3.52,3.52,0,0,0-1.41,0,2.84,2.84,0,0,0-.63.31,2.38,2.38,0,0,0-.47.53c-1,1.62-1.45,3.52-2.29,5.23a9.35,9.35,0,0,1-1.54,2.43,3.75,3.75,0,0,1-2.52,1.3,5,5,0,0,1-2.78-.69,2.86,2.86,0,0,1-.9-2.66A23.08,23.08,0,0,1,36.54,307c1.29-3.59,2.89-7.11,3.41-10.89.11-.93.13-1.9.25-2.85s.28-1.9.49-2.83A23.29,23.29,0,0,1,42.51,285a10.69,10.69,0,0,1,1.6-2.4,4.73,4.73,0,0,1,2.49-1.41,3.36,3.36,0,0,1,2.75.71A6.07,6.07,0,0,1,51,284.26a25.41,25.41,0,0,1,1.45,5.54c.17.94.31,1.89.51,2.82A10.87,10.87,0,0,0,53.3,294a7.2,7.2,0,0,0,.64,1.27,32.63,32.63,0,0,1,2.62,5.09,7.27,7.27,0,0,1,.51,2.8A3.23,3.23,0,0,1,55.77,305.63Zm0,0a3.19,3.19,0,0,0,1.28-2.46,7.2,7.2,0,0,0-.52-2.79,31.34,31.34,0,0,0-2.65-5.07,8.09,8.09,0,0,1-.65-1.28,13.51,13.51,0,0,1-.36-1.39c-.2-.94-.35-1.88-.52-2.82a26,26,0,0,0-1.47-5.51,6.17,6.17,0,0,0-1.62-2.3,3.24,3.24,0,0,0-2.63-.67,4.51,4.51,0,0,0-2.39,1.38,10.45,10.45,0,0,0-1.56,2.37,22.63,22.63,0,0,0-1.77,5.4c-.21.93-.35,1.87-.47,2.82s-.13,1.89-.24,2.85c-.55,3.84-2.18,7.35-3.49,10.93a22.9,22.9,0,0,0-1.52,5.48A2.69,2.69,0,0,0,36,315.1a5,5,0,0,0,2.69.69,3.66,3.66,0,0,0,2.45-1.25,9.42,9.42,0,0,0,1.53-2.4c.85-1.7,1.31-3.59,2.33-5.23a3.09,3.09,0,0,1,.48-.54,2.62,2.62,0,0,1,.65-.32,3.67,3.67,0,0,1,1.44,0c.94.17,1.84.51,2.78.7a6.75,6.75,0,0,0,2.83.09A6.83,6.83,0,0,0,55.77,305.63Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Car--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.4,396.54s-.89-3.39-1.06-3.55a31.56,31.56,0,0,0-6-.71,4.58,4.58,0,0,0-.86,2.13c0,.37.68,2.13,1,2.19s5.22.15,5.53.12.9,1.88.9,1.88l1.08,0Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.4,396.54s-.89-3.39-1.06-3.55a31.56,31.56,0,0,0-6-.71,4.58,4.58,0,0,0-.86,2.13c0,.37.68,2.13,1,2.19s5.22.15,5.53.12.9,1.88.9,1.88l1.08,0Z",
    style: {
      fill: "#020100",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.35,436.62c5.47-.09,7.07-1.4,7.07-11.67,0-11.53-3.57-11.47-7.17-11.41-5.62.1-7,5.18-7,11.66S233.52,436.74,240.35,436.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.65,425c0,4.71-.78,8.54-1.74,8.56s-1.74-3.79-1.74-8.5.78-8.54,1.74-8.56S246.65,420.26,246.65,425Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.71,437.91c5.46-.1,7.06-1.4,7.06-11.67,0-11.54-3.57-11.48-7.16-11.41-5.63.09-7,5.18-7,11.66S159.88,438,166.71,437.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,426.26c0,4.7-.78,8.54-1.74,8.55s-1.74-3.78-1.74-8.49.78-8.54,1.74-8.56S173,421.55,173,426.26Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.41,430.76c5.17-.09,6.67-1.32,6.67-11,0-10.9-3.37-10.84-6.76-10.78-5.32.09-6.58,4.89-6.58,11S257,430.88,263.41,430.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.36,419.76c0,4.45-.74,8.07-1.65,8.08s-1.64-3.58-1.64-8,.74-8.07,1.64-8.08S269.36,415.31,269.36,419.76Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.22,433.31c-1.25,0-6.73-7.88-7.31-8.92s-1.74-11.22-1.27-12.74a11.46,11.46,0,0,1,1.5-3.5c.47-.48,15.46-10.86,16-11.3s11-19.51,14.09-21.05,15.66-1.84,28.37-2.06,30.63,1.12,33.24,2.47,14.18,23.94,15.22,25.66.35,6.09.35,6.09a11.86,11.86,0,0,1,2.18,4.35,7.83,7.83,0,0,1-.18,3.4s-.82-3.6-2.22-3.57-5,11.88-6.61,14.16a7.94,7.94,0,0,1-4.31,3.43c-1,.28-8.7.93-8.7.93a75,75,0,0,0-.3-9.17c-.48-5.82-2.22-8.62-4-8.59s-4.74,6.05-7.13,11.35-7.05,8.39-9.57,8.44S170.41,433.26,167.22,433.31Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.94,409.23l.55-2.28a18.67,18.67,0,0,1,1.68-1.65c1.15-1.06,2.32-2.1,3.49-3.14,2.36-2.05,4.71-4.12,7.11-6.12l-7,6.21c-1.18,1-2.35,2.06-3.52,3.11a23.19,23.19,0,0,0-1.67,1.61Z",
    style: {
      fill: "#020100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.51,432.69c.57-1.81,1.17-3.61,1.78-5.4s1.19-3.6,1.82-5.39v0c-.08-2.18-.16-4.37-.2-6.55.12,2.18.21,4.36.3,6.55h0c-.59,1.8-1.21,3.59-1.83,5.38S227.15,430.9,226.51,432.69Z",
    style: {
      fill: "#020100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.59,410.38l.55-2h0l8.43-6.32c2.83-2.08,5.65-4.18,8.5-6.24-2.79,2.14-5.62,4.23-8.42,6.34l-8.49,6.26v0Z",
    style: {
      fill: "#020100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.78,395.68c.68,3.77,1.29,7.57,1.93,11.35h0l.21,6.45q.11,3.22.17,6.45-.15-3.22-.26-6.45l-.24-6.44h0C246,403.26,245.35,399.47,244.78,395.68Z",
    style: {
      fill: "#020100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.74,396c1.17,3,2.29,6,3.44,9h0c.08,2.11.12,4.23.19,6.35s.11,4.23.15,6.35c-.1-2.12-.18-4.23-.25-6.35s-.16-4.23-.21-6.35v0C259,402,257.82,399,256.74,396Z",
    style: {
      fill: "#020100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.08,423.63q.81-2.85,1.66-5.7a40.64,40.64,0,0,1,1.9-5.64,5.76,5.76,0,0,1,1.84-2.34,3.2,3.2,0,0,1,2.88-.28,4.43,4.43,0,0,1,2,2.13,11.71,11.71,0,0,1,1,2.76,12.07,12.07,0,0,0-1.06-2.73,4.35,4.35,0,0,0-2-2.08,3.14,3.14,0,0,0-2.79.29,5.71,5.71,0,0,0-1.77,2.31,39.44,39.44,0,0,0-1.94,5.6Q235,420.8,234.08,423.63Z",
    style: {
      fill: "#020100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.65,428.64c1.36-.19,2.71-.41,4.06-.64s2.7-.48,4-.86a3.94,3.94,0,0,0,.48-.18.76.76,0,0,0,.39-.29,5.48,5.48,0,0,0,.47-.9c.27-.63.49-1.28.7-1.94.42-1.3.78-2.63,1.13-3.95q1-4,1.91-8a10.8,10.8,0,0,1,.52-2,4,4,0,0,1,1.22-1.66,3.35,3.35,0,0,1,1.9-.74,3.51,3.51,0,0,1,2,.48,3.44,3.44,0,0,0-2-.45,3.36,3.36,0,0,0-1.86.75,4.07,4.07,0,0,0-1.19,1.65,10.28,10.28,0,0,0-.51,2q-.84,4-1.86,8c-.36,1.33-.73,2.65-1.16,4-.21.65-.44,1.3-.71,1.94a4.71,4.71,0,0,1-.49.91.9.9,0,0,1-.42.33c-.16.07-.33.11-.49.17A65.68,65.68,0,0,1,248.65,428.64Z",
    style: {
      fill: "#020100"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M179.08,395.78l-12.15,9s15.49-.85,17.46-.93,11.6-3.55,11.6-3.55l25.3-3.05Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.25,389.59s-1.6-8.73-1.84-10.51.85-1.86,5.43-1.94c5.23-.1,5.62-.05,7,2.43s5.14,9.74,5.14,9.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.91,395.94c.19.35.79.71,2.51.55s12.15-.59,12.89-.73,1.26-.83.91-2-6.78-12.53-7.28-13.49-.72-1.1-2.35-1.07l-8,.14c-1.91,0-1.8,1.4-1.57,3S243.79,393.92,244.91,395.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.23,382.56l-11.06,11.25c-.41-1.57-.83-3.69-1.19-5.69l8.78-8.93c1.47,0,1.71.13,2.18,1.06C254.06,380.49,254.56,381.36,255.23,382.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.15,391.53,255.72,396l-3.32.16,6.64-6.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.42,388.33l-7.84,8-.67,0,8.28-8.43C258.27,388.05,258.35,388.19,258.42,388.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.92,379.27,242.27,384c0-.2-.06-.4-.08-.57l4.07-4.14Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "253.13 396.17 246.84 377.14 248.09 377.12 254.48 396.1 253.13 396.17",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.35,397c4.82-.09,4.41-1.82,4-4.37s-1.42-10.12-2.29-12.72-1.21-3.17-9.39-3l-37.16.65c-2.64.05-2.81.69-5.07,3.75s-6.8,11.19-7.57,12.62c-1.19,2.2-2.06,4.13,3.56,4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.25,380.43l-51.82.91a.09.09,0,0,1,0-.06c2.26-3.06,2.43-3.7,5.07-3.75l37.15-.65c8.18-.14,8.53.43,9.4,3C239.14,380.07,239.2,380.24,239.25,380.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,396.88q-.69.09-1.62.12l-37.31.65s4.44-2.47,5-2.7,29.36-.51,30-.53S238.54,396.39,239,396.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.64,377.35l-20.22,20.58c-4.46-.15-3.63-2-2.52-4l.4-.73,15.43-15.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.22,380.3l-16.66,16.95-6.91.12,20-20.33c2.53.32,2.88,1.15,3.45,2.87C239.13,380,239.17,380.16,239.22,380.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.34 377.13 195.09 397.73 191.88 397.79 212.13 377.19 215.34 377.13",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.24 377.08 198 397.68 197.35 397.69 217.59 377.09 218.24 377.08",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.49,386.72l-10.23,10.4h-.65l10.79-11Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M244.43,395.37a35.71,35.71,0,0,1,1.06-3.58c.17-.16,5.66-1.14,6-.92a4.5,4.5,0,0,1,.86,2.09c0,.38-.69,2.16-1,2.23s-5.22.33-5.53.31-.91,1.91-.91,1.91l-1.07,0Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.43,395.37a35.71,35.71,0,0,1,1.06-3.58c.17-.16,5.66-1.14,6-.92a4.5,4.5,0,0,1,.86,2.09c0,.38-.69,2.16-1,2.23s-5.22.33-5.53.31-.91,1.91-.91,1.91l-1.07,0Z",
    style: {
      fill: "#020100",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.1,432.71c-10.91.13-54,.55-56.88.6-1.25,0-6.73-7.89-7.31-8.92-.39-.71-1.07-5.71-1.3-9.28.64,1.06,4.84,7.95,8.32,9.39,3.77,1.56,14.22,4.28,24.95,5.13C202.1,430.45,222.24,432.52,224.1,432.71Z",
    style: {
      fill: "#020100",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.51 423.36 158.53 424.65 158.53 421.69 232.51 420.4 232.51 423.36",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.23 430.43 182.56 430.84 182.56 425.62 206.23 425.21 206.23 430.43",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.59,410.38a27.23,27.23,0,0,0-1,4.2,24.65,24.65,0,0,0,.52,4l68.57-1.2s.52-3.66.52-4.47a22.85,22.85,0,0,0-1-3.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.49 410.98 195.37 410.34 228.25 409.83 195.37 410.47 162.49 410.98",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.49 411.67 195.37 411.03 228.25 410.52 195.37 411.16 162.49 411.67",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.49 412.37 195.37 411.73 228.25 411.22 195.37 411.86 162.49 412.37",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.97 413.07 195.37 412.43 228.77 411.91 195.37 412.56 161.97 413.07",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.45 413.78 195.37 413.12 229.29 412.6 195.37 413.25 161.45 413.78",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.45 414.48 195.37 413.82 229.29 413.29 195.37 413.95 161.45 414.48",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.45 415.17 195.37 414.51 229.29 413.99 195.37 414.64 161.45 415.17",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.97 415.86 195.37 415.21 228.77 414.69 195.37 415.34 161.97 415.86",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.49 416.55 195.37 415.91 228.25 415.4 195.37 416.04 162.49 416.55",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.49 417.24 195.37 416.6 228.25 416.09 195.37 416.73 162.49 417.24",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.49 417.94 195.37 417.3 228.25 416.79 195.37 417.43 162.49 417.94",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.37,414.3a4.54,4.54,0,0,1-4.44,4.52,4.35,4.35,0,0,1-4.44-4.36,4.54,4.54,0,0,1,4.44-4.52A4.35,4.35,0,0,1,171.37,414.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.68,413.3a4.54,4.54,0,0,1-4.44,4.52,4.34,4.34,0,0,1-4.43-4.36,4.53,4.53,0,0,1,4.43-4.52A4.35,4.35,0,0,1,228.68,413.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.89,413.86a2.22,2.22,0,0,1-2.17,2.21,2.14,2.14,0,0,1-2.18-2.14,2.22,2.22,0,0,1,2.18-2.21A2.13,2.13,0,0,1,196.89,413.86Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.51 409.15 267.98 404.76 267.98 404.05 232.51 408.25 232.51 409.15",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.39 423.3 247.35 422.65 259.55 420.8 259.31 421.58 247.39 423.3",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Snow--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.79,282a4.24,4.24,0,0,1-1.24,7.46,2.82,2.82,0,0,1-1.72.05h0a4.15,4.15,0,0,1-4-5.39A4.5,4.5,0,0,1,392.79,282Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.79,282a4.61,4.61,0,0,1,1.58,2.23,4.38,4.38,0,0,1,0,2.77,4.31,4.31,0,0,1-1.74,2.23,3.72,3.72,0,0,1-.64.36,3.89,3.89,0,0,1-.7.26,3.13,3.13,0,0,1-1.52,0h.12a4.15,4.15,0,0,1-3.85-1.91,4.51,4.51,0,0,1-.37-4.24,4.42,4.42,0,0,1,3.22-2.57A4.86,4.86,0,0,1,392.79,282Zm0,0a4.45,4.45,0,0,0-3.89-.72,4.09,4.09,0,0,0-2.8,2.6,4.19,4.19,0,0,0,.52,3.66,3.64,3.64,0,0,0,3.19,1.63h.11a2.66,2.66,0,0,0,1.22.09,3,3,0,0,0,.61-.18,3.15,3.15,0,0,0,.59-.27,3.9,3.9,0,0,0,1.75-1.92,4,4,0,0,0,.21-2.65A4.24,4.24,0,0,0,392.79,282Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.61,205.34a4.24,4.24,0,0,1-1.24,7.46,2.82,2.82,0,0,1-1.72,0h0a4.15,4.15,0,0,1-4-5.39A4.5,4.5,0,0,1,301.61,205.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.61,205.34a4.61,4.61,0,0,1,1.58,2.23,4.38,4.38,0,0,1,0,2.77,4.26,4.26,0,0,1-1.74,2.23,3.38,3.38,0,0,1-.64.36,3.89,3.89,0,0,1-.7.26,3.13,3.13,0,0,1-1.52,0h.11a4.15,4.15,0,0,1-3.84-1.91,4.48,4.48,0,0,1-.36-4.24,4.38,4.38,0,0,1,3.21-2.57A4.86,4.86,0,0,1,301.61,205.34Zm0,0a4.45,4.45,0,0,0-3.89-.72,4.09,4.09,0,0,0-2.8,2.6,4.19,4.19,0,0,0,.52,3.66,3.64,3.64,0,0,0,3.2,1.63h.1a2.6,2.6,0,0,0,1.83-.09,3.15,3.15,0,0,0,.59-.27,4.06,4.06,0,0,0,2-4.57A4.18,4.18,0,0,0,301.61,205.34Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.86,380.88c0,3.34-5.2,3.35-5.2,0S63.86,377.53,63.86,380.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.86,380.88a2.61,2.61,0,0,1-.72,1.85,2.88,2.88,0,0,1-1.88.85,3,3,0,0,1-2.07-.65,2.78,2.78,0,0,1,0-4.1,3,3,0,0,1,2.07-.65,2.9,2.9,0,0,1,1.89.84A2.69,2.69,0,0,1,63.86,380.88Zm0,0a2.35,2.35,0,0,0-.79-1.78,2.54,2.54,0,0,0-1.81-.54,2.46,2.46,0,0,0-1.63.74,2.38,2.38,0,0,0,0,3.16,2.44,2.44,0,0,0,1.63.74,2.54,2.54,0,0,0,1.81-.54A2.35,2.35,0,0,0,63.86,380.88Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.12,57.05a4.25,4.25,0,0,1,7.51.92,2.75,2.75,0,0,1,.12,1.71s0,0,0,0A4.14,4.14,0,0,1,407.55,64,4.51,4.51,0,0,1,405.12,57.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.12,57.05a4.59,4.59,0,0,1,2.16-1.68,4.37,4.37,0,0,1,2.77-.08,4.28,4.28,0,0,1,2.31,1.64,4,4,0,0,1,.38.62,3,3,0,0,1,.29.69,3,3,0,0,1,.05,1.52v-.12a4.12,4.12,0,0,1-1.74,3.92,4.47,4.47,0,0,1-4.22.55,4.39,4.39,0,0,1-2.7-3.1A4.81,4.81,0,0,1,405.12,57.05Zm0,0a4.48,4.48,0,0,0-.55,3.92,4.08,4.08,0,0,0,2.72,2.68,4.18,4.18,0,0,0,3.63-.67,3.68,3.68,0,0,0,1.5-3.27V59.6a2.52,2.52,0,0,0,0-1.22,2.35,2.35,0,0,0-.2-.6,2.66,2.66,0,0,0-.3-.58,3.88,3.88,0,0,0-2-1.66,3.92,3.92,0,0,0-2.66-.1A4.31,4.31,0,0,0,405.12,57.05Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.18,162.46a4.25,4.25,0,0,1,7.52.92,2.82,2.82,0,0,1,.11,1.71.06.06,0,0,1,0,0,4.14,4.14,0,0,1-5.21,4.27A4.51,4.51,0,0,1,425.18,162.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.18,162.46a4.57,4.57,0,0,1,2.16-1.67,4.3,4.3,0,0,1,2.77-.09,4.25,4.25,0,0,1,2.31,1.64,4,4,0,0,1,.38.62,2.8,2.8,0,0,1,.29.69,3,3,0,0,1,.05,1.52v-.11a4.11,4.11,0,0,1-1.74,3.91,4.45,4.45,0,0,1-4.21.55,4.38,4.38,0,0,1-2.71-3.1A4.82,4.82,0,0,1,425.18,162.46Zm0,0a4.48,4.48,0,0,0-.55,3.92,4.08,4.08,0,0,0,2.72,2.68,4.18,4.18,0,0,0,3.63-.67,3.67,3.67,0,0,0,1.5-3.27V165a2.65,2.65,0,0,0,0-1.22,2.86,2.86,0,0,0-.21-.6,3.49,3.49,0,0,0-.29-.58,3.94,3.94,0,0,0-2-1.66,3.89,3.89,0,0,0-2.65-.1A4.3,4.3,0,0,0,425.18,162.46Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.49,128.46a4.25,4.25,0,0,1,7.51.92,2.86,2.86,0,0,1,.12,1.72s0,0,0,0a4.14,4.14,0,0,1-5.21,4.27A4.5,4.5,0,0,1,54.49,128.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.49,128.46a4.59,4.59,0,0,1,2.16-1.67,4.44,4.44,0,0,1,2.77-.09,4.34,4.34,0,0,1,2.31,1.65,3.21,3.21,0,0,1,.38.62,3.48,3.48,0,0,1,.29.68,3,3,0,0,1,.05,1.52v-.11A4.12,4.12,0,0,1,60.72,135a4.52,4.52,0,0,1-4.22.55,4.4,4.4,0,0,1-2.71-3.1A4.88,4.88,0,0,1,54.49,128.46Zm0,0a4.47,4.47,0,0,0-.55,3.93,4.08,4.08,0,0,0,2.72,2.68,4.19,4.19,0,0,0,3.63-.68,3.64,3.64,0,0,0,1.49-3.26V131a2.65,2.65,0,0,0,0-1.22,2.82,2.82,0,0,0-.2-.6,2.89,2.89,0,0,0-.3-.58,3.9,3.9,0,0,0-2-1.67,4,4,0,0,0-2.66-.09A4.25,4.25,0,0,0,54.49,128.46Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.8,73.5c3.34-.15,3.57,5,.23,5.19S444.45,73.64,447.8,73.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.8,73.5a2.68,2.68,0,0,1,1.89.63,2.91,2.91,0,0,1,.92,1.85,2.94,2.94,0,0,1-.56,2.1,2.72,2.72,0,0,1-2,1,2.75,2.75,0,0,1-2.09-.82,3,3,0,0,1-.73-2,2.86,2.86,0,0,1,.76-1.92A2.62,2.62,0,0,1,447.8,73.5Zm0,0a2.35,2.35,0,0,0-1.74.86,2.59,2.59,0,0,0-.47,1.84,2.46,2.46,0,0,0,.82,1.59,2.24,2.24,0,0,0,1.6.53,2.26,2.26,0,0,0,1.55-.66,2.52,2.52,0,0,0,.68-1.66,2.59,2.59,0,0,0-.63-1.79A2.32,2.32,0,0,0,447.8,73.5Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.67,150c3.34-.14,3.57,5.05.22,5.2S344.32,150.19,347.67,150Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.67,150a2.62,2.62,0,0,1,1.88.64,2.82,2.82,0,0,1,.92,1.84,2.93,2.93,0,0,1-.55,2.1,2.79,2.79,0,0,1-4.1.18,3,3,0,0,1,0-4A2.69,2.69,0,0,1,347.67,150Zm0,0a2.36,2.36,0,0,0-1.75.86,2.59,2.59,0,0,0-.46,1.84,2.45,2.45,0,0,0,.81,1.59,2.4,2.4,0,0,0,3.16-.13,2.49,2.49,0,0,0,.67-1.66,2.58,2.58,0,0,0-.62-1.79A2.34,2.34,0,0,0,347.67,150Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,50.1c3.35-.14,3.58,5,.23,5.2S211.65,50.25,215,50.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,50.1a2.63,2.63,0,0,1,1.89.64,2.86,2.86,0,0,1,.92,1.84,2.93,2.93,0,0,1-.55,2.1,2.79,2.79,0,0,1-4.1.18,2.93,2.93,0,0,1-.74-2,2.82,2.82,0,0,1,.76-1.92A2.63,2.63,0,0,1,215,50.1Zm0,0a2.35,2.35,0,0,0-1.74.86,2.54,2.54,0,0,0-.46,1.84,2.45,2.45,0,0,0,.81,1.59,2.25,2.25,0,0,0,1.6.53,2.29,2.29,0,0,0,1.56-.66,2.49,2.49,0,0,0,.67-1.66,2.59,2.59,0,0,0-.63-1.79A2.31,2.31,0,0,0,215,50.1Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.39,171.11c3.34-.15,3.57,5,.23,5.19S154,171.25,157.39,171.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.39,171.11a2.64,2.64,0,0,1,1.88.63,3,3,0,0,1,.37,3.94,2.77,2.77,0,0,1-4.1.18,2.92,2.92,0,0,1-.73-2,2.86,2.86,0,0,1,.76-1.92A2.62,2.62,0,0,1,157.39,171.11Zm0,0a2.35,2.35,0,0,0-1.74.86,2.59,2.59,0,0,0-.47,1.84,2.49,2.49,0,0,0,.82,1.59,2.22,2.22,0,0,0,1.6.53,2.26,2.26,0,0,0,1.55-.66,2.47,2.47,0,0,0,.67-1.67,2.51,2.51,0,0,0-.62-1.78A2.34,2.34,0,0,0,157.39,171.11Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.58,304.69c0,3.34-5.2,3.35-5.2,0S376.58,301.34,376.58,304.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.58,304.69a2.65,2.65,0,0,1-.71,1.85,2.88,2.88,0,0,1-1.89.85,3,3,0,0,1-2.07-.65,2.78,2.78,0,0,1,0-4.1A3,3,0,0,1,374,302a2.9,2.9,0,0,1,1.89.84A2.69,2.69,0,0,1,376.58,304.69Zm0,0a2.35,2.35,0,0,0-.79-1.78,2.53,2.53,0,0,0-1.81-.54,2.46,2.46,0,0,0-1.63.74,2.41,2.41,0,0,0,0,3.16A2.44,2.44,0,0,0,374,307a2.53,2.53,0,0,0,1.81-.54A2.35,2.35,0,0,0,376.58,304.69Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.21,399.34c0,3.34-5.19,3.35-5.19,0S433.21,396,433.21,399.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.21,399.34a2.61,2.61,0,0,1-.71,1.85,2.85,2.85,0,0,1-1.89.84,2.91,2.91,0,0,1-2.07-.64,2.8,2.8,0,0,1,0-4.11,3,3,0,0,1,2.07-.64,2.85,2.85,0,0,1,1.89.84A2.63,2.63,0,0,1,433.21,399.34Zm0,0a2.34,2.34,0,0,0-.78-1.78,2.57,2.57,0,0,0-1.81-.55,2.47,2.47,0,0,0-1.63.75,2.21,2.21,0,0,0-.6,1.58,2.26,2.26,0,0,0,.59,1.58,2.46,2.46,0,0,0,1.63.74,2.62,2.62,0,0,0,1.82-.54A2.38,2.38,0,0,0,433.21,399.34Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.34,343.8c0,3.34-5.2,3.35-5.2,0S457.34,340.45,457.34,343.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.34,343.8a2.61,2.61,0,0,1-.72,1.85,2.91,2.91,0,0,1-1.88.85,3,3,0,0,1-2.07-.65,2.76,2.76,0,0,1,0-4.1,2.9,2.9,0,0,1,2.07-.65,2.83,2.83,0,0,1,1.88.84A2.66,2.66,0,0,1,457.34,343.8Zm0,0a2.32,2.32,0,0,0-.79-1.78,2.54,2.54,0,0,0-1.81-.54,2.44,2.44,0,0,0-1.63.74,2.3,2.3,0,0,0-.6,1.58,2.27,2.27,0,0,0,.6,1.58,2.41,2.41,0,0,0,1.63.74,2.54,2.54,0,0,0,1.81-.54A2.35,2.35,0,0,0,457.34,343.8Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.2,393.15c-.67-3.28,4.42-4.33,5.09-1S356.87,396.43,356.2,393.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.2,393.15a2.6,2.6,0,0,1,.33-2,2.89,2.89,0,0,1,1.68-1.21,2.94,2.94,0,0,1,2.15.22,2.77,2.77,0,0,1,.82,4,2.9,2.9,0,0,1-1.89,1,2.85,2.85,0,0,1-2-.45A2.62,2.62,0,0,1,356.2,393.15Zm0,0a2.35,2.35,0,0,0,1.12,1.58,2.54,2.54,0,0,0,1.89.17,2.5,2.5,0,0,0,1.45-1,2.39,2.39,0,0,0-.63-3.1,2.5,2.5,0,0,0-1.75-.4,2.58,2.58,0,0,0-1.67.9A2.36,2.36,0,0,0,356.2,393.15Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.72,179c-.67-3.27,4.43-4.32,5.1-1S43.39,182.33,42.72,179Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.72,179a2.66,2.66,0,0,1,.33-2,2.92,2.92,0,0,1,1.68-1.2,3,3,0,0,1,2.16.22,2.73,2.73,0,0,1,1.29,1.83,2.68,2.68,0,0,1-.47,2.19,2.94,2.94,0,0,1-1.9,1,2.85,2.85,0,0,1-2-.45A2.7,2.7,0,0,1,42.72,179Zm0,0a2.36,2.36,0,0,0,1.13,1.59,2.57,2.57,0,0,0,1.88.17,2.47,2.47,0,0,0,1.45-1.05,2.31,2.31,0,0,0,.27-1.67,2.26,2.26,0,0,0-.9-1.43,2.42,2.42,0,0,0-1.74-.4,2.56,2.56,0,0,0-1.67.89A2.37,2.37,0,0,0,42.72,179Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.11,370.29a1.49,1.49,0,0,1,2.92-.59A1.49,1.49,0,0,1,342.11,370.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.11,370.29a1.61,1.61,0,0,1,1.13-1.89,1.77,1.77,0,0,1,1.33.09,1.67,1.67,0,0,1,.83,1.13,1.65,1.65,0,0,1-.32,1.37,1.76,1.76,0,0,1-1.18.6A1.61,1.61,0,0,1,342.11,370.29Zm0,0a1.24,1.24,0,0,0,.66.89,1.37,1.37,0,0,0,1.05,0,1.27,1.27,0,0,0,.73-.6,1.31,1.31,0,0,0-.32-1.58,1.26,1.26,0,0,0-.91-.27,1.36,1.36,0,0,0-1,.45A1.27,1.27,0,0,0,342.11,370.29Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.88,79a1.49,1.49,0,0,1,2.92-.59A1.49,1.49,0,0,1,140.88,79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.88,79A1.61,1.61,0,0,1,142,77.1a1.77,1.77,0,0,1,1.33.09,1.7,1.7,0,0,1,.51,2.5,1.74,1.74,0,0,1-1.19.6A1.6,1.6,0,0,1,140.88,79Zm0,0a1.29,1.29,0,0,0,.65.9,1.39,1.39,0,0,0,1.06,0,1.3,1.3,0,0,0,.73-.6,1.23,1.23,0,0,0,.11-.85,1.19,1.19,0,0,0-.43-.73,1.28,1.28,0,0,0-.91-.27,1.36,1.36,0,0,0-1,.45A1.27,1.27,0,0,0,140.88,79Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.39,167.81a1.49,1.49,0,0,1,2.92-.59A1.49,1.49,0,0,1,361.39,167.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.39,167.81a1.61,1.61,0,0,1,1.14-1.89,1.74,1.74,0,0,1,1.32.09,1.67,1.67,0,0,1,.83,1.13,1.65,1.65,0,0,1-.32,1.37,1.72,1.72,0,0,1-1.18.6A1.6,1.6,0,0,1,361.39,167.81Zm0,0a1.31,1.31,0,0,0,.66.9,1.37,1.37,0,0,0,1.05,0,1.27,1.27,0,0,0,.73-.6,1.18,1.18,0,0,0,.11-.85,1.19,1.19,0,0,0-.43-.73,1.26,1.26,0,0,0-.91-.27,1.4,1.4,0,0,0-1,.45A1.27,1.27,0,0,0,361.39,167.81Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.71,407.24a1.49,1.49,0,0,1,2.92-.6A1.49,1.49,0,0,1,180.71,407.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.71,407.24a1.61,1.61,0,0,1,1.13-1.89,1.81,1.81,0,0,1,1.33.08,1.69,1.69,0,0,1,.51,2.51,1.76,1.76,0,0,1-1.19.6A1.61,1.61,0,0,1,180.71,407.24Zm0,0a1.26,1.26,0,0,0,.65.89,1.44,1.44,0,0,0,1.06,0,1.28,1.28,0,0,0,.73-.61,1.21,1.21,0,0,0,.11-.84,1.25,1.25,0,0,0-.43-.74,1.37,1.37,0,0,0-.91-.27,1.44,1.44,0,0,0-1,.45A1.3,1.3,0,0,0,180.71,407.24Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.92,225.46a1.5,1.5,0,0,1-3,0A1.5,1.5,0,0,1,451.92,225.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.92,225.46a1.63,1.63,0,0,1-1.49,1.63,1.78,1.78,0,0,1-1.28-.35,1.7,1.7,0,0,1-.59-1.28,1.67,1.67,0,0,1,.58-1.28,1.82,1.82,0,0,1,1.29-.35A1.62,1.62,0,0,1,451.92,225.46Zm0,0a1.28,1.28,0,0,0-.47-1,1.36,1.36,0,0,0-1-.25,1.3,1.3,0,0,0-.84.44,1.33,1.33,0,0,0,0,1.62,1.3,1.3,0,0,0,.85.44,1.36,1.36,0,0,0,1-.25A1.28,1.28,0,0,0,451.92,225.46Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.11,227.46a1.49,1.49,0,0,1-3,0A1.49,1.49,0,0,1,339.11,227.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.11,227.46a1.62,1.62,0,0,1-1.49,1.63,1.78,1.78,0,0,1-1.28-.35,1.67,1.67,0,0,1-.59-1.28,1.7,1.7,0,0,1,.59-1.28,1.8,1.8,0,0,1,1.28-.35A1.62,1.62,0,0,1,339.11,227.46Zm0,0a1.3,1.3,0,0,0-.46-1,1.43,1.43,0,0,0-1-.25,1.27,1.27,0,0,0-.84.45,1.3,1.3,0,0,0,0,1.61,1.31,1.31,0,0,0,.84.45,1.48,1.48,0,0,0,1-.25A1.3,1.3,0,0,0,339.11,227.46Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.42,130.18a1.49,1.49,0,0,1-3,0A1.49,1.49,0,0,1,240.42,130.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.42,130.18a1.62,1.62,0,0,1-1.49,1.63,1.78,1.78,0,0,1-1.28-.35,1.67,1.67,0,0,1-.59-1.28,1.7,1.7,0,0,1,.59-1.28,1.78,1.78,0,0,1,1.28-.35A1.63,1.63,0,0,1,240.42,130.18Zm0,0a1.31,1.31,0,0,0-.47-1,1.4,1.4,0,0,0-1-.25,1.27,1.27,0,0,0-.84.45,1.18,1.18,0,0,0-.28.8,1.28,1.28,0,0,0,.27.81,1.36,1.36,0,0,0,.85.45,1.45,1.45,0,0,0,1-.25A1.31,1.31,0,0,0,240.42,130.18Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.28,129.79a4.25,4.25,0,0,1,7.1-2.63,2.84,2.84,0,0,1,.89,1.46l0,0a4.15,4.15,0,0,1-2.67,6.19A4.51,4.51,0,0,1,191.28,129.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.28,129.79a4.63,4.63,0,0,1,1.15-2.48,4.44,4.44,0,0,1,2.42-1.35,4.3,4.3,0,0,1,2.81.4,3.55,3.55,0,0,1,.62.38,3.62,3.62,0,0,1,.58.47,3.13,3.13,0,0,1,.74,1.33l0-.1a4.14,4.14,0,0,1,.25,4.28,4.49,4.49,0,0,1-3.49,2.42,4.39,4.39,0,0,1-3.83-1.51A4.85,4.85,0,0,1,191.28,129.79Zm0,0a4.47,4.47,0,0,0,1.32,3.74,4.06,4.06,0,0,0,3.64,1.13,4.18,4.18,0,0,0,2.92-2.27,3.66,3.66,0,0,0-.17-3.58l0-.05v0a2.62,2.62,0,0,0-.53-1.1,3.21,3.21,0,0,0-.46-.44,2.85,2.85,0,0,0-.53-.38,3.92,3.92,0,0,0-2.53-.57,4,4,0,0,0-2.41,1.14A4.35,4.35,0,0,0,191.28,129.79Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.53,338.94a4.26,4.26,0,0,1,7.1-2.64,2.86,2.86,0,0,1,.89,1.47l0,0a4.16,4.16,0,0,1-2.67,6.19A4.51,4.51,0,0,1,100.53,338.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.53,338.94a4.63,4.63,0,0,1,1.15-2.48,4.39,4.39,0,0,1,5.23-.95,3,3,0,0,1,.62.38,3,3,0,0,1,1.32,1.8l0-.1a4.13,4.13,0,0,1,.25,4.27,4.5,4.5,0,0,1-3.49,2.43,4.39,4.39,0,0,1-3.83-1.51A4.87,4.87,0,0,1,100.53,338.94Zm0,0a4.45,4.45,0,0,0,1.32,3.73,4.07,4.07,0,0,0,3.64,1.14,4.2,4.2,0,0,0,2.92-2.27,3.65,3.65,0,0,0-.18-3.59l0-.05v0a2.64,2.64,0,0,0-.53-1.09,2.8,2.8,0,0,0-.46-.45,3.39,3.39,0,0,0-.53-.38,4.06,4.06,0,0,0-4.94.58A4.32,4.32,0,0,0,100.53,338.94Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.2,267.45c2.9-1.66,5.49,2.85,2.59,4.51S242.29,269.12,245.2,267.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.2,267.45a2.63,2.63,0,0,1,2-.3,2.81,2.81,0,0,1,1.67,1.22,2.91,2.91,0,0,1,.47,2.11,2.77,2.77,0,0,1-3.56,2,2.91,2.91,0,0,1-1.59-1.47A2.84,2.84,0,0,1,244,269,2.63,2.63,0,0,1,245.2,267.45Zm0,0a2.35,2.35,0,0,0-1.15,1.57,2.63,2.63,0,0,0,1.88,2.89,2.29,2.29,0,0,0,1.67-.27,2.34,2.34,0,0,0,1.08-1.3,2.49,2.49,0,0,0-.17-1.79,2.55,2.55,0,0,0-1.38-1.3A2.35,2.35,0,0,0,245.2,267.45Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.66,291a1.49,1.49,0,0,1,1.48,2.58A1.49,1.49,0,0,1,293.66,291Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.66,291a1.6,1.6,0,0,1,2.15.48,1.79,1.79,0,0,1,.34,1.29,1.7,1.7,0,0,1-2.22,1.27,1.76,1.76,0,0,1-.94-.94A1.61,1.61,0,0,1,293.66,291Zm0,0a1.28,1.28,0,0,0-.64.9,1.38,1.38,0,0,0,.3,1,1.31,1.31,0,0,0,.8.51,1.31,1.31,0,0,0,1.4-.8,1.31,1.31,0,0,0,0-.95,1.41,1.41,0,0,0-.73-.77A1.26,1.26,0,0,0,293.66,291Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.92,234c2.18-1.26,4.13,2.13,2,3.39S165.74,235.21,167.92,234Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.92,234a2,2,0,0,1,1.48-.24,2.17,2.17,0,0,1,1.29.9,2.24,2.24,0,0,1,.4,1.63,2.16,2.16,0,0,1-2.78,1.6,2.29,2.29,0,0,1-1.22-1.17,2.2,2.2,0,0,1-.12-1.57A2,2,0,0,1,167.92,234Zm0,0a1.71,1.71,0,0,0-.85,1.18,1.86,1.86,0,0,0,.35,1.36,1.79,1.79,0,0,0,1.08.73,1.78,1.78,0,0,0,2-1.12,1.87,1.87,0,0,0-.09-1.31,1.93,1.93,0,0,0-1-1A1.73,1.73,0,0,0,167.92,234Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.2,328.67c2.18-1.25,4.13,2.14,2,3.4S132,329.93,134.2,328.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.2,328.67a2.06,2.06,0,0,1,1.48-.24,2.31,2.31,0,0,1,1.68,2.54,2.14,2.14,0,0,1-2.78,1.59,2.25,2.25,0,0,1-1.21-1.16,2.2,2.2,0,0,1-.12-1.57A2.06,2.06,0,0,1,134.2,328.67Zm0,0a1.73,1.73,0,0,0-.85,1.18,1.85,1.85,0,0,0,.35,1.36,1.81,1.81,0,0,0,1.08.74,1.77,1.77,0,0,0,2-1.13,1.85,1.85,0,0,0-.09-1.3,1.93,1.93,0,0,0-1-1A1.77,1.77,0,0,0,134.2,328.67Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.38,78.7c0,2.51-3.91,2.52-3.91,0S321.38,76.18,321.38,78.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.38,78.7a2,2,0,0,1-.53,1.4,2.14,2.14,0,0,1-1.42.67,2.31,2.31,0,0,1-1.62-.47,2.17,2.17,0,0,1,0-3.21,2.31,2.31,0,0,1,1.62-.47,2.19,2.19,0,0,1,1.42.67A2,2,0,0,1,321.38,78.7Zm0,0a1.74,1.74,0,0,0-.6-1.33,1.85,1.85,0,0,0-1.35-.37,1.77,1.77,0,0,0-1.17.57,1.62,1.62,0,0,0-.41,1.13,1.65,1.65,0,0,0,.4,1.13,1.86,1.86,0,0,0,1.18.57,1.91,1.91,0,0,0,1.35-.38A1.73,1.73,0,0,0,321.38,78.7Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.12,275.47a2,2,0,0,1-3.9,0C107.22,273,111.12,273,111.12,275.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.12,275.47a2,2,0,0,1-.52,1.41,2.29,2.29,0,0,1-3,.19,2.14,2.14,0,0,1,0-3.2,2.2,2.2,0,0,1,1.61-.47,2.17,2.17,0,0,1,1.43.67A2,2,0,0,1,111.12,275.47Zm0,0a1.74,1.74,0,0,0-.59-1.33,1.93,1.93,0,0,0-1.36-.37,1.81,1.81,0,0,0-1.17.57,1.64,1.64,0,0,0-.41,1.13,1.62,1.62,0,0,0,.41,1.13,1.77,1.77,0,0,0,1.17.57,1.88,1.88,0,0,0,1.36-.37A1.73,1.73,0,0,0,111.12,275.47Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.29,208.38c0,2.52-3.91,2.52-3.91,0S330.29,205.86,330.29,208.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.29,208.38a2,2,0,0,1-.53,1.4,2.12,2.12,0,0,1-1.42.67,2.19,2.19,0,0,1-1.61-.47,2.14,2.14,0,0,1,0-3.2,2.24,2.24,0,0,1,1.61-.48,2.18,2.18,0,0,1,1.42.68A2,2,0,0,1,330.29,208.38Zm0,0a1.74,1.74,0,0,0-.6-1.33,1.89,1.89,0,0,0-1.35-.37,1.81,1.81,0,0,0-1.17.57,1.76,1.76,0,0,0,0,2.26,1.77,1.77,0,0,0,1.17.57,1.89,1.89,0,0,0,1.35-.37A1.74,1.74,0,0,0,330.29,208.38Z",
    style: {
      fill: "#c7c7c7"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinterRoad);
export default __webpack_public_path__ + "static/media/winter-road.4f6bafbae5699fcaa4c7e693bad8417e.svg";
export { ForwardRef as ReactComponent };